/* tslint:disable */
/* eslint-disable */
/**
 * Lifestack API (Staging)
 * This is the API documentation for Lifestack.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccountAuthAccessAliveGetRes
 */
export interface AccountAuthAccessAliveGetRes {
    /**
     * True when access token is valid
     * @type {boolean}
     * @memberof AccountAuthAccessAliveGetRes
     */
    'alive': boolean;
    /**
     * User ID from the token payload
     * @type {string}
     * @memberof AccountAuthAccessAliveGetRes
     */
    'userId'?: string;
    /**
     * Access token expiry (unix timestamp in seconds)
     * @type {number}
     * @memberof AccountAuthAccessAliveGetRes
     */
    'exp'?: number;
    /**
     * Access token issued-at (unix timestamp in seconds)
     * @type {number}
     * @memberof AccountAuthAccessAliveGetRes
     */
    'iat'?: number;
}
/**
 * 
 * @export
 * @interface AccountAuthGenerateJWTPostRes
 */
export interface AccountAuthGenerateJWTPostRes {
    /**
     * refresh token
     * @type {string}
     * @memberof AccountAuthGenerateJWTPostRes
     */
    'refreshToken': string;
    /**
     * access token
     * @type {string}
     * @memberof AccountAuthGenerateJWTPostRes
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @interface AccountAuthRefreshPostRes
 */
export interface AccountAuthRefreshPostRes {
    /**
     * access token
     * @type {string}
     * @memberof AccountAuthRefreshPostRes
     */
    'access': string;
}
/**
 * 
 * @export
 * @interface AccountAuthSignInPostReq
 */
export interface AccountAuthSignInPostReq {
    /**
     * 
     * @type {string}
     * @memberof AccountAuthSignInPostReq
     */
    'serverAuthCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountAuthSignInPostReq
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountAuthSignInPostReq
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountAuthSignInPostReq
     */
    'tokenExpiryDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountAuthSignInPostReq
     */
    'isNewTrialFlow'?: boolean;
    /**
     * FirestoreUser
     * @type {object}
     * @memberof AccountAuthSignInPostReq
     */
    'newUserInfo'?: object;
    /**
     * google scopes
     * @type {Array<string>}
     * @memberof AccountAuthSignInPostReq
     */
    'scopes'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AccountAuthSignInPostReq
     */
    'skipCalendarSync'?: boolean;
    /**
     * Authentication provider (e.g., google or apple)
     * @type {string}
     * @memberof AccountAuthSignInPostReq
     */
    'authProvider'?: string;
    /**
     * oauth generated client type (web, mobile, desktop)
     * @type {string}
     * @memberof AccountAuthSignInPostReq
     */
    'generatedClientType'?: string;
    /**
     * oauth redirect uri used for code exchange
     * @type {string}
     * @memberof AccountAuthSignInPostReq
     */
    'redirectUri'?: string;
    /**
     * PKCE code verifier used for code exchange
     * @type {string}
     * @memberof AccountAuthSignInPostReq
     */
    'codeVerifier'?: string;
}
/**
 * 
 * @export
 * @interface AccountAuthSignInPostRes
 */
export interface AccountAuthSignInPostRes {
    /**
     * User
     * @type {object}
     * @memberof AccountAuthSignInPostRes
     */
    'user': object;
    /**
     * refresh token
     * @type {string}
     * @memberof AccountAuthSignInPostRes
     */
    'refreshToken'?: string;
    /**
     * access token
     * @type {string}
     * @memberof AccountAuthSignInPostRes
     */
    'accessToken'?: string;
}
/**
 * 
 * @export
 * @interface AccountDevicesGetRes
 */
export interface AccountDevicesGetRes {
    /**
     * DevicePriorities
     * @type {object}
     * @memberof AccountDevicesGetRes
     */
    'sleepPriorities': object;
    /**
     * DevicePriorities
     * @type {object}
     * @memberof AccountDevicesGetRes
     */
    'stressPriorities': object;
    /**
     * Array<Device>
     * @type {Array<object>}
     * @memberof AccountDevicesGetRes
     */
    'devices': Array<object>;
    /**
     * Array of terraUserIds
     * @type {Array<string>}
     * @memberof AccountDevicesGetRes
     */
    'terraUserIds': Array<string>;
}
/**
 * 
 * @export
 * @interface AccountSubscriptionGetRes
 */
export interface AccountSubscriptionGetRes {
    /**
     * Subscriptions
     * @type {Array<object>}
     * @memberof AccountSubscriptionGetRes
     */
    'subscriptions': Array<object>;
    /**
     * Active subscription
     * @type {object}
     * @memberof AccountSubscriptionGetRes
     */
    'activeSubscription'?: object;
    /**
     * Has access
     * @type {boolean}
     * @memberof AccountSubscriptionGetRes
     */
    'hasAccess': boolean;
}
/**
 * 
 * @export
 * @interface AppleAuthCallbackReq
 */
export interface AppleAuthCallbackReq {
    /**
     * Authorization code from Apple
     * @type {string}
     * @memberof AppleAuthCallbackReq
     */
    'code'?: string;
    /**
     * Identity token (JWT) from Apple
     * @type {string}
     * @memberof AppleAuthCallbackReq
     */
    'id_token'?: string;
    /**
     * 
     * @type {AppleUser}
     * @memberof AppleAuthCallbackReq
     */
    'user'?: AppleUser;
    /**
     * State parameter for CSRF protection
     * @type {string}
     * @memberof AppleAuthCallbackReq
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface AppleCalendarSyncReq
 */
export interface AppleCalendarSyncReq {
    /**
     * User\'s email address
     * @type {string}
     * @memberof AppleCalendarSyncReq
     */
    'email'?: string;
    /**
     * User\'s metric ID
     * @type {string}
     * @memberof AppleCalendarSyncReq
     */
    'metricId'?: string;
    /**
     * User persona (optional)
     * @type {string}
     * @memberof AppleCalendarSyncReq
     */
    'userPersona'?: string;
    /**
     * Whether to sync deleted calendars (optional)
     * @type {boolean}
     * @memberof AppleCalendarSyncReq
     */
    'shouldSyncDeletedList'?: boolean;
    /**
     * Array of Apple calendars with events
     * @type {Array<object>}
     * @memberof AppleCalendarSyncReq
     */
    'appleCalendars'?: Array<object>;
}
/**
 * 
 * @export
 * @interface AppleRemindersSyncReq
 */
export interface AppleRemindersSyncReq {
    /**
     * 
     * @type {string}
     * @memberof AppleRemindersSyncReq
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof AppleRemindersSyncReq
     */
    'metricId': string;
    /**
     * 
     * @type {string}
     * @memberof AppleRemindersSyncReq
     */
    'userPersona'?: string;
    /**
     * Apple Reminder lists (maps to Todo boards)
     * @type {Array<object>}
     * @memberof AppleRemindersSyncReq
     */
    'lists': Array<object>;
    /**
     * Native Apple reminders array
     * @type {Array<object>}
     * @memberof AppleRemindersSyncReq
     */
    'reminders': Array<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppleRemindersSyncReq
     */
    'deletedReminderIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AppleUser
 */
export interface AppleUser {
    /**
     * User last name
     * @type {string}
     * @memberof AppleUser
     */
    'name'?: string;
    /**
     * User email
     * @type {string}
     * @memberof AppleUser
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface AvgEnergyDataTrendOfDayOfWeek
 */
export interface AvgEnergyDataTrendOfDayOfWeek {
    /**
     * 
     * @type {string}
     * @memberof AvgEnergyDataTrendOfDayOfWeek
     */
    'day': string;
    /**
     * 
     * @type {number}
     * @memberof AvgEnergyDataTrendOfDayOfWeek
     */
    'energy'?: number;
}
/**
 * 
 * @export
 * @interface CalcTimeFrame
 */
export interface CalcTimeFrame {
    /**
     * 
     * @type {number}
     * @memberof CalcTimeFrame
     */
    'deepworkDurationMin': number;
    /**
     * 
     * @type {number}
     * @memberof CalcTimeFrame
     */
    'breakDurationMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalcTimeFrame
     */
    'lunchDurationMin'?: number;
}
/**
 * 
 * @export
 * @interface CalendarAccess
 */
export interface CalendarAccess {
    /**
     * 
     * @type {boolean}
     * @memberof CalendarAccess
     */
    'calendarWrite'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarAccess
     */
    'calendarRead'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarAccess
     */
    'eventWrite'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarAccess
     */
    'eventRead'?: boolean;
}
/**
 * 
 * @export
 * @interface CalendarError401Res
 */
export interface CalendarError401Res {
    /**
     * error: {message}
     * @type {string}
     * @memberof CalendarError401Res
     */
    'error': string;
    /**
     * -
     * @type {string}
     * @memberof CalendarError401Res
     */
    'rootEmail'?: string;
}
/**
 * 
 * @export
 * @interface CalendarEventForEfficiency
 */
export interface CalendarEventForEfficiency {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventForEfficiency
     */
    'summary': string;
    /**
     * 
     * @type {object}
     * @memberof CalendarEventForEfficiency
     */
    'start': object;
    /**
     * 
     * @type {object}
     * @memberof CalendarEventForEfficiency
     */
    'end': object;
    /**
     * 
     * @type {Array<object>}
     * @memberof CalendarEventForEfficiency
     */
    'categories': Array<object>;
}
/**
 * 
 * @export
 * @interface CalendarEventLocationAutocompleteRes
 */
export interface CalendarEventLocationAutocompleteRes {
    /**
     * 
     * @type {Array<CalendarEventLocationSuggestion>}
     * @memberof CalendarEventLocationAutocompleteRes
     */
    'suggestions': Array<CalendarEventLocationSuggestion>;
}
/**
 * 
 * @export
 * @interface CalendarEventLocationSuggestion
 */
export interface CalendarEventLocationSuggestion {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventLocationSuggestion
     */
    'placeId': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventLocationSuggestion
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventLocationSuggestion
     */
    'subtitle': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventLocationSuggestion
     */
    'formattedText': string;
}
/**
 * 
 * @export
 * @interface CalendarEventPostReq
 */
export interface CalendarEventPostReq {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventPostReq
     */
    'taskId'?: string;
    /**
     * CalendarEventMetrics
     * @type {object}
     * @memberof CalendarEventPostReq
     */
    'metrics'?: object;
    /**
     * Partial<CalendarEvent>
     * @type {object}
     * @memberof CalendarEventPostReq
     */
    'newEventOption': object;
}
/**
 * 
 * @export
 * @interface CalendarEventRespondReq
 */
export interface CalendarEventRespondReq {
    /**
     * The attendee response for the current user. Allowed values: accepted, tentative, declined
     * @type {string}
     * @memberof CalendarEventRespondReq
     */
    'responseStatus': string;
    /**
     * Optional RSVP comment
     * @type {string}
     * @memberof CalendarEventRespondReq
     */
    'comment'?: string;
    /**
     * Whether the provider should notify the organizer. Defaults to true
     * @type {boolean}
     * @memberof CalendarEventRespondReq
     */
    'sendResponse'?: boolean;
}
/**
 * 
 * @export
 * @interface CalendarEventsSyncRes
 */
export interface CalendarEventsSyncRes {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventsSyncRes
     */
    'calendarId'?: string;
    /**
     * CalendarEvent[]
     * @type {Array<object>}
     * @memberof CalendarEventsSyncRes
     */
    'events'?: Array<object>;
}
/**
 * 
 * @export
 * @interface CalendarListSyncGCalReq
 */
export interface CalendarListSyncGCalReq {
    /**
     * Google refresh token
     * @type {string}
     * @memberof CalendarListSyncGCalReq
     */
    'refreshToken'?: string;
    /**
     * Google access token
     * @type {string}
     * @memberof CalendarListSyncGCalReq
     */
    'accessToken'?: string;
    /**
     * Google access token expiry date
     * @type {string}
     * @memberof CalendarListSyncGCalReq
     */
    'expiryDate'?: string;
    /**
     * version string
     * @type {string}
     * @memberof CalendarListSyncGCalReq
     */
    'version'?: string;
    /**
     * google scopes
     * @type {Array<string>}
     * @memberof CalendarListSyncGCalReq
     */
    'scopes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CalendarOutlookAuthTokenRes
 */
export interface CalendarOutlookAuthTokenRes {
    /**
     * Outlook refresh token
     * @type {string}
     * @memberof CalendarOutlookAuthTokenRes
     */
    'refreshToken'?: string;
    /**
     * Outlook access token
     * @type {string}
     * @memberof CalendarOutlookAuthTokenRes
     */
    'accessToken'?: string;
    /**
     * Outlook access token expiry date
     * @type {string}
     * @memberof CalendarOutlookAuthTokenRes
     */
    'expiryDate'?: string;
    /**
     * Outlook root email
     * @type {string}
     * @memberof CalendarOutlookAuthTokenRes
     */
    'rootEmail'?: string;
}
/**
 * 
 * @export
 * @interface CalendarSyncBody
 */
export interface CalendarSyncBody {
    /**
     * 
     * @type {string}
     * @memberof CalendarSyncBody
     */
    'userId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendarSyncBody
     */
    'calendarIds': Array<string>;
}
/**
 * 
 * @export
 * @interface CalendarWebhookSubscribeReq
 */
export interface CalendarWebhookSubscribeReq {
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendarWebhookSubscribeReq
     */
    'calendarIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CalendarWebhookSubscribeReq
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface CalendarWithAccess
 */
export interface CalendarWithAccess {
    /**
     * rootEmail
     * @type {string}
     * @memberof CalendarWithAccess
     */
    'rootEmail'?: string;
    /**
     * calendarType
     * @type {string}
     * @memberof CalendarWithAccess
     */
    'calendarType'?: string;
    /**
     * list of scopes
     * @type {Array<string>}
     * @memberof CalendarWithAccess
     */
    'scopes'?: Array<string>;
    /**
     * 
     * @type {CalendarAccess}
     * @memberof CalendarWithAccess
     */
    'access'?: CalendarAccess;
}
/**
 * 
 * @export
 * @interface ConvertedReferralCampaign
 */
export interface ConvertedReferralCampaign {
    /**
     * campaignId
     * @type {string}
     * @memberof ConvertedReferralCampaign
     */
    'campaignId': string;
    /**
     * rewardfulClientId
     * @type {string}
     * @memberof ConvertedReferralCampaign
     */
    'rewardfulClientId'?: string;
}
/**
 * 
 * @export
 * @interface CreateStripeCheckoutSessionParams
 */
export interface CreateStripeCheckoutSessionParams {
    /**
     * userId
     * @type {string}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'userId': string;
    /**
     * email
     * @type {string}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'email': string;
    /**
     * priceId
     * @type {string}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'priceId': string;
    /**
     * plan
     * @type {string}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'plan': string;
    /**
     * successUrl
     * @type {string}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'successUrl': string;
    /**
     * cancelUrl
     * @type {string}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'cancelUrl': string;
    /**
     * offeringId
     * @type {string}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'offeringId': string;
    /**
     * freeTrialDays
     * @type {number}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'freeTrialDays'?: number;
    /**
     * 
     * @type {ConvertedReferralCampaign}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'referral'?: ConvertedReferralCampaign;
    /**
     * Discount
     * @type {object}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'discount'?: object;
    /**
     * mode
     * @type {string}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'mode'?: string;
    /**
     * user expectations data
     * @type {string}
     * @memberof CreateStripeCheckoutSessionParams
     */
    'userExpectations'?: string;
}
/**
 * 
 * @export
 * @interface CreateStripeCheckoutSessionRes
 */
export interface CreateStripeCheckoutSessionRes {
    /**
     * Session ID
     * @type {string}
     * @memberof CreateStripeCheckoutSessionRes
     */
    'id': string;
    /**
     * Checkout URL
     * @type {string}
     * @memberof CreateStripeCheckoutSessionRes
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface CurrentLocation
 */
export interface CurrentLocation {
    /**
     * 
     * @type {number}
     * @memberof CurrentLocation
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocation
     */
    'lng': number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocation
     */
    'accuracy_m'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocation
     */
    'captured_at': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocation
     */
    'capturedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocation
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface DaySummary
 */
export interface DaySummary {
    /**
     * The date of the summary
     * @type {string}
     * @memberof DaySummary
     */
    'date'?: string;
    /**
     * 
     * @type {DaySummaryEnergy}
     * @memberof DaySummary
     */
    'energy'?: DaySummaryEnergy;
    /**
     * 
     * @type {DaySummaryTask}
     * @memberof DaySummary
     */
    'task'?: DaySummaryTask;
    /**
     * 
     * @type {DaySummaryEvent}
     * @memberof DaySummary
     */
    'event'?: DaySummaryEvent;
    /**
     * 
     * @type {DaySummarySchedule}
     * @memberof DaySummary
     */
    'schedule'?: DaySummarySchedule;
}
/**
 * 
 * @export
 * @interface DaySummaryEnergy
 */
export interface DaySummaryEnergy {
    /**
     * Peak energy level
     * @type {number}
     * @memberof DaySummaryEnergy
     */
    'peakEnergy'?: number;
    /**
     * Difference from average energy
     * @type {number}
     * @memberof DaySummaryEnergy
     */
    'energyDiffFromAvg'?: number;
}
/**
 * 
 * @export
 * @interface DaySummaryEvent
 */
export interface DaySummaryEvent {
    /**
     * Title of stressful event
     * @type {string}
     * @memberof DaySummaryEvent
     */
    'stressfulEvent'?: string;
    /**
     * Number of meetings
     * @type {number}
     * @memberof DaySummaryEvent
     */
    'meetingCount'?: number;
}
/**
 * 
 * @export
 * @interface DaySummarySchedule
 */
export interface DaySummarySchedule {
    /**
     * Total deep work minutes
     * @type {number}
     * @memberof DaySummarySchedule
     */
    'deepWorkMinutes'?: number;
}
/**
 * 
 * @export
 * @interface DaySummaryTask
 */
export interface DaySummaryTask {
    /**
     * Number of completed tasks
     * @type {number}
     * @memberof DaySummaryTask
     */
    'completedTasks'?: number;
    /**
     * Task completion percentage
     * @type {number}
     * @memberof DaySummaryTask
     */
    'completionPercentage'?: number;
}
/**
 * 
 * @export
 * @interface DeleteSchedulerRuleResponse
 */
export interface DeleteSchedulerRuleResponse {
    /**
     * 
     * @type {string}
     * @memberof DeleteSchedulerRuleResponse
     */
    'ruleId': string;
}
/**
 * 
 * @export
 * @interface EnergyCircadianGetRes
 */
export interface EnergyCircadianGetRes {
    /**
     * Circadian rhythm
     * @type {Array<object>}
     * @memberof EnergyCircadianGetRes
     */
    'circadian': Array<object>;
    /**
     * Fluctuations
     * @type {object}
     * @memberof EnergyCircadianGetRes
     */
    'fluctuations': object;
}
/**
 * 
 * @export
 * @interface EnergyDataTrendWeeklyRes
 */
export interface EnergyDataTrendWeeklyRes {
    /**
     * 
     * @type {string}
     * @memberof EnergyDataTrendWeeklyRes
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof EnergyDataTrendWeeklyRes
     */
    'endDate': string;
    /**
     * EnergyDataTrend[]
     * @type {object}
     * @memberof EnergyDataTrendWeeklyRes
     */
    'data': object;
    /**
     * 
     * @type {number}
     * @memberof EnergyDataTrendWeeklyRes
     */
    'avgPeakEnergy': number;
    /**
     * 
     * @type {AvgEnergyDataTrendOfDayOfWeek}
     * @memberof EnergyDataTrendWeeklyRes
     */
    'avgEnergyOfDaysOfWeek': AvgEnergyDataTrendOfDayOfWeek;
}
/**
 * 
 * @export
 * @interface ErrorRes
 */
export interface ErrorRes {
    /**
     * error: {message}
     * @type {string}
     * @memberof ErrorRes
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorRes
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface EventDataTrendWeeklyRes
 */
export interface EventDataTrendWeeklyRes {
    /**
     * 
     * @type {string}
     * @memberof EventDataTrendWeeklyRes
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof EventDataTrendWeeklyRes
     */
    'endDate': string;
    /**
     * EventDataTrendEventItemWithData
     * @type {object}
     * @memberof EventDataTrendWeeklyRes
     */
    'stressfulEvent'?: object;
    /**
     * EventDataTrendEventItemWithData
     * @type {object}
     * @memberof EventDataTrendWeeklyRes
     */
    'energyDrainingEvent'?: object;
    /**
     * EventDataTrendEventItemWithData
     * @type {object}
     * @memberof EventDataTrendWeeklyRes
     */
    'energyBoostingEvent'?: object;
}
/**
 * 
 * @export
 * @interface ExportLifestackCalendarBody
 */
export interface ExportLifestackCalendarBody {
    /**
     * 
     * @type {Array<ExportLifestackCalendarParam>}
     * @memberof ExportLifestackCalendarBody
     */
    'calendars': Array<ExportLifestackCalendarParam>;
}
/**
 * 
 * @export
 * @interface ExportLifestackCalendarParam
 */
export interface ExportLifestackCalendarParam {
    /**
     * 
     * @type {string}
     * @memberof ExportLifestackCalendarParam
     */
    'calendarType': string;
    /**
     * 
     * @type {string}
     * @memberof ExportLifestackCalendarParam
     */
    'rootEmail': string;
}
/**
 * 
 * @export
 * @interface GenerateReferralCodeGetRes
 */
export interface GenerateReferralCodeGetRes {
    /**
     * The generated referral code
     * @type {string}
     * @memberof GenerateReferralCodeGetRes
     */
    'referralCode': string;
    /**
     * The inviter email
     * @type {string}
     * @memberof GenerateReferralCodeGetRes
     */
    'inviterEmail'?: string;
    /**
     * The inviter name
     * @type {string}
     * @memberof GenerateReferralCodeGetRes
     */
    'inviterName'?: string;
}
/**
 * 
 * @export
 * @interface GetCalendlyAvailableSlotsRes
 */
export interface GetCalendlyAvailableSlotsRes {
    /**
     * Available time slots CalendlyAvailableTimeSlot
     * @type {Array<object>}
     * @memberof GetCalendlyAvailableSlotsRes
     */
    'slots'?: Array<object>;
    /**
     * Event type CalendlyEventType
     * @type {object}
     * @memberof GetCalendlyAvailableSlotsRes
     */
    'eventType'?: object;
}
/**
 * 
 * @export
 * @interface GetTerraUserStatusRes
 */
export interface GetTerraUserStatusRes {
    /**
     * 
     * @type {string}
     * @memberof GetTerraUserStatusRes
     */
    'terraUserId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTerraUserStatusRes
     */
    'valid': boolean;
    /**
     * -- TerraUserResponse
     * @type {object}
     * @memberof GetTerraUserStatusRes
     */
    'user': object;
}
/**
 * 
 * @export
 * @interface InitCalendlyBody
 */
export interface InitCalendlyBody {
    /**
     * Authorization code from Calendly
     * @type {string}
     * @memberof InitCalendlyBody
     */
    'code'?: string;
    /**
     * Code verifier from Calendly
     * @type {string}
     * @memberof InitCalendlyBody
     */
    'codeVerifier'?: string;
}
/**
 * 
 * @export
 * @interface InitCalendlyRes
 */
export interface InitCalendlyRes {
    /**
     * Calendly integration id
     * @type {string}
     * @memberof InitCalendlyRes
     */
    'calendlyIntegId'?: string;
}
/**
 * 
 * @export
 * @interface InitTodoPutReq
 */
export interface InitTodoPutReq {
    /**
     * 
     * @type {Array<string>}
     * @memberof InitTodoPutReq
     */
    'targetOriginalBoardIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface InitTodoPutRes
 */
export interface InitTodoPutRes {
    /**
     * 
     * @type {Array<string>}
     * @memberof InitTodoPutRes
     */
    'newTodoTasksBoardIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InitTodoPutRes
     */
    'newTodoIntegrationId': string;
}
/**
 * 
 * @export
 * @interface JobStatusEvent
 */
export interface JobStatusEvent {
    /**
     * SSE event type as originally emitted (e.g. sequence, result_json, plan_done, stream_end)
     * @type {string}
     * @memberof JobStatusEvent
     */
    'type': string;
    /**
     * Event payload, same shape as the corresponding SSE `data` field
     * @type {object}
     * @memberof JobStatusEvent
     */
    'data': object;
}
/**
 * 
 * @export
 * @interface JobStatusRes
 */
export interface JobStatusRes {
    /**
     * running | done | error
     * @type {string}
     * @memberof JobStatusRes
     */
    'status': string;
    /**
     * chat | daily_plan
     * @type {string}
     * @memberof JobStatusRes
     */
    'jobType': string;
    /**
     * 
     * @type {string}
     * @memberof JobStatusRes
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof JobStatusRes
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof JobStatusRes
     */
    'updatedAt': string;
    /**
     * All SSE events emitted so far, in order
     * @type {Array<JobStatusEvent>}
     * @memberof JobStatusRes
     */
    'events': Array<JobStatusEvent>;
    /**
     * 
     * @type {string}
     * @memberof JobStatusRes
     */
    'summary'?: string;
    /**
     * 
     * @type {object}
     * @memberof JobStatusRes
     */
    'resultJson'?: object;
    /**
     * 
     * @type {string}
     * @memberof JobStatusRes
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface MealContent
 */
export interface MealContent {
    /**
     * Short meal content title
     * @type {string}
     * @memberof MealContent
     */
    'title'?: string;
    /**
     * Brief rationale based on meal context/history
     * @type {string}
     * @memberof MealContent
     */
    'rationale'?: string;
    /**
     * Suggested meal items
     * @type {Array<MealContentItem>}
     * @memberof MealContent
     */
    'suggestedItems'?: Array<MealContentItem>;
    /**
     * Macro nutrient values
     * @type {object}
     * @memberof MealContent
     */
    'macros'?: object;
}
/**
 * 
 * @export
 * @interface MealContentItem
 */
export interface MealContentItem {
    /**
     * Food item name
     * @type {string}
     * @memberof MealContentItem
     */
    'name'?: string;
    /**
     * Suggested serving size
     * @type {string}
     * @memberof MealContentItem
     */
    'portion'?: string;
    /**
     * Why this item is suggested
     * @type {string}
     * @memberof MealContentItem
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface MealData
 */
export interface MealData {
    /**
     * 
     * @type {MealDataItem}
     * @memberof MealData
     */
    'breakfast'?: MealDataItem;
    /**
     * 
     * @type {MealDataItem}
     * @memberof MealData
     */
    'lunch'?: MealDataItem;
    /**
     * 
     * @type {MealDataItem}
     * @memberof MealData
     */
    'dinner'?: MealDataItem;
}
/**
 * 
 * @export
 * @interface MealDataItem
 */
export interface MealDataItem {
    /**
     * Start time of the meal
     * @type {string}
     * @memberof MealDataItem
     */
    'start'?: string;
    /**
     * End time of the meal
     * @type {string}
     * @memberof MealDataItem
     */
    'end'?: string;
    /**
     * Event reference ID
     * @type {string}
     * @memberof MealDataItem
     */
    'eventRef'?: string;
    /**
     * 
     * @type {MealContent}
     * @memberof MealDataItem
     */
    'content'?: MealContent;
    /**
     * Description of the meal
     * @type {string}
     * @memberof MealDataItem
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface MetricsWebhookTerraPutReq
 */
export interface MetricsWebhookTerraPutReq {
    /**
     * TerraUser
     * @type {object}
     * @memberof MetricsWebhookTerraPutReq
     */
    'user': object;
    /**
     * 
     * @type {string}
     * @memberof MetricsWebhookTerraPutReq
     */
    'type': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof MetricsWebhookTerraPutReq
     */
    'data': Array<object>;
}
/**
 * 
 * @export
 * @interface MoveTodoTaskBetweenProjectsReq
 */
export interface MoveTodoTaskBetweenProjectsReq {
    /**
     * 
     * @type {string}
     * @memberof MoveTodoTaskBetweenProjectsReq
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof MoveTodoTaskBetweenProjectsReq
     */
    'sourceBoardId': string;
    /**
     * 
     * @type {string}
     * @memberof MoveTodoTaskBetweenProjectsReq
     */
    'targetBoardId': string;
}
/**
 * 
 * @export
 * @interface MoveTodoTaskBetweenProjectsRes
 */
export interface MoveTodoTaskBetweenProjectsRes {
    /**
     * TaskItem
     * @type {object}
     * @memberof MoveTodoTaskBetweenProjectsRes
     */
    'task': object;
}
/**
 * Uncommitted suggest card still on the client\'s screen for this chat turn. Matches science `PendingItem` (`action_id` + `name` required). CamelCase aliases accepted.
 * @export
 * @interface PendingItem
 */
export interface PendingItem {
    /**
     * Client card id reused when revising this temporary event (alias: actionId)
     * @type {string}
     * @memberof PendingItem
     */
    'action_id': string;
    /**
     * Display name used to match the pending card
     * @type {string}
     * @memberof PendingItem
     */
    'name': string;
    /**
     * Time in HH:MM format, 24-hour (alias: startTime)
     * @type {string}
     * @memberof PendingItem
     */
    'start_time'?: string;
    /**
     * Time in HH:MM format, 24-hour (alias: endTime)
     * @type {string}
     * @memberof PendingItem
     */
    'end_time'?: string;
    /**
     * Optional origin hint: routine, todo, activity, … (alias: eventFrom)
     * @type {string}
     * @memberof PendingItem
     */
    'event_from'?: string;
    /**
     * Optional category hint for prompt context
     * @type {string}
     * @memberof PendingItem
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface QuickSuggestionEnergy
 */
export interface QuickSuggestionEnergy {
    /**
     * End time
     * @type {string}
     * @memberof QuickSuggestionEnergy
     */
    'end_time': string;
    /**
     * Phase category
     * @type {string}
     * @memberof QuickSuggestionEnergy
     */
    'phase_category': string;
    /**
     * Start time
     * @type {string}
     * @memberof QuickSuggestionEnergy
     */
    'start_time': string;
}
/**
 * 
 * @export
 * @interface QuickSuggestionRes
 */
export interface QuickSuggestionRes {
    /**
     * 
     * @type {QuickSuggestionEnergy}
     * @memberof QuickSuggestionRes
     */
    'currentEnergyZone': QuickSuggestionEnergy;
    /**
     * Summary
     * @type {string}
     * @memberof QuickSuggestionRes
     */
    'summary': string;
    /**
     * Top actions
     * @type {Array<QuickSuggestionTopAction>}
     * @memberof QuickSuggestionRes
     */
    'topActions': Array<QuickSuggestionTopAction>;
}
/**
 * 
 * @export
 * @interface QuickSuggestionTopAction
 */
export interface QuickSuggestionTopAction {
    /**
     * Action LLM text
     * @type {string}
     * @memberof QuickSuggestionTopAction
     */
    'actionLLMText': string;
    /**
     * Action name
     * @type {string}
     * @memberof QuickSuggestionTopAction
     */
    'actionName': string;
}
/**
 * 
 * @export
 * @interface RemoveCalendarsInfoBody
 */
export interface RemoveCalendarsInfoBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveCalendarsInfoBody
     */
    'calendarIds': Array<string>;
}
/**
 * 
 * @export
 * @interface RequestSubscriptionPostRes
 */
export interface RequestSubscriptionPostRes {
    /**
     * priceId
     * @type {string}
     * @memberof RequestSubscriptionPostRes
     */
    'priceId': string;
    /**
     * email
     * @type {string}
     * @memberof RequestSubscriptionPostRes
     */
    'email': string;
    /**
     * customerToken
     * @type {string}
     * @memberof RequestSubscriptionPostRes
     */
    'customerToken': string;
    /**
     * offeringId
     * @type {string}
     * @memberof RequestSubscriptionPostRes
     */
    'offeringId': string;
    /**
     * freeTrialDays
     * @type {number}
     * @memberof RequestSubscriptionPostRes
     */
    'freeTrialDays'?: number;
    /**
     * 
     * @type {ConvertedReferralCampaign}
     * @memberof RequestSubscriptionPostRes
     */
    'referral'?: ConvertedReferralCampaign;
    /**
     * Discount
     * @type {object}
     * @memberof RequestSubscriptionPostRes
     */
    'discount'?: object;
    /**
     * isRestored
     * @type {boolean}
     * @memberof RequestSubscriptionPostRes
     */
    'isRestored'?: boolean;
}
/**
 * 
 * @export
 * @interface RunAISchedulerV5Params
 */
export interface RunAISchedulerV5Params {
    /**
     * 
     * @type {string}
     * @memberof RunAISchedulerV5Params
     */
    'targetDate': string;
    /**
     * 
     * @type {string}
     * @memberof RunAISchedulerV5Params
     */
    'metricId': string;
    /**
     * 
     * @type {string}
     * @memberof RunAISchedulerV5Params
     */
    'preferencesId': string;
    /**
     * 
     * @type {string}
     * @memberof RunAISchedulerV5Params
     */
    'routineId': string;
    /**
     * -- TaskItemForSchedule[]
     * @type {Array<object>}
     * @memberof RunAISchedulerV5Params
     */
    'todos'?: Array<object>;
    /**
     * -- RoutineActivity[]
     * @type {Array<object>}
     * @memberof RunAISchedulerV5Params
     */
    'routine'?: Array<object>;
    /**
     * -- string
     * @type {string}
     * @memberof RunAISchedulerV5Params
     */
    'userMessage'?: string;
}
/**
 * 
 * @export
 * @interface RunAISchedulerV7Params
 */
export interface RunAISchedulerV7Params {
    /**
     * 
     * @type {string}
     * @memberof RunAISchedulerV7Params
     */
    'targetDate': string;
    /**
     * 
     * @type {string}
     * @memberof RunAISchedulerV7Params
     */
    'metricId': string;
    /**
     * 
     * @type {string}
     * @memberof RunAISchedulerV7Params
     */
    'preferencesId': string;
    /**
     * 
     * @type {string}
     * @memberof RunAISchedulerV7Params
     */
    'routineId': string;
    /**
     * 
     * @type {string}
     * @memberof RunAISchedulerV7Params
     */
    'userMessage'?: string;
    /**
     * -- AllPlanScheduleType[]
     * @type {Array<string>}
     * @memberof RunAISchedulerV7Params
     */
    'planTypes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RunAIWeekPlanParams
 */
export interface RunAIWeekPlanParams {
    /**
     * 
     * @type {string}
     * @memberof RunAIWeekPlanParams
     */
    'weekStart': string;
    /**
     * 
     * @type {number}
     * @memberof RunAIWeekPlanParams
     */
    'numDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof RunAIWeekPlanParams
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof RunAIWeekPlanParams
     */
    'metricId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RunAIWeekPlanParams
     */
    'preferencesId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RunAIWeekPlanParams
     */
    'routineId'?: string;
    /**
     * -- TaskItemForSchedule[]
     * @type {Array<object>}
     * @memberof RunAIWeekPlanParams
     */
    'todos'?: Array<object>;
    /**
     * -- RoutineActivity[]
     * @type {Array<object>}
     * @memberof RunAIWeekPlanParams
     */
    'routine'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof RunAIWeekPlanParams
     */
    'userMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof RunAIWeekPlanParams
     */
    'currentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RunAIWeekPlanParams
     */
    'currentTime'?: string;
    /**
     * -- idempotency key, only used by /week_plan/v2
     * @type {string}
     * @memberof RunAIWeekPlanParams
     */
    'jobId'?: string;
}
/**
 * 
 * @export
 * @interface SchedulerAIReplanSchedulerV5PutFormattedRes
 */
export interface SchedulerAIReplanSchedulerV5PutFormattedRes {
    /**
     * Array of {before?: ScheduledAction, after?: ScheduledAction}
     * @type {Array<object>}
     * @memberof SchedulerAIReplanSchedulerV5PutFormattedRes
     */
    'schedules': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAIReplanSchedulerV5PutFormattedRes
     */
    'scienceApiReq'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAIReplanSchedulerV5PutFormattedRes
     */
    'scienceApiRes'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAIReplanSchedulerV5PutFormattedRes
     */
    'summary'?: string;
}
/**
 * 
 * @export
 * @interface SchedulerAISchedulerV4PutFormattedRes
 */
export interface SchedulerAISchedulerV4PutFormattedRes {
    /**
     * ScheduledActions[]
     * @type {Array<object>}
     * @memberof SchedulerAISchedulerV4PutFormattedRes
     */
    'schedules': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAISchedulerV4PutFormattedRes
     */
    'scienceApiReq'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAISchedulerV4PutFormattedRes
     */
    'scienceApiRes'?: string;
    /**
     * CalendarEvent[]
     * @type {Array<object>}
     * @memberof SchedulerAISchedulerV4PutFormattedRes
     */
    'prescheduledEvents'?: Array<object>;
    /**
     * ScheduleEfficiencyScore
     * @type {object}
     * @memberof SchedulerAISchedulerV4PutFormattedRes
     */
    'efficiency'?: object;
    /**
     * 
     * @type {SchedulerSessionRes}
     * @memberof SchedulerAISchedulerV4PutFormattedRes
     */
    'sessions'?: SchedulerSessionRes;
}
/**
 * 
 * @export
 * @interface SchedulerAISchedulerV5PutFormattedRes
 */
export interface SchedulerAISchedulerV5PutFormattedRes {
    /**
     * ChatAdjustmentChangeWrapper<ScheduledAction>[]
     * @type {Array<object>}
     * @memberof SchedulerAISchedulerV5PutFormattedRes
     */
    'schedules': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAISchedulerV5PutFormattedRes
     */
    'scienceApiReq'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAISchedulerV5PutFormattedRes
     */
    'scienceApiRes'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAISchedulerV5PutFormattedRes
     */
    'summary'?: string;
}
/**
 * 
 * @export
 * @interface SchedulerAISchedulerV5StreamResultSchedule
 */
export interface SchedulerAISchedulerV5StreamResultSchedule {
    /**
     * 
     * @type {string}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'action_id': string;
    /**
     * Start time in HH:mm format
     * @type {string}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'start_time': string;
    /**
     * End time in HH:mm format
     * @type {string}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'end_time': string;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'duration': number;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'category': string;
    /**
     * \'activity\' | \'todo\' | \'existing_calendar\'
     * @type {string}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'event_from': string;
    /**
     * Event ID for existing calendar events
     * @type {string}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'event_id'?: string;
    /**
     * ID of the todo item that originates the scheduled event
     * @type {string}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'origin_todo_id'?: string;
    /**
     * Brief explanation of why this event is scheduled at this time
     * @type {string}
     * @memberof SchedulerAISchedulerV5StreamResultSchedule
     */
    'explanation'?: string;
}
/**
 * 
 * @export
 * @interface SchedulerAITimeBoxPlannerPutFormattedRes
 */
export interface SchedulerAITimeBoxPlannerPutFormattedRes {
    /**
     * ScheduledActions[]
     * @type {Array<object>}
     * @memberof SchedulerAITimeBoxPlannerPutFormattedRes
     */
    'schedules': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAITimeBoxPlannerPutFormattedRes
     */
    'scienceApiReq'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerAITimeBoxPlannerPutFormattedRes
     */
    'scienceApiRes'?: string;
    /**
     * CalendarEvent[]
     * @type {Array<object>}
     * @memberof SchedulerAITimeBoxPlannerPutFormattedRes
     */
    'prescheduledEvents'?: Array<object>;
    /**
     * ScheduleEfficiencyScore
     * @type {object}
     * @memberof SchedulerAITimeBoxPlannerPutFormattedRes
     */
    'efficiency'?: object;
}
/**
 * 
 * @export
 * @interface SchedulerRule
 */
export interface SchedulerRule {
    /**
     * 
     * @type {string}
     * @memberof SchedulerRule
     */
    'ruleId': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerRule
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerRule
     */
    'source'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SchedulerRule
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SchedulerRule
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerRule
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface SchedulerRuleWithoutId
 */
export interface SchedulerRuleWithoutId {
    /**
     * 
     * @type {string}
     * @memberof SchedulerRuleWithoutId
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerRuleWithoutId
     */
    'source'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SchedulerRuleWithoutId
     */
    'tags'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SchedulerSessionRes
 */
export interface SchedulerSessionRes {
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionRes
     */
    'currentSessionId'?: string;
    /**
     * SessionMessage[]
     * @type {Array<object>}
     * @memberof SchedulerSessionRes
     */
    'messages'?: Array<object>;
}
/**
 * 
 * @export
 * @interface SessionMessage
 */
export interface SessionMessage {
    /**
     * Unique identifier for the message
     * @type {string}
     * @memberof SessionMessage
     */
    'messageId'?: string;
    /**
     * Message content
     * @type {string}
     * @memberof SessionMessage
     */
    'content'?: string;
    /**
     * Role of the message sender (user/assistant)
     * @type {string}
     * @memberof SessionMessage
     */
    'role'?: string;
    /**
     * When the message was created
     * @type {string}
     * @memberof SessionMessage
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface SharedAccessAcceptPostReq
 */
export interface SharedAccessAcceptPostReq {
    /**
     * The referral code to accept
     * @type {string}
     * @memberof SharedAccessAcceptPostReq
     */
    'referralCode': string;
}
/**
 * 
 * @export
 * @interface SharedAccessCreateRulePostReq
 */
export interface SharedAccessCreateRulePostReq {
    /**
     * The user ID to share data with
     * @type {string}
     * @memberof SharedAccessCreateRulePostReq
     */
    'targetUserId': string;
    /**
     * Type of data to share (\'calendar\' or \'energy\')
     * @type {string}
     * @memberof SharedAccessCreateRulePostReq
     */
    'dataTypes': string;
    /**
     * Access level (\'view\' or \'none\', defaults to \'view\')
     * @type {string}
     * @memberof SharedAccessCreateRulePostReq
     */
    'accessLevel'?: string;
    /**
     * Status (\'pending\' or \'accepted\' or \'declined\', defaults to \'pending\')
     * @type {string}
     * @memberof SharedAccessCreateRulePostReq
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface SharedAccessGetUsersGetRes
 */
export interface SharedAccessGetUsersGetRes {
    /**
     * Array of users with shared access
     * @type {Array<SharedAccessUser>}
     * @memberof SharedAccessGetUsersGetRes
     */
    'users': Array<SharedAccessUser>;
}
/**
 * 
 * @export
 * @interface SharedAccessUpdateRulePutReq
 */
export interface SharedAccessUpdateRulePutReq {
    /**
     * New status (\'accepted\' or \'declined\')
     * @type {string}
     * @memberof SharedAccessUpdateRulePutReq
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface SharedAccessUser
 */
export interface SharedAccessUser {
    /**
     * The user ID
     * @type {string}
     * @memberof SharedAccessUser
     */
    'userId': string;
    /**
     * The user email
     * @type {string}
     * @memberof SharedAccessUser
     */
    'email'?: string;
    /**
     * The user name
     * @type {string}
     * @memberof SharedAccessUser
     */
    'name'?: string;
    /**
     * The user photo URL
     * @type {string}
     * @memberof SharedAccessUser
     */
    'photoUrl'?: string;
    /**
     * The data types shared with the user
     * @type {Array<string>}
     * @memberof SharedAccessUser
     */
    'dataTypes'?: Array<string>;
    /**
     * The access level (\'view\' or \'none\')
     * @type {string}
     * @memberof SharedAccessUser
     */
    'accessLevel'?: string;
    /**
     * The status (\'pending\' or \'accepted\' or \'declined\')
     * @type {string}
     * @memberof SharedAccessUser
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface SleepData
 */
export interface SleepData {
    /**
     * Recommended sleep time
     * @type {string}
     * @memberof SleepData
     */
    'sleepTime'?: string;
    /**
     * Recommended wake time
     * @type {string}
     * @memberof SleepData
     */
    'wakeTime'?: string;
    /**
     * Calendar ID for the sleep event
     * @type {string}
     * @memberof SleepData
     */
    'calendarId'?: string;
    /**
     * Event ID for the sleep event
     * @type {string}
     * @memberof SleepData
     */
    'eventId'?: string;
}
/**
 * 
 * @export
 * @interface SleepDataTrendWeeklyRes
 */
export interface SleepDataTrendWeeklyRes {
    /**
     * start date
     * @type {string}
     * @memberof SleepDataTrendWeeklyRes
     */
    'startDate': string;
    /**
     * end date
     * @type {string}
     * @memberof SleepDataTrendWeeklyRes
     */
    'endDate': string;
    /**
     * SleepDetailsByDate[]
     * @type {object}
     * @memberof SleepDataTrendWeeklyRes
     */
    'data': object;
    /**
     * 
     * @type {number}
     * @memberof SleepDataTrendWeeklyRes
     */
    'avgDurationMin': number;
    /**
     * SleepStage
     * @type {object}
     * @memberof SleepDataTrendWeeklyRes
     */
    'avgStage': object;
}
/**
 * 
 * @export
 * @interface StartChatSessionOutput
 */
export interface StartChatSessionOutput {
    /**
     * Unique session identifier
     * @type {string}
     * @memberof StartChatSessionOutput
     */
    'sessionId': string;
    /**
     * Type of session that was created
     * @type {string}
     * @memberof StartChatSessionOutput
     */
    'type': string;
    /**
     * Session expiration time in seconds
     * @type {number}
     * @memberof StartChatSessionOutput
     */
    'expires_in'?: number;
    /**
     * Confirmation message
     * @type {string}
     * @memberof StartChatSessionOutput
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface StartChatSessionParams
 */
export interface StartChatSessionParams {
    /**
     * User ID
     * @type {string}
     * @memberof StartChatSessionParams
     */
    'userId': string;
    /**
     * Metric ID for the chat
     * @type {string}
     * @memberof StartChatSessionParams
     */
    'metricId': string;
    /**
     * date format YYYY-MM-DD
     * @type {string}
     * @memberof StartChatSessionParams
     */
    'date': string;
    /**
     * Type of chat session (sleep, meal, task, general) StreamChatSessionType
     * @type {string}
     * @memberof StartChatSessionParams
     */
    'sessionType': string;
    /**
     * Routine ID for the chat
     * @type {string}
     * @memberof StartChatSessionParams
     */
    'routineId'?: string;
    /**
     * User\'s message to the assistant
     * @type {string}
     * @memberof StartChatSessionParams
     */
    'userMessage'?: string;
    /**
     * Preference ID for the chat
     * @type {string}
     * @memberof StartChatSessionParams
     */
    'preferenceId'?: string;
}
/**
 * 
 * @export
 * @interface SubscribeSkipCardSubscriptionParams
 */
export interface SubscribeSkipCardSubscriptionParams {
    /**
     * userId
     * @type {string}
     * @memberof SubscribeSkipCardSubscriptionParams
     */
    'userId': string;
    /**
     * deviceFrom
     * @type {string}
     * @memberof SubscribeSkipCardSubscriptionParams
     */
    'deviceFrom': string;
    /**
     * trialDays
     * @type {number}
     * @memberof SubscribeSkipCardSubscriptionParams
     */
    'trialDays': number;
    /**
     * discountId
     * @type {string}
     * @memberof SubscribeSkipCardSubscriptionParams
     */
    'discountId'?: string;
    /**
     * offeringId
     * @type {string}
     * @memberof SubscribeSkipCardSubscriptionParams
     */
    'offeringId'?: string;
}
/**
 * 
 * @export
 * @interface SuccessRes
 */
export interface SuccessRes {
    /**
     * success: true
     * @type {boolean}
     * @memberof SuccessRes
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface SuggestIndividualTaskTimeParams
 */
export interface SuggestIndividualTaskTimeParams {
    /**
     * 
     * @type {string}
     * @memberof SuggestIndividualTaskTimeParams
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestIndividualTaskTimeParams
     */
    'metricId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestIndividualTaskTimeParams
     */
    'currentTime': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestIndividualTaskTimeParams
     */
    'preferenceId': string;
    /**
     * TaskItem
     * @type {object}
     * @memberof SuggestIndividualTaskTimeParams
     */
    'task': object;
    /**
     * TemporaryTask[]
     * @type {Array<TemporaryTask>}
     * @memberof SuggestIndividualTaskTimeParams
     */
    'temporaryTasks'?: Array<TemporaryTask>;
}
/**
 * 
 * @export
 * @interface SuggestIndividualTaskTimeRes
 */
export interface SuggestIndividualTaskTimeRes {
    /**
     * SuggestedTaskItem
     * @type {object}
     * @memberof SuggestIndividualTaskTimeRes
     */
    'suggestedTask': object;
    /**
     * 
     * @type {string}
     * @memberof SuggestIndividualTaskTimeRes
     */
    'detailedExplanation': string;
}
/**
 * 
 * @export
 * @interface SuggestMealItemRes
 */
export interface SuggestMealItemRes {
    /**
     * 
     * @type {string}
     * @memberof SuggestMealItemRes
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealItemRes
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealItemRes
     */
    'eventId': string;
}
/**
 * 
 * @export
 * @interface SuggestMealTimeParams
 */
export interface SuggestMealTimeParams {
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeParams
     */
    'routineId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeParams
     */
    'chatId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeParams
     */
    'chatSessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeParams
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeParams
     */
    'calendarId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeParams
     */
    'metricId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeParams
     */
    'dateToBeSuggested': string;
}
/**
 * 
 * @export
 * @interface SuggestMealTimeRes
 */
export interface SuggestMealTimeRes {
    /**
     * 
     * @type {SuggestMealItemRes}
     * @memberof SuggestMealTimeRes
     */
    'breakfast': SuggestMealItemRes;
    /**
     * 
     * @type {SuggestMealItemRes}
     * @memberof SuggestMealTimeRes
     */
    'lunch': SuggestMealItemRes;
    /**
     * 
     * @type {SuggestMealItemRes}
     * @memberof SuggestMealTimeRes
     */
    'dinner': SuggestMealItemRes;
    /**
     * 
     * @type {SchedulerSessionRes}
     * @memberof SuggestMealTimeRes
     */
    'sessions': SchedulerSessionRes;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeRes
     */
    'detailedExplanation': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeRes
     */
    'scienceApiReq'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestMealTimeRes
     */
    'scienceApiRes'?: string;
}
/**
 * 
 * @export
 * @interface SuggestRecommendationNowParams
 */
export interface SuggestRecommendationNowParams {
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowParams
     */
    'chatId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowParams
     */
    'sessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowParams
     */
    'userMessage': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowParams
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowParams
     */
    'metricId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowParams
     */
    'currentTime': string;
}
/**
 * 
 * @export
 * @interface SuggestRecommendationNowRes
 */
export interface SuggestRecommendationNowRes {
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowRes
     */
    'currentSessionId': string;
    /**
     * SessionMessage[]
     * @type {Array<object>}
     * @memberof SuggestRecommendationNowRes
     */
    'messages': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowRes
     */
    'response': string;
    /**
     * ChatAdjustmentCTA
     * @type {object}
     * @memberof SuggestRecommendationNowRes
     */
    'cta'?: object;
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowRes
     */
    'scienceApiReq'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRecommendationNowRes
     */
    'scienceApiRes'?: string;
}
/**
 * 
 * @export
 * @interface SuggestRoutineTimeParams
 */
export interface SuggestRoutineTimeParams {
    /**
     * 
     * @type {string}
     * @memberof SuggestRoutineTimeParams
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRoutineTimeParams
     */
    'metricId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRoutineTimeParams
     */
    'currentTime': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRoutineTimeParams
     */
    'preferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestRoutineTimeParams
     */
    'routineId': string;
}
/**
 * 
 * @export
 * @interface SuggestRoutineTimeRes
 */
export interface SuggestRoutineTimeRes {
    /**
     * RoutineActivity[]
     * @type {Array<object>}
     * @memberof SuggestRoutineTimeRes
     */
    'suggestedRoutineActivities': Array<object>;
    /**
     * RoutineActivity[]
     * @type {Array<object>}
     * @memberof SuggestRoutineTimeRes
     */
    'unscheduledRoutineActivities': Array<object>;
}
/**
 * 
 * @export
 * @interface SuggestSleepTimeParams
 */
export interface SuggestSleepTimeParams {
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeParams
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeParams
     */
    'metricId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeParams
     */
    'dateToBeSuggested': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeParams
     */
    'chatId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeParams
     */
    'calendarId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeParams
     */
    'chatSessionId'?: string;
}
/**
 * 
 * @export
 * @interface SuggestSleepTimeRes
 */
export interface SuggestSleepTimeRes {
    /**
     * 
     * @type {SchedulerSessionRes}
     * @memberof SuggestSleepTimeRes
     */
    'sessions': SchedulerSessionRes;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeRes
     */
    'sleepTime': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeRes
     */
    'wakeTime': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeRes
     */
    'calendarId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeRes
     */
    'eventId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeRes
     */
    'detailedExplanation': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeRes
     */
    'scienceApiReq'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestSleepTimeRes
     */
    'scienceApiRes'?: string;
}
/**
 * 
 * @export
 * @interface SuggestTaskTimeParams
 */
export interface SuggestTaskTimeParams {
    /**
     * 
     * @type {string}
     * @memberof SuggestTaskTimeParams
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestTaskTimeParams
     */
    'chatId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestTaskTimeParams
     */
    'metricId': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestTaskTimeParams
     */
    'currentTime': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestTaskTimeParams
     */
    'chatSessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestTaskTimeParams
     */
    'preferenceId': string;
}
/**
 * 
 * @export
 * @interface SuggestTaskTimeRes
 */
export interface SuggestTaskTimeRes {
    /**
     * 
     * @type {SchedulerSessionRes}
     * @memberof SuggestTaskTimeRes
     */
    'sessions': SchedulerSessionRes;
    /**
     * SuggestedTaskItem[]
     * @type {Array<object>}
     * @memberof SuggestTaskTimeRes
     */
    'suggestedTasks': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof SuggestTaskTimeRes
     */
    'detailedExplanation': string;
    /**
     * 
     * @type {string}
     * @memberof SuggestTaskTimeRes
     */
    'scienceApiReq'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestTaskTimeRes
     */
    'scienceApiRes'?: string;
}
/**
 * 
 * @export
 * @interface SyncAppleReminderRes
 */
export interface SyncAppleReminderRes {
    /**
     * 
     * @type {boolean}
     * @memberof SyncAppleReminderRes
     */
    'success': boolean;
    /**
     * TaskItem[]
     * @type {Array<object>}
     * @memberof SyncAppleReminderRes
     */
    'updatedTasks': Array<object>;
    /**
     * TaskItem[]
     * @type {Array<object>}
     * @memberof SyncAppleReminderRes
     */
    'deletedTasks': Array<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncAppleReminderRes
     */
    'todoTasksBoardIds': Array<string>;
    /**
     * Record<string, string>
     * @type {object}
     * @memberof SyncAppleReminderRes
     */
    'boardMap': object;
}
/**
 * 
 * @export
 * @interface SyncChatResultOutput
 */
export interface SyncChatResultOutput {
    /**
     * Array of session messages SessionMessage[]
     * @type {Array<object>}
     * @memberof SyncChatResultOutput
     */
    'sessions': Array<object>;
    /**
     * Detailed explanation of the result
     * @type {string}
     * @memberof SyncChatResultOutput
     */
    'detailedExplanation'?: string;
    /**
     * 
     * @type {SleepData}
     * @memberof SyncChatResultOutput
     */
    'sleepData'?: SleepData;
    /**
     * 
     * @type {MealData}
     * @memberof SyncChatResultOutput
     */
    'mealData'?: MealData;
    /**
     * Suggested task items (for task sessions) SuggestedTaskItem[]
     * @type {Array<object>}
     * @memberof SyncChatResultOutput
     */
    'suggestedTasks'?: Array<object>;
    /**
     * Chat adjustment call-to-action ChatAdjustmentCTA
     * @type {object}
     * @memberof SyncChatResultOutput
     */
    'cta'?: object;
    /**
     * Chat adjustment call-to-action for each date ChatAdjustmentCTA[]
     * @type {Array<object>}
     * @memberof SyncChatResultOutput
     */
    'ctas'?: Array<object>;
}
/**
 * 
 * @export
 * @interface SyncChatResultParams
 */
export interface SyncChatResultParams {
    /**
     * Type of chat session (sleep, meal, task, general, recommendation)
     * @type {string}
     * @memberof SyncChatResultParams
     */
    'sessionType': string;
    /**
     * JSON string containing the chat result
     * @type {string}
     * @memberof SyncChatResultParams
     */
    'resultJson': string;
    /**
     * User ID
     * @type {string}
     * @memberof SyncChatResultParams
     */
    'userId': string;
    /**
     * Routine ID (required for general sessions)  required for general sessions
     * @type {string}
     * @memberof SyncChatResultParams
     */
    'routineId'?: string;
    /**
     * Metric ID
     * @type {string}
     * @memberof SyncChatResultParams
     */
    'metricId': string;
    /**
     * Calendar ID (required for sleep and meal sessions)
     * @type {string}
     * @memberof SyncChatResultParams
     */
    'calendarId'?: string;
    /**
     * Date to be suggested (required for sleep and meal sessions)
     * @type {string}
     * @memberof SyncChatResultParams
     */
    'dateToBeSuggested'?: string;
}
/**
 * 
 * @export
 * @interface SyncErrorRes
 */
export interface SyncErrorRes {
    /**
     * error message
     * @type {string}
     * @memberof SyncErrorRes
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof SyncErrorRes
     */
    'reason'?: string;
    /**
     * terra user id
     * @type {string}
     * @memberof SyncErrorRes
     */
    'terraUserId'?: string;
}
/**
 * 
 * @export
 * @interface SyncExerciseBody
 */
export interface SyncExerciseBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncExerciseBody
     */
    'terraUserIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SyncExerciseBody
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof SyncExerciseBody
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface SyncLocationPayload
 */
export interface SyncLocationPayload {
    /**
     * 
     * @type {CurrentLocation}
     * @memberof SyncLocationPayload
     */
    'currentLocation': CurrentLocation;
    /**
     * 
     * @type {string}
     * @memberof SyncLocationPayload
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface SyncMealBody
 */
export interface SyncMealBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncMealBody
     */
    'terraUserIds': Array<string>;
    /**
     * start date
     * @type {string}
     * @memberof SyncMealBody
     */
    'startDate': string;
    /**
     * end date
     * @type {string}
     * @memberof SyncMealBody
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface SyncSuccessRes
 */
export interface SyncSuccessRes {
    /**
     * success: true
     * @type {boolean}
     * @memberof SyncSuccessRes
     */
    'success': boolean;
    /**
     * SleepDetailsByDate[]
     * @type {Array<object>}
     * @memberof SyncSuccessRes
     */
    'results'?: Array<object>;
}
/**
 * 
 * @export
 * @interface SyncSuccessStripePaymentParams
 */
export interface SyncSuccessStripePaymentParams {
    /**
     * Stripe checkout session ID
     * @type {string}
     * @memberof SyncSuccessStripePaymentParams
     */
    'sessionId': string;
    /**
     * 
     * @type {ConvertedReferralCampaign}
     * @memberof SyncSuccessStripePaymentParams
     */
    'referral'?: ConvertedReferralCampaign;
    /**
     * Discount
     * @type {object}
     * @memberof SyncSuccessStripePaymentParams
     */
    'discount'?: object;
}
/**
 * 
 * @export
 * @interface SyncSuccessStripePaymentRes
 */
export interface SyncSuccessStripePaymentRes {
    /**
     * Updated subscription
     * @type {object}
     * @memberof SyncSuccessStripePaymentRes
     */
    'subscription': object;
}
/**
 * 
 * @export
 * @interface SyncTodoProjectsReq
 */
export interface SyncTodoProjectsReq {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncTodoProjectsReq
     */
    'targetOriginalBoardIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TalkWithAssistantUserContext
 */
export interface TalkWithAssistantUserContext {
    /**
     * Detailed explanation of the meals
     * @type {string}
     * @memberof TalkWithAssistantUserContext
     */
    'meals_detailed_explanation'?: string;
    /**
     * Detailed explanation of the sleep
     * @type {string}
     * @memberof TalkWithAssistantUserContext
     */
    'sleep_detailed_explanation'?: string;
    /**
     * Detailed explanation of the task
     * @type {string}
     * @memberof TalkWithAssistantUserContext
     */
    'task_detailed_explanation'?: string;
}
/**
 * 
 * @export
 * @interface TaskDataTrendWeeklyRes
 */
export interface TaskDataTrendWeeklyRes {
    /**
     * 
     * @type {string}
     * @memberof TaskDataTrendWeeklyRes
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof TaskDataTrendWeeklyRes
     */
    'endDate': string;
    /**
     * TaskDataDailyTrendWithData[]
     * @type {object}
     * @memberof TaskDataTrendWeeklyRes
     */
    'data': object;
}
/**
 * 
 * @export
 * @interface TaskError401Res
 */
export interface TaskError401Res {
    /**
     * error: {message}
     * @type {string}
     * @memberof TaskError401Res
     */
    'error': string;
    /**
     * e.g., todoist, trello
     * @type {string}
     * @memberof TaskError401Res
     */
    'provider'?: string;
}
/**
 * 
 * @export
 * @interface TaskIdRes
 */
export interface TaskIdRes {
    /**
     * taskId: abcdef
     * @type {string}
     * @memberof TaskIdRes
     */
    'taskId': string;
}
/**
 * 
 * @export
 * @interface TaskLabelCreateRes
 */
export interface TaskLabelCreateRes {
    /**
     * Generated label id
     * @type {string}
     * @memberof TaskLabelCreateRes
     */
    'taskLabelId': string;
    /**
     * Created label stored in DB (id, name, color)
     * @type {object}
     * @memberof TaskLabelCreateRes
     */
    'label': object;
}
/**
 * 
 * @export
 * @interface TaskProjectIdRes
 */
export interface TaskProjectIdRes {
    /**
     * taskId: abcdef
     * @type {string}
     * @memberof TaskProjectIdRes
     */
    'taskProjectId': string;
}
/**
 * 
 * @export
 * @interface TaskSyncProviderReq
 */
export interface TaskSyncProviderReq {
    /**
     * 
     * @type {string}
     * @memberof TaskSyncProviderReq
     */
    'userId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskSyncProviderReq
     */
    'todoTasksBoardIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TaskSyncProviderReq
     */
    'fullSync'?: boolean;
}
/**
 * 
 * @export
 * @interface TaskSyncProviderRes
 */
export interface TaskSyncProviderRes {
    /**
     * TaskItem[]
     * @type {Array<object>}
     * @memberof TaskSyncProviderRes
     */
    'updatedTasks': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof TaskSyncProviderRes
     */
    'nextSyncToken'?: string;
}
/**
 * 
 * @export
 * @interface TeamAssignedTasksItem
 */
export interface TeamAssignedTasksItem {
    /**
     * 
     * @type {TeamTaskTeamSummary}
     * @memberof TeamAssignedTasksItem
     */
    'team': TeamTaskTeamSummary;
    /**
     * team-board
     * @type {string}
     * @memberof TeamAssignedTasksItem
     */
    'source': string;
    /**
     * Whether the task was created by the authenticated user
     * @type {boolean}
     * @memberof TeamAssignedTasksItem
     */
    'isOwnTask': boolean;
    /**
     * Always true for this endpoint
     * @type {boolean}
     * @memberof TeamAssignedTasksItem
     */
    'isMeAssigned': boolean;
    /**
     * 
     * @type {TeamTaskMemberSummary}
     * @memberof TeamAssignedTasksItem
     */
    'owner': TeamTaskMemberSummary;
    /**
     * 
     * @type {TeamTaskMemberSummary}
     * @memberof TeamAssignedTasksItem
     */
    'assignee'?: TeamTaskMemberSummary;
    /**
     * 
     * @type {TeamTaskProjectSummary}
     * @memberof TeamAssignedTasksItem
     */
    'project': TeamTaskProjectSummary;
    /**
     * 
     * @type {TeamTaskPermissions}
     * @memberof TeamAssignedTasksItem
     */
    'permissions': TeamTaskPermissions;
    /**
     * One of overdue, today, upcoming, done
     * @type {string}
     * @memberof TeamAssignedTasksItem
     */
    'bucket': string;
    /**
     * Full TaskItem payload
     * @type {object}
     * @memberof TeamAssignedTasksItem
     */
    'task': object;
}
/**
 * 
 * @export
 * @interface TeamAssignedTasksRangeRes
 */
export interface TeamAssignedTasksRangeRes {
    /**
     * Requested range start in YYYY-MM-DD format
     * @type {string}
     * @memberof TeamAssignedTasksRangeRes
     */
    'startDate': string;
    /**
     * Requested range end in YYYY-MM-DD format
     * @type {string}
     * @memberof TeamAssignedTasksRangeRes
     */
    'endDate': string;
    /**
     * Map of teamId to active Team members that can be assigned tasks
     * @type {object}
     * @memberof TeamAssignedTasksRangeRes
     */
    'teamMembersByTeamId': object;
    /**
     * Assigned Team-board task results for each day in the range
     * @type {Array<TeamAssignedTasksRes>}
     * @memberof TeamAssignedTasksRangeRes
     */
    'results': Array<TeamAssignedTasksRes>;
}
/**
 * 
 * @export
 * @interface TeamAssignedTasksRes
 */
export interface TeamAssignedTasksRes {
    /**
     * Requested day in YYYY-MM-DD format
     * @type {string}
     * @memberof TeamAssignedTasksRes
     */
    'date': string;
    /**
     * 
     * @type {TeamTasksCounts}
     * @memberof TeamAssignedTasksRes
     */
    'counts': TeamTasksCounts;
    /**
     * Team-board tasks assigned to the authenticated user across teams
     * @type {Array<TeamAssignedTasksItem>}
     * @memberof TeamAssignedTasksRes
     */
    'tasks': Array<TeamAssignedTasksItem>;
}
/**
 * 
 * @export
 * @interface TeamBoardArchiveRes
 */
export interface TeamBoardArchiveRes {
    /**
     * Archived Team board
     * @type {object}
     * @memberof TeamBoardArchiveRes
     */
    'board': object;
}
/**
 * 
 * @export
 * @interface TeamBoardCreateReq
 */
export interface TeamBoardCreateReq {
    /**
     * Team board name
     * @type {string}
     * @memberof TeamBoardCreateReq
     */
    'name': string;
    /**
     * Optional board color
     * @type {string}
     * @memberof TeamBoardCreateReq
     */
    'color'?: string;
}
/**
 * 
 * @export
 * @interface TeamBoardCreateRes
 */
export interface TeamBoardCreateRes {
    /**
     * Created Team board
     * @type {object}
     * @memberof TeamBoardCreateRes
     */
    'board': object;
}
/**
 * 
 * @export
 * @interface TeamBoardUpdateReq
 */
export interface TeamBoardUpdateReq {
    /**
     * Team board name
     * @type {string}
     * @memberof TeamBoardUpdateReq
     */
    'name'?: string;
    /**
     * Optional board color
     * @type {string}
     * @memberof TeamBoardUpdateReq
     */
    'color'?: string;
}
/**
 * 
 * @export
 * @interface TeamBoardUpdateRes
 */
export interface TeamBoardUpdateRes {
    /**
     * Updated Team board
     * @type {object}
     * @memberof TeamBoardUpdateRes
     */
    'board': object;
}
/**
 * 
 * @export
 * @interface TeamCreateReq
 */
export interface TeamCreateReq {
    /**
     * Team name
     * @type {string}
     * @memberof TeamCreateReq
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TeamCreateRes
 */
export interface TeamCreateRes {
    /**
     * Created team ID
     * @type {string}
     * @memberof TeamCreateRes
     */
    'teamId': string;
}
/**
 * 
 * @export
 * @interface TeamDayMemberItem
 */
export interface TeamDayMemberItem {
    /**
     * Team member ID
     * @type {string}
     * @memberof TeamDayMemberItem
     */
    'teamMemberId': string;
    /**
     * Member user ID
     * @type {string}
     * @memberof TeamDayMemberItem
     */
    'userId': string;
    /**
     * Member timezone
     * @type {string}
     * @memberof TeamDayMemberItem
     */
    'timezone': string;
    /**
     * Whether calendar data is shared
     * @type {boolean}
     * @memberof TeamDayMemberItem
     */
    'isCalendarShared': boolean;
    /**
     * Whether energy data is shared
     * @type {boolean}
     * @memberof TeamDayMemberItem
     */
    'isEnergyShared': boolean;
    /**
     * Full calendar events for the requested day
     * @type {Array<object>}
     * @memberof TeamDayMemberItem
     */
    'events': Array<object>;
    /**
     * Phase windows for the requested day
     * @type {object}
     * @memberof TeamDayMemberItem
     */
    'phases'?: object;
}
/**
 * 
 * @export
 * @interface TeamDayRes
 */
export interface TeamDayRes {
    /**
     * Requested day in YYYY-MM-DD format
     * @type {string}
     * @memberof TeamDayRes
     */
    'date': string;
    /**
     * Team day data grouped by member
     * @type {Array<TeamDayMemberItem>}
     * @memberof TeamDayRes
     */
    'members': Array<TeamDayMemberItem>;
}
/**
 * 
 * @export
 * @interface TeamDeleteRes
 */
export interface TeamDeleteRes {
    /**
     * Deleted team ID
     * @type {string}
     * @memberof TeamDeleteRes
     */
    'teamId': string;
}
/**
 * 
 * @export
 * @interface TeamGetRes
 */
export interface TeamGetRes {
    /**
     * Team
     * @type {object}
     * @memberof TeamGetRes
     */
    'team': object;
    /**
     * Authenticated user\'s team membership
     * @type {object}
     * @memberof TeamGetRes
     */
    'membership': object;
    /**
     * Active team members
     * @type {Array<object>}
     * @memberof TeamGetRes
     */
    'members': Array<object>;
    /**
     * Active Team boards
     * @type {Array<object>}
     * @memberof TeamGetRes
     */
    'boards': Array<object>;
}
/**
 * 
 * @export
 * @interface TeamInviteAcceptReq
 */
export interface TeamInviteAcceptReq {
    /**
     * Invite code
     * @type {string}
     * @memberof TeamInviteAcceptReq
     */
    'inviteCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamInviteAcceptReq
     */
    'sharedCalendarIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamInviteAcceptReq
     */
    'sharedTaskBoardIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TeamInviteAcceptReq
     */
    'shareEnergy'?: boolean;
}
/**
 * 
 * @export
 * @interface TeamInviteAcceptRes
 */
export interface TeamInviteAcceptRes {
    /**
     * Accepted team ID
     * @type {string}
     * @memberof TeamInviteAcceptRes
     */
    'teamId': string;
    /**
     * Active membership
     * @type {object}
     * @memberof TeamInviteAcceptRes
     */
    'membership': object;
}
/**
 * 
 * @export
 * @interface TeamInviteCreateReq
 */
export interface TeamInviteCreateReq {
    /**
     * Invitee email
     * @type {string}
     * @memberof TeamInviteCreateReq
     */
    'email': string;
    /**
     * admin or member
     * @type {string}
     * @memberof TeamInviteCreateReq
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface TeamInviteCreateRes
 */
export interface TeamInviteCreateRes {
    /**
     * Invite
     * @type {object}
     * @memberof TeamInviteCreateRes
     */
    'invite': object;
    /**
     * Shareable invite URL
     * @type {string}
     * @memberof TeamInviteCreateRes
     */
    'inviteUrl': string;
}
/**
 * 
 * @export
 * @interface TeamInviteResolveRes
 */
export interface TeamInviteResolveRes {
    /**
     * Invite
     * @type {object}
     * @memberof TeamInviteResolveRes
     */
    'invite': object;
    /**
     * Team summary
     * @type {object}
     * @memberof TeamInviteResolveRes
     */
    'team': object;
    /**
     * Signed-in viewer eligibility
     * @type {object}
     * @memberof TeamInviteResolveRes
     */
    'viewer': object;
}
/**
 * 
 * @export
 * @interface TeamInviteRevokeRes
 */
export interface TeamInviteRevokeRes {
    /**
     * Revoked invite
     * @type {object}
     * @memberof TeamInviteRevokeRes
     */
    'invite': object;
}
/**
 * 
 * @export
 * @interface TeamInvitesListRes
 */
export interface TeamInvitesListRes {
    /**
     * Team invites
     * @type {Array<object>}
     * @memberof TeamInvitesListRes
     */
    'invites': Array<object>;
}
/**
 * 
 * @export
 * @interface TeamLeaveRes
 */
export interface TeamLeaveRes {
    /**
     * Updated team
     * @type {object}
     * @memberof TeamLeaveRes
     */
    'team': object;
    /**
     * Updated membership
     * @type {object}
     * @memberof TeamLeaveRes
     */
    'membership': object;
}
/**
 * 
 * @export
 * @interface TeamListRes
 */
export interface TeamListRes {
    /**
     * Active teams for the authenticated user
     * @type {Array<object>}
     * @memberof TeamListRes
     */
    'teams': Array<object>;
}
/**
 * 
 * @export
 * @interface TeamMemberRemoveRes
 */
export interface TeamMemberRemoveRes {
    /**
     * Removed member
     * @type {object}
     * @memberof TeamMemberRemoveRes
     */
    'membership': object;
}
/**
 * 
 * @export
 * @interface TeamMemberRoleUpdateReq
 */
export interface TeamMemberRoleUpdateReq {
    /**
     * admin or member
     * @type {string}
     * @memberof TeamMemberRoleUpdateReq
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface TeamMemberRoleUpdateRes
 */
export interface TeamMemberRoleUpdateRes {
    /**
     * Updated member
     * @type {object}
     * @memberof TeamMemberRoleUpdateRes
     */
    'membership': object;
}
/**
 * 
 * @export
 * @interface TeamOwnershipTransferReq
 */
export interface TeamOwnershipTransferReq {
    /**
     * User ID of the new owner
     * @type {string}
     * @memberof TeamOwnershipTransferReq
     */
    'newOwnerUserId': string;
}
/**
 * 
 * @export
 * @interface TeamOwnershipTransferRes
 */
export interface TeamOwnershipTransferRes {
    /**
     * Updated team
     * @type {object}
     * @memberof TeamOwnershipTransferRes
     */
    'team': object;
    /**
     * Previous owner membership
     * @type {object}
     * @memberof TeamOwnershipTransferRes
     */
    'previousOwnerMembership': object;
    /**
     * New owner membership
     * @type {object}
     * @memberof TeamOwnershipTransferRes
     */
    'newOwnerMembership': object;
}
/**
 * 
 * @export
 * @interface TeamShareSettingsUpdateReq
 */
export interface TeamShareSettingsUpdateReq {
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamShareSettingsUpdateReq
     */
    'sharedCalendarIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamShareSettingsUpdateReq
     */
    'sharedTaskBoardIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TeamShareSettingsUpdateReq
     */
    'shareEnergy'?: boolean;
}
/**
 * 
 * @export
 * @interface TeamShareSettingsUpdateRes
 */
export interface TeamShareSettingsUpdateRes {
    /**
     * Updated authenticated user\'s team membership
     * @type {object}
     * @memberof TeamShareSettingsUpdateRes
     */
    'membership': object;
}
/**
 * 
 * @export
 * @interface TeamTaskAssignmentReq
 */
export interface TeamTaskAssignmentReq {
    /**
     * User to assign, or null to unassign
     * @type {string}
     * @memberof TeamTaskAssignmentReq
     */
    'assigneeUserId'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamTaskCreateReq
 */
export interface TeamTaskCreateReq {
    /**
     * Task name
     * @type {string}
     * @memberof TeamTaskCreateReq
     */
    'name': string;
    /**
     * Task description
     * @type {string}
     * @memberof TeamTaskCreateReq
     */
    'desc'?: string;
    /**
     * Due date/time
     * @type {object}
     * @memberof TeamTaskCreateReq
     */
    'dueDateTime'?: object;
    /**
     * Planned duration
     * @type {object}
     * @memberof TeamTaskCreateReq
     */
    'duration'?: object;
    /**
     * Task priority
     * @type {string}
     * @memberof TeamTaskCreateReq
     */
    'priority'?: string;
    /**
     * User to assign on create, or null to leave unassigned
     * @type {string}
     * @memberof TeamTaskCreateReq
     */
    'assigneeUserId'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamTaskDeleteRes
 */
export interface TeamTaskDeleteRes {
    /**
     * Deleted task ID
     * @type {string}
     * @memberof TeamTaskDeleteRes
     */
    'taskId': string;
    /**
     * Team board ID
     * @type {string}
     * @memberof TeamTaskDeleteRes
     */
    'boardId': string;
    /**
     * Always true
     * @type {boolean}
     * @memberof TeamTaskDeleteRes
     */
    'deleted': boolean;
}
/**
 * 
 * @export
 * @interface TeamTaskDetailItem
 */
export interface TeamTaskDetailItem {
    /**
     * One of shared-personal-board or team-board
     * @type {string}
     * @memberof TeamTaskDetailItem
     */
    'source': string;
    /**
     * Whether the task was created by the authenticated user
     * @type {boolean}
     * @memberof TeamTaskDetailItem
     */
    'isOwnTask': boolean;
    /**
     * Whether the task is assigned to the authenticated user
     * @type {boolean}
     * @memberof TeamTaskDetailItem
     */
    'isMeAssigned': boolean;
    /**
     * 
     * @type {TeamTaskMemberSummary}
     * @memberof TeamTaskDetailItem
     */
    'owner': TeamTaskMemberSummary;
    /**
     * 
     * @type {TeamTaskMemberSummary}
     * @memberof TeamTaskDetailItem
     */
    'assignee'?: TeamTaskMemberSummary;
    /**
     * 
     * @type {TeamTaskProjectSummary}
     * @memberof TeamTaskDetailItem
     */
    'project': TeamTaskProjectSummary;
    /**
     * 
     * @type {TeamTaskPermissions}
     * @memberof TeamTaskDetailItem
     */
    'permissions': TeamTaskPermissions;
    /**
     * Full TaskItem payload
     * @type {object}
     * @memberof TeamTaskDetailItem
     */
    'task': object;
}
/**
 * 
 * @export
 * @interface TeamTaskMemberSummary
 */
export interface TeamTaskMemberSummary {
    /**
     * User ID
     * @type {string}
     * @memberof TeamTaskMemberSummary
     */
    'userId': string;
    /**
     * Team member ID
     * @type {string}
     * @memberof TeamTaskMemberSummary
     */
    'teamMemberId'?: string;
    /**
     * Display name
     * @type {string}
     * @memberof TeamTaskMemberSummary
     */
    'name'?: string;
    /**
     * Photo URL
     * @type {string}
     * @memberof TeamTaskMemberSummary
     */
    'photoUrl'?: string;
    /**
     * Team role
     * @type {string}
     * @memberof TeamTaskMemberSummary
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface TeamTaskMutationRes
 */
export interface TeamTaskMutationRes {
    /**
     * Updated task ID
     * @type {string}
     * @memberof TeamTaskMutationRes
     */
    'taskId': string;
    /**
     * 
     * @type {TeamTaskDetailItem}
     * @memberof TeamTaskMutationRes
     */
    'task': TeamTaskDetailItem;
}
/**
 * 
 * @export
 * @interface TeamTaskPermissions
 */
export interface TeamTaskPermissions {
    /**
     * Whether the viewer can edit the task
     * @type {boolean}
     * @memberof TeamTaskPermissions
     */
    'canEdit': boolean;
    /**
     * Whether the viewer can delete the task
     * @type {boolean}
     * @memberof TeamTaskPermissions
     */
    'canDelete': boolean;
    /**
     * Whether the viewer can complete the task
     * @type {boolean}
     * @memberof TeamTaskPermissions
     */
    'canComplete': boolean;
    /**
     * Whether the viewer can change assignee
     * @type {boolean}
     * @memberof TeamTaskPermissions
     */
    'canAssign': boolean;
}
/**
 * 
 * @export
 * @interface TeamTaskProjectSummary
 */
export interface TeamTaskProjectSummary {
    /**
     * Board ID
     * @type {string}
     * @memberof TeamTaskProjectSummary
     */
    'boardId': string;
    /**
     * Board name
     * @type {string}
     * @memberof TeamTaskProjectSummary
     */
    'name': string;
    /**
     * Provider/source
     * @type {string}
     * @memberof TeamTaskProjectSummary
     */
    'appFrom'?: string;
    /**
     * Team ID for Team-owned boards
     * @type {string}
     * @memberof TeamTaskProjectSummary
     */
    'teamId'?: string;
}
/**
 * 
 * @export
 * @interface TeamTaskTeamSummary
 */
export interface TeamTaskTeamSummary {
    /**
     * Team ID
     * @type {string}
     * @memberof TeamTaskTeamSummary
     */
    'teamId': string;
    /**
     * Team name
     * @type {string}
     * @memberof TeamTaskTeamSummary
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TeamTaskUpdateReq
 */
export interface TeamTaskUpdateReq {
    /**
     * Task name
     * @type {string}
     * @memberof TeamTaskUpdateReq
     */
    'name'?: string;
    /**
     * Task description, or null to clear it
     * @type {string}
     * @memberof TeamTaskUpdateReq
     */
    'desc'?: string | null;
    /**
     * Due date/time, or null to clear it
     * @type {object}
     * @memberof TeamTaskUpdateReq
     */
    'dueDateTime'?: object | null;
    /**
     * Planned duration, or null to clear it
     * @type {object}
     * @memberof TeamTaskUpdateReq
     */
    'duration'?: object | null;
    /**
     * Task priority, or null to clear it
     * @type {string}
     * @memberof TeamTaskUpdateReq
     */
    'priority'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamTasksCounts
 */
export interface TeamTasksCounts {
    /**
     * Total returned tasks
     * @type {number}
     * @memberof TeamTasksCounts
     */
    'all': number;
    /**
     * Overdue task count
     * @type {number}
     * @memberof TeamTasksCounts
     */
    'overdue': number;
    /**
     * Today task count
     * @type {number}
     * @memberof TeamTasksCounts
     */
    'today': number;
    /**
     * Upcoming task count
     * @type {number}
     * @memberof TeamTasksCounts
     */
    'upcoming': number;
    /**
     * Done task count
     * @type {number}
     * @memberof TeamTasksCounts
     */
    'done': number;
}
/**
 * 
 * @export
 * @interface TeamTasksItem
 */
export interface TeamTasksItem {
    /**
     * One of shared-personal-board or team-board
     * @type {string}
     * @memberof TeamTasksItem
     */
    'source': string;
    /**
     * Whether the task was created by the authenticated user
     * @type {boolean}
     * @memberof TeamTasksItem
     */
    'isOwnTask': boolean;
    /**
     * Whether the task is assigned to the authenticated user
     * @type {boolean}
     * @memberof TeamTasksItem
     */
    'isMeAssigned': boolean;
    /**
     * 
     * @type {TeamTaskMemberSummary}
     * @memberof TeamTasksItem
     */
    'owner': TeamTaskMemberSummary;
    /**
     * 
     * @type {TeamTaskMemberSummary}
     * @memberof TeamTasksItem
     */
    'assignee'?: TeamTaskMemberSummary;
    /**
     * 
     * @type {TeamTaskProjectSummary}
     * @memberof TeamTasksItem
     */
    'project': TeamTaskProjectSummary;
    /**
     * 
     * @type {TeamTaskPermissions}
     * @memberof TeamTasksItem
     */
    'permissions': TeamTaskPermissions;
    /**
     * One of overdue, today, upcoming, done
     * @type {string}
     * @memberof TeamTasksItem
     */
    'bucket': string;
    /**
     * Full TaskItem payload
     * @type {object}
     * @memberof TeamTasksItem
     */
    'task': object;
}
/**
 * 
 * @export
 * @interface TeamTasksRes
 */
export interface TeamTasksRes {
    /**
     * Requested day in YYYY-MM-DD format
     * @type {string}
     * @memberof TeamTasksRes
     */
    'date': string;
    /**
     * 
     * @type {TeamTasksCounts}
     * @memberof TeamTasksRes
     */
    'counts': TeamTasksCounts;
    /**
     * Visible Team task items for this endpoint
     * @type {Array<TeamTasksItem>}
     * @memberof TeamTasksRes
     */
    'tasks': Array<TeamTasksItem>;
}
/**
 * 
 * @export
 * @interface TeamUpdateReq
 */
export interface TeamUpdateReq {
    /**
     * Team name
     * @type {string}
     * @memberof TeamUpdateReq
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TeamUpdateRes
 */
export interface TeamUpdateRes {
    /**
     * Updated team
     * @type {object}
     * @memberof TeamUpdateRes
     */
    'team': object;
}
/**
 * 
 * @export
 * @interface TelegramChat
 */
export interface TelegramChat {
    /**
     * 
     * @type {number}
     * @memberof TelegramChat
     */
    'id': number;
    /**
     * \"private\" | \"group\" | \"supergroup\" | \"channel\"
     * @type {string}
     * @memberof TelegramChat
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface TelegramFrom
 */
export interface TelegramFrom {
    /**
     * 
     * @type {number}
     * @memberof TelegramFrom
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TelegramFrom
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof TelegramFrom
     */
    'first_name'?: string;
}
/**
 * 
 * @export
 * @interface TelegramMessage
 */
export interface TelegramMessage {
    /**
     * 
     * @type {number}
     * @memberof TelegramMessage
     */
    'message_id': number;
    /**
     * 
     * @type {TelegramFrom}
     * @memberof TelegramMessage
     */
    'from'?: TelegramFrom;
    /**
     * 
     * @type {TelegramChat}
     * @memberof TelegramMessage
     */
    'chat': TelegramChat;
    /**
     * 
     * @type {string}
     * @memberof TelegramMessage
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface TelegramUpdate
 */
export interface TelegramUpdate {
    /**
     * 
     * @type {number}
     * @memberof TelegramUpdate
     */
    'update_id': number;
    /**
     * 
     * @type {TelegramMessage}
     * @memberof TelegramUpdate
     */
    'message'?: TelegramMessage;
}
/**
 * 
 * @export
 * @interface TemporaryTask
 */
export interface TemporaryTask {
    /**
     * 
     * @type {string}
     * @memberof TemporaryTask
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof TemporaryTask
     */
    'name': string;
    /**
     * HH:mm
     * @type {string}
     * @memberof TemporaryTask
     */
    'startTime': string;
    /**
     * HH:mm
     * @type {string}
     * @memberof TemporaryTask
     */
    'endTime': string;
}
/**
 * 
 * @export
 * @interface TodoTasksBoardWebhook
 */
export interface TodoTasksBoardWebhook {
    /**
     * 
     * @type {string}
     * @memberof TodoTasksBoardWebhook
     */
    'resourceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof TodoTasksBoardWebhook
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof TodoTasksBoardWebhook
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface TodoTasksWebhookSubscribeReq
 */
export interface TodoTasksWebhookSubscribeReq {
    /**
     * Internal todo tasks board id
     * @type {Array<string>}
     * @memberof TodoTasksWebhookSubscribeReq
     */
    'todoTasksBoardIds': Array<string>;
    /**
     * User id
     * @type {string}
     * @memberof TodoTasksWebhookSubscribeReq
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface TodoTasksWebhookSubscribeRes
 */
export interface TodoTasksWebhookSubscribeRes {
    /**
     * Subscription status outcome
     * @type {string}
     * @memberof TodoTasksWebhookSubscribeRes
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface UpdateCannyPostRequest
 */
export interface UpdateCannyPostRequest {
    /**
     * Canny post ID
     * @type {string}
     * @memberof UpdateCannyPostRequest
     */
    'postId': string;
    /**
     * User ID
     * @type {string}
     * @memberof UpdateCannyPostRequest
     */
    'userId': string;
    /**
     * User name
     * @type {string}
     * @memberof UpdateCannyPostRequest
     */
    'userName': string;
    /**
     * User email
     * @type {string}
     * @memberof UpdateCannyPostRequest
     */
    'userEmail': string;
    /**
     * 
     * @type {UpdateCannyPostUpdates}
     * @memberof UpdateCannyPostRequest
     */
    'updates': UpdateCannyPostUpdates;
}
/**
 * 
 * @export
 * @interface UpdateCannyPostUpdates
 */
export interface UpdateCannyPostUpdates {
    /**
     * Vote
     * @type {boolean}
     * @memberof UpdateCannyPostUpdates
     */
    'vote'?: boolean;
    /**
     * Comment
     * @type {string}
     * @memberof UpdateCannyPostUpdates
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface UpdateCompleteStatusRes
 */
export interface UpdateCompleteStatusRes {
    /**
     * The task ID that was updated
     * @type {string}
     * @memberof UpdateCompleteStatusRes
     */
    'taskId': string;
    /**
     * The next occurrence date for recurring tasks in YYYY-MM-DD format. Null if not a recurring task or if the recurrence string cannot be parsed.
     * @type {string}
     * @memberof UpdateCompleteStatusRes
     */
    'nextDueDate'?: string;
}
/**
 * 
 * @export
 * @interface UpdateExerciseBody
 */
export interface UpdateExerciseBody {
    /**
     * ExerciseDetailsByDate[]
     * @type {Array<object>}
     * @memberof UpdateExerciseBody
     */
    'exerciseDetails': Array<object>;
}
/**
 * 
 * @export
 * @interface UpdateHeartRate200Res
 */
export interface UpdateHeartRate200Res {
    /**
     * 
     * @type {string}
     * @memberof UpdateHeartRate200Res
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface UpdateMealBody
 */
export interface UpdateMealBody {
    /**
     * MealDetailsByDate[]
     * @type {Array<object>}
     * @memberof UpdateMealBody
     */
    'mealDetails': Array<object>;
}
/**
 * 
 * @export
 * @interface UpdateMealPredictionBody
 */
export interface UpdateMealPredictionBody {
    /**
     * date
     * @type {string}
     * @memberof UpdateMealPredictionBody
     */
    'date': string;
    /**
     * -- PredictedMeal
     * @type {object}
     * @memberof UpdateMealPredictionBody
     */
    'prediction': object;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMealPredictionBody
     */
    'shouldUpdateEvent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateMealPredictionBody
     */
    'baseCalendarId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMealPredictionBody
     */
    'chatSessionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMealPredictionBody
     */
    'editedManually'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateSatisfactionEmaParams
 */
export interface UpdateSatisfactionEmaParams {
    /**
     * EMASatisfactionType
     * @type {string}
     * @memberof UpdateSatisfactionEmaParams
     */
    'satisfaction'?: string;
    /**
     * Optional satisfaction note text
     * @type {string}
     * @memberof UpdateSatisfactionEmaParams
     */
    'satisfactionNote'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSleepPredictionBody
 */
export interface UpdateSleepPredictionBody {
    /**
     * date to be suggested.
     * @type {string}
     * @memberof UpdateSleepPredictionBody
     */
    'date': string;
    /**
     * -- PredictedSleep
     * @type {object}
     * @memberof UpdateSleepPredictionBody
     */
    'prediction': object;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSleepPredictionBody
     */
    'shouldUpdateEvent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateSleepPredictionBody
     */
    'baseCalendarId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSleepPredictionBody
     */
    'chatSessionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSleepPredictionBody
     */
    'editedManually'?: boolean;
}
/**
 * 
 * @export
 * @interface UserLifetimeStats
 */
export interface UserLifetimeStats {
    /**
     * 
     * @type {string}
     * @memberof UserLifetimeStats
     */
    'userId': string;
    /**
     * 
     * @type {number}
     * @memberof UserLifetimeStats
     */
    'totalTasksCompleted': number;
    /**
     * 
     * @type {number}
     * @memberof UserLifetimeStats
     */
    'totalDeepWorkMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof UserLifetimeStats
     */
    'avgSleepDurationMin': number;
    /**
     * 
     * @type {number}
     * @memberof UserLifetimeStats
     */
    'totalSteps': number;
    /**
     * 
     * @type {number}
     * @memberof UserLifetimeStats
     */
    'avgRestingHRBpm'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserLifetimeStats
     */
    'joinedDate'?: string;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Apple Sign In OAuth callback endpoint
         * @param {AppleAuthCallbackReq} [appleAuthCallbackReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAuthCallback: async (appleAuthCallbackReq?: AppleAuthCallbackReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/auth/callback/apple-auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appleAuthCallbackReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a subscription via Stripe
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStripeSubscription: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('cancelStripeSubscription', 'userId', userId)
            const localVarPath = `/api/v1/account/subscriptions/stripe/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check whether JWT access token is still alive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAccessAlive: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/auth/access-alive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Stripe Checkout session for subscriptions
         * @param {string} userId 
         * @param {CreateStripeCheckoutSessionParams} createStripeCheckoutSessionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeCheckoutSession: async (userId: string, createStripeCheckoutSessionParams: CreateStripeCheckoutSessionParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createStripeCheckoutSession', 'userId', userId)
            // verify required parameter 'createStripeCheckoutSessionParams' is not null or undefined
            assertParamExists('createStripeCheckoutSession', 'createStripeCheckoutSessionParams', createStripeCheckoutSessionParams)
            const localVarPath = `/api/v1/account/subscriptions/stripe/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStripeCheckoutSessionParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a user info
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/api/v1/account/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exchange or refresh a Google OAuth token on the SPA\'s behalf. The frontend\'s oidc-client-ts UserManager is configured to send its authorization_code and refresh_token grant requests here instead of directly to Google, so the confidential client\'s secret never has to live in browser-bundled code.
         * @param {string} [generatedClientType] oauth generated client type (web, mobile, desktop)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeGoogleOAuthToken: async (generatedClientType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/auth/google/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (generatedClientType !== undefined) {
                localVarQueryParameter['generatedClientType'] = generatedClientType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a new JWT
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateJwt: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('generateJwt', 'userId', userId)
            const localVarPath = `/api/v1/account/auth/generateJwt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a referral code for the authenticated user
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReferralCode: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('generateReferralCode', 'userId', userId)
            const localVarPath = `/api/v1/account/subscriptions/referral/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get available subscriptions
         * @param {string} access Access type: \&quot;beta\&quot; | \&quot;basic\&quot; | \&quot;basic_price_up_202512\&quot;
         * @param {string} [provider] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSubscriptions: async (access: string, provider?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'access' is not null or undefined
            assertParamExists('getAvailableSubscriptions', 'access', access)
            const localVarPath = `/api/v1/account/subscriptions/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }

            if (access !== undefined) {
                localVarQueryParameter['access'] = access;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of devices
         * @param {string} deviceGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices: async (deviceGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceGroupId' is not null or undefined
            assertParamExists('getDevices', 'deviceGroupId', deviceGroupId)
            const localVarPath = `/api/v1/account/devices/{deviceGroupId}`
                .replace(`{${"deviceGroupId"}}`, encodeURIComponent(String(deviceGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get general preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getGeneralPreference: async (preferenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('getGeneralPreference', 'preferenceId', preferenceId)
            const localVarPath = `/api/v1/account/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all preferences
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences: async (preferenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('getPreferences', 'preferenceId', preferenceId)
            const localVarPath = `/api/v1/account/preference/{preferenceId}/all`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a referral campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralCampaign: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getReferralCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/v1/account/subscriptions/referral/campaign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get subscriptions
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSubscriptions', 'userId', userId)
            const localVarPath = `/api/v1/account/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a user info
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/api/v1/account/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get lifetime stats for a user
         * @param {string} userId 
         * @param {string} [metricId] Metric ID (required for health stats)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStats: async (userId: string, metricId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserStats', 'userId', userId)
            const localVarPath = `/api/v1/account/user/{userId}/stats`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a user token
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getuserToken: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getuserToken', 'userId', userId)
            const localVarPath = `/api/v1/account/user/{userId}/token`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh an access token
         * @param {string} refresh 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refresh: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refresh' is not null or undefined
            assertParamExists('refreshToken', 'refresh', refresh)
            const localVarPath = `/api/v1/account/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (refresh !== undefined) {
                localVarQueryParameter['refresh'] = refresh;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a device
         * @param {string} deviceGroupId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDeviceV2: async (deviceGroupId: string, deviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceGroupId' is not null or undefined
            assertParamExists('removeDeviceV2', 'deviceGroupId', deviceGroupId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('removeDeviceV2', 'deviceId', deviceId)
            const localVarPath = `/api/v1/account/devices/{deviceGroupId}/device/{deviceId}`
                .replace(`{${"deviceGroupId"}}`, encodeURIComponent(String(deviceGroupId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a user device
         * @param {string} userId 
         * @param {string} deviceTerraId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        removeUserDevice: async (userId: string, deviceTerraId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeUserDevice', 'userId', userId)
            // verify required parameter 'deviceTerraId' is not null or undefined
            assertParamExists('removeUserDevice', 'deviceTerraId', deviceTerraId)
            const localVarPath = `/api/v1/account/user/{userId}/device`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceTerraId !== undefined) {
                localVarQueryParameter['deviceTerraId'] = deviceTerraId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a subscription via Stripe
         * @param {string} userId 
         * @param {RequestSubscriptionPostRes} [requestSubscriptionPostRes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestStripeSubscription: async (userId: string, requestSubscriptionPostRes?: RequestSubscriptionPostRes, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('requestStripeSubscription', 'userId', userId)
            const localVarPath = `/api/v1/account/subscriptions/stripe/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSubscriptionPostRes, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sign in or sign up a user
         * @param {string} userId 
         * @param {boolean} [withJwt] -- deprecated
         * @param {AccountAuthSignInPostReq} [accountAuthSignInPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn: async (userId: string, withJwt?: boolean, accountAuthSignInPostReq?: AccountAuthSignInPostReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('signIn', 'userId', userId)
            const localVarPath = `/api/v1/account/auth/signIn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (withJwt !== undefined) {
                localVarQueryParameter['withJwt'] = withJwt;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountAuthSignInPostReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Subscribe with skip card (no payment)
         * @param {SubscribeSkipCardSubscriptionParams} subscribeSkipCardSubscriptionParams { userId: string, deviceFrom: \&#39;mobile\&#39; | \&#39;web\&#39;, trialDays: number, offeringId: string, discountId: string }
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeSkipCardSubscription: async (subscribeSkipCardSubscriptionParams: SubscribeSkipCardSubscriptionParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribeSkipCardSubscriptionParams' is not null or undefined
            assertParamExists('subscribeSkipCardSubscription', 'subscribeSkipCardSubscriptionParams', subscribeSkipCardSubscriptionParams)
            const localVarPath = `/api/v1/account/subscriptions/subscribe/skipCard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeSkipCardSubscriptionParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync successful Stripe payment and update subscription in DB
         * @param {string} userId 
         * @param {SyncSuccessStripePaymentParams} syncSuccessStripePaymentParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSuccessStripePayment: async (userId: string, syncSuccessStripePaymentParams: SyncSuccessStripePaymentParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('syncSuccessStripePayment', 'userId', userId)
            // verify required parameter 'syncSuccessStripePaymentParams' is not null or undefined
            assertParamExists('syncSuccessStripePayment', 'syncSuccessStripePaymentParams', syncSuccessStripePaymentParams)
            const localVarPath = `/api/v1/account/subscriptions/stripe/sync-success`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncSuccessStripePaymentParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update general preferences
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;GeneralPreference&gt;
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updatGeneralPreference: async (preferenceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updatGeneralPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updatGeneralPreference', 'body', body)
            const localVarPath = `/api/v1/account/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a device
         * @param {string} deviceGroupId 
         * @param {string} deviceId 
         * @param {object} body Partial&lt;FirestoreDevice&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceV2: async (deviceGroupId: string, deviceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceGroupId' is not null or undefined
            assertParamExists('updateDeviceV2', 'deviceGroupId', deviceGroupId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('updateDeviceV2', 'deviceId', deviceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateDeviceV2', 'body', body)
            const localVarPath = `/api/v1/account/devices/{deviceGroupId}/device/{deviceId}`
                .replace(`{${"deviceGroupId"}}`, encodeURIComponent(String(deviceGroupId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update devices\' priorities
         * @param {string} deviceGroupId 
         * @param {string} metricSource MetricSourceType
         * @param {object} body DevicePriorities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevicesPriorities: async (deviceGroupId: string, metricSource: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceGroupId' is not null or undefined
            assertParamExists('updateDevicesPriorities', 'deviceGroupId', deviceGroupId)
            // verify required parameter 'metricSource' is not null or undefined
            assertParamExists('updateDevicesPriorities', 'metricSource', metricSource)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateDevicesPriorities', 'body', body)
            const localVarPath = `/api/v1/account/devices/{deviceGroupId}/priorities`
                .replace(`{${"deviceGroupId"}}`, encodeURIComponent(String(deviceGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metricSource !== undefined) {
                localVarQueryParameter['metricSource'] = metricSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update email preferences
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;EmailPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailPreference: async (preferenceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updateEmailPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateEmailPreference', 'body', body)
            const localVarPath = `/api/v1/account/preference/{preferenceId}/email`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an onboarding status
         * @param {string} userId 
         * @param {object} body Partial&lt;OnboardingStatus&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnboardingStatus: async (userId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateOnboardingStatus', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateOnboardingStatus', 'body', body)
            const localVarPath = `/api/v1/account/user/{userId}/onboarding`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a subscription
         * @param {string} userId 
         * @param {object} body Partial&lt;Subscription&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: async (userId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateSubscription', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateSubscription', 'body', body)
            const localVarPath = `/api/v1/account/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user info
         * @param {string} userId 
         * @param {object} body Parital&lt;FirestoreUser&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateUser', 'body', body)
            const localVarPath = `/api/v1/account/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user devices
         * @param {string} userId 
         * @param {Array<object>} requestBody Array&lt;UserConnectedDevice&gt;
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateUserDevices: async (userId: string, requestBody: Array<object>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserDevices', 'userId', userId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateUserDevices', 'requestBody', requestBody)
            const localVarPath = `/api/v1/account/user/{userId}/devices`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user token
         * @param {string} userId 
         * @param {object} body Partial&lt;FirestoreToken&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserToken: async (userId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserToken', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateUserToken', 'body', body)
            const localVarPath = `/api/v1/account/user/{userId}/token`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify a discount or referral code
         * @param {string} code 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDiscountCode: async (code: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('verifyDiscountCode', 'code', code)
            const localVarPath = `/api/v1/account/subscriptions/discount/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Watch a subscription status -- Connect to Stripe
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchStripeSubscriptionStatus: async (body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/subscriptions/stripe/watchStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Watch a subscription status -- Connect to RevenueCat
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchSubscriptionStatus: async (body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/subscriptions/watchStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Apple Sign In OAuth callback endpoint
         * @param {AppleAuthCallbackReq} [appleAuthCallbackReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleAuthCallback(appleAuthCallbackReq?: AppleAuthCallbackReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountAuthSignInPostRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleAuthCallback(appleAuthCallbackReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.appleAuthCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel a subscription via Stripe
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelStripeSubscription(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelStripeSubscription(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.cancelStripeSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check whether JWT access token is still alive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAccessAlive(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountAuthAccessAliveGetRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAccessAlive(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.checkAccessAlive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Stripe Checkout session for subscriptions
         * @param {string} userId 
         * @param {CreateStripeCheckoutSessionParams} createStripeCheckoutSessionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStripeCheckoutSession(userId: string, createStripeCheckoutSessionParams: CreateStripeCheckoutSessionParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateStripeCheckoutSessionRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStripeCheckoutSession(userId, createStripeCheckoutSessionParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.createStripeCheckoutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a user info
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Exchange or refresh a Google OAuth token on the SPA\'s behalf. The frontend\'s oidc-client-ts UserManager is configured to send its authorization_code and refresh_token grant requests here instead of directly to Google, so the confidential client\'s secret never has to live in browser-bundled code.
         * @param {string} [generatedClientType] oauth generated client type (web, mobile, desktop)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeGoogleOAuthToken(generatedClientType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeGoogleOAuthToken(generatedClientType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.exchangeGoogleOAuthToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate a new JWT
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateJwt(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountAuthGenerateJWTPostRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateJwt(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.generateJwt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate a referral code for the authenticated user
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateReferralCode(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateReferralCodeGetRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateReferralCode(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.generateReferralCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get available subscriptions
         * @param {string} access Access type: \&quot;beta\&quot; | \&quot;basic\&quot; | \&quot;basic_price_up_202512\&quot;
         * @param {string} [provider] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSubscriptions(access: string, provider?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSubscriptions(access, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getAvailableSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of devices
         * @param {string} deviceGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevices(deviceGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDevicesGetRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevices(deviceGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get general preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getGeneralPreference(preferenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralPreference(preferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getGeneralPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all preferences
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferences(preferenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferences(preferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a referral campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralCampaign(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getReferralCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get subscriptions
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptions(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountSubscriptionGetRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptions(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a user info
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get lifetime stats for a user
         * @param {string} userId 
         * @param {string} [metricId] Metric ID (required for health stats)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserStats(userId: string, metricId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLifetimeStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserStats(userId, metricId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getUserStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a user token
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getuserToken(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getuserToken(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getuserToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh an access token
         * @param {string} refresh 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refresh: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountAuthRefreshPostRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refresh, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a device
         * @param {string} deviceGroupId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDeviceV2(deviceGroupId: string, deviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDeviceV2(deviceGroupId, deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.removeDeviceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a user device
         * @param {string} userId 
         * @param {string} deviceTerraId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async removeUserDevice(userId: string, deviceTerraId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserDevice(userId, deviceTerraId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.removeUserDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request a subscription via Stripe
         * @param {string} userId 
         * @param {RequestSubscriptionPostRes} [requestSubscriptionPostRes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestStripeSubscription(userId: string, requestSubscriptionPostRes?: RequestSubscriptionPostRes, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestStripeSubscription(userId, requestSubscriptionPostRes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.requestStripeSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sign in or sign up a user
         * @param {string} userId 
         * @param {boolean} [withJwt] -- deprecated
         * @param {AccountAuthSignInPostReq} [accountAuthSignInPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signIn(userId: string, withJwt?: boolean, accountAuthSignInPostReq?: AccountAuthSignInPostReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountAuthSignInPostRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signIn(userId, withJwt, accountAuthSignInPostReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.signIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Subscribe with skip card (no payment)
         * @param {SubscribeSkipCardSubscriptionParams} subscribeSkipCardSubscriptionParams { userId: string, deviceFrom: \&#39;mobile\&#39; | \&#39;web\&#39;, trialDays: number, offeringId: string, discountId: string }
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeSkipCardSubscription(subscribeSkipCardSubscriptionParams: SubscribeSkipCardSubscriptionParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeSkipCardSubscription(subscribeSkipCardSubscriptionParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.subscribeSkipCardSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync successful Stripe payment and update subscription in DB
         * @param {string} userId 
         * @param {SyncSuccessStripePaymentParams} syncSuccessStripePaymentParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncSuccessStripePayment(userId: string, syncSuccessStripePaymentParams: SyncSuccessStripePaymentParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncSuccessStripePaymentRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncSuccessStripePayment(userId, syncSuccessStripePaymentParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.syncSuccessStripePayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update general preferences
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;GeneralPreference&gt;
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updatGeneralPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatGeneralPreference(preferenceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updatGeneralPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a device
         * @param {string} deviceGroupId 
         * @param {string} deviceId 
         * @param {object} body Partial&lt;FirestoreDevice&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeviceV2(deviceGroupId: string, deviceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeviceV2(deviceGroupId, deviceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateDeviceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update devices\' priorities
         * @param {string} deviceGroupId 
         * @param {string} metricSource MetricSourceType
         * @param {object} body DevicePriorities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevicesPriorities(deviceGroupId: string, metricSource: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevicesPriorities(deviceGroupId, metricSource, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateDevicesPriorities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update email preferences
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;EmailPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailPreference(preferenceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateEmailPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an onboarding status
         * @param {string} userId 
         * @param {object} body Partial&lt;OnboardingStatus&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOnboardingStatus(userId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOnboardingStatus(userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateOnboardingStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a subscription
         * @param {string} userId 
         * @param {object} body Partial&lt;Subscription&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscription(userId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscription(userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a user info
         * @param {string} userId 
         * @param {object} body Parital&lt;FirestoreUser&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a user devices
         * @param {string} userId 
         * @param {Array<object>} requestBody Array&lt;UserConnectedDevice&gt;
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateUserDevices(userId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDevices(userId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateUserDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a user token
         * @param {string} userId 
         * @param {object} body Partial&lt;FirestoreToken&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserToken(userId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserToken(userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateUserToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify a discount or referral code
         * @param {string} code 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyDiscountCode(code: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyDiscountCode(code, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.verifyDiscountCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Watch a subscription status -- Connect to Stripe
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchStripeSubscriptionStatus(body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchStripeSubscriptionStatus(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.watchStripeSubscriptionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Watch a subscription status -- Connect to RevenueCat
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchSubscriptionStatus(body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchSubscriptionStatus(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.watchSubscriptionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @summary Apple Sign In OAuth callback endpoint
         * @param {AppleAuthCallbackReq} [appleAuthCallbackReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAuthCallback(appleAuthCallbackReq?: AppleAuthCallbackReq, options?: RawAxiosRequestConfig): AxiosPromise<AccountAuthSignInPostRes> {
            return localVarFp.appleAuthCallback(appleAuthCallbackReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a subscription via Stripe
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStripeSubscription(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.cancelStripeSubscription(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check whether JWT access token is still alive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAccessAlive(options?: RawAxiosRequestConfig): AxiosPromise<AccountAuthAccessAliveGetRes> {
            return localVarFp.checkAccessAlive(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Stripe Checkout session for subscriptions
         * @param {string} userId 
         * @param {CreateStripeCheckoutSessionParams} createStripeCheckoutSessionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeCheckoutSession(userId: string, createStripeCheckoutSessionParams: CreateStripeCheckoutSessionParams, options?: RawAxiosRequestConfig): AxiosPromise<CreateStripeCheckoutSessionRes> {
            return localVarFp.createStripeCheckoutSession(userId, createStripeCheckoutSessionParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a user info
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exchange or refresh a Google OAuth token on the SPA\'s behalf. The frontend\'s oidc-client-ts UserManager is configured to send its authorization_code and refresh_token grant requests here instead of directly to Google, so the confidential client\'s secret never has to live in browser-bundled code.
         * @param {string} [generatedClientType] oauth generated client type (web, mobile, desktop)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeGoogleOAuthToken(generatedClientType?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.exchangeGoogleOAuthToken(generatedClientType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a new JWT
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateJwt(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountAuthGenerateJWTPostRes> {
            return localVarFp.generateJwt(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a referral code for the authenticated user
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReferralCode(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GenerateReferralCodeGetRes> {
            return localVarFp.generateReferralCode(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get available subscriptions
         * @param {string} access Access type: \&quot;beta\&quot; | \&quot;basic\&quot; | \&quot;basic_price_up_202512\&quot;
         * @param {string} [provider] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSubscriptions(access: string, provider?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getAvailableSubscriptions(access, provider, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of devices
         * @param {string} deviceGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices(deviceGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountDevicesGetRes> {
            return localVarFp.getDevices(deviceGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get general preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getGeneralPreference(preferenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getGeneralPreference(preferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all preferences
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences(preferenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getPreferences(preferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a referral campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralCampaign(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getReferralCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get subscriptions
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountSubscriptionGetRes> {
            return localVarFp.getSubscriptions(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a user info
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get lifetime stats for a user
         * @param {string} userId 
         * @param {string} [metricId] Metric ID (required for health stats)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStats(userId: string, metricId?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserLifetimeStats> {
            return localVarFp.getUserStats(userId, metricId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a user token
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getuserToken(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getuserToken(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh an access token
         * @param {string} refresh 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refresh: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountAuthRefreshPostRes> {
            return localVarFp.refreshToken(refresh, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a device
         * @param {string} deviceGroupId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDeviceV2(deviceGroupId: string, deviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.removeDeviceV2(deviceGroupId, deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a user device
         * @param {string} userId 
         * @param {string} deviceTerraId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        removeUserDevice(userId: string, deviceTerraId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.removeUserDevice(userId, deviceTerraId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a subscription via Stripe
         * @param {string} userId 
         * @param {RequestSubscriptionPostRes} [requestSubscriptionPostRes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestStripeSubscription(userId: string, requestSubscriptionPostRes?: RequestSubscriptionPostRes, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.requestStripeSubscription(userId, requestSubscriptionPostRes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sign in or sign up a user
         * @param {string} userId 
         * @param {boolean} [withJwt] -- deprecated
         * @param {AccountAuthSignInPostReq} [accountAuthSignInPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn(userId: string, withJwt?: boolean, accountAuthSignInPostReq?: AccountAuthSignInPostReq, options?: RawAxiosRequestConfig): AxiosPromise<AccountAuthSignInPostRes> {
            return localVarFp.signIn(userId, withJwt, accountAuthSignInPostReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Subscribe with skip card (no payment)
         * @param {SubscribeSkipCardSubscriptionParams} subscribeSkipCardSubscriptionParams { userId: string, deviceFrom: \&#39;mobile\&#39; | \&#39;web\&#39;, trialDays: number, offeringId: string, discountId: string }
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeSkipCardSubscription(subscribeSkipCardSubscriptionParams: SubscribeSkipCardSubscriptionParams, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.subscribeSkipCardSubscription(subscribeSkipCardSubscriptionParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync successful Stripe payment and update subscription in DB
         * @param {string} userId 
         * @param {SyncSuccessStripePaymentParams} syncSuccessStripePaymentParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSuccessStripePayment(userId: string, syncSuccessStripePaymentParams: SyncSuccessStripePaymentParams, options?: RawAxiosRequestConfig): AxiosPromise<SyncSuccessStripePaymentRes> {
            return localVarFp.syncSuccessStripePayment(userId, syncSuccessStripePaymentParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update general preferences
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;GeneralPreference&gt;
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updatGeneralPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updatGeneralPreference(preferenceId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a device
         * @param {string} deviceGroupId 
         * @param {string} deviceId 
         * @param {object} body Partial&lt;FirestoreDevice&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceV2(deviceGroupId: string, deviceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateDeviceV2(deviceGroupId, deviceId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update devices\' priorities
         * @param {string} deviceGroupId 
         * @param {string} metricSource MetricSourceType
         * @param {object} body DevicePriorities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevicesPriorities(deviceGroupId: string, metricSource: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateDevicesPriorities(deviceGroupId, metricSource, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update email preferences
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;EmailPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateEmailPreference(preferenceId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an onboarding status
         * @param {string} userId 
         * @param {object} body Partial&lt;OnboardingStatus&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnboardingStatus(userId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateOnboardingStatus(userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a subscription
         * @param {string} userId 
         * @param {object} body Partial&lt;Subscription&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(userId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateSubscription(userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user info
         * @param {string} userId 
         * @param {object} body Parital&lt;FirestoreUser&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateUser(userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user devices
         * @param {string} userId 
         * @param {Array<object>} requestBody Array&lt;UserConnectedDevice&gt;
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateUserDevices(userId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateUserDevices(userId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user token
         * @param {string} userId 
         * @param {object} body Partial&lt;FirestoreToken&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserToken(userId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateUserToken(userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify a discount or referral code
         * @param {string} code 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDiscountCode(code: string, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.verifyDiscountCode(code, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Watch a subscription status -- Connect to Stripe
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchStripeSubscriptionStatus(body?: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.watchStripeSubscriptionStatus(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Watch a subscription status -- Connect to RevenueCat
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchSubscriptionStatus(body?: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.watchSubscriptionStatus(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary Apple Sign In OAuth callback endpoint
     * @param {AppleAuthCallbackReq} [appleAuthCallbackReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public appleAuthCallback(appleAuthCallbackReq?: AppleAuthCallbackReq, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).appleAuthCallback(appleAuthCallbackReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a subscription via Stripe
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public cancelStripeSubscription(userId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).cancelStripeSubscription(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check whether JWT access token is still alive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public checkAccessAlive(options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).checkAccessAlive(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Stripe Checkout session for subscriptions
     * @param {string} userId 
     * @param {CreateStripeCheckoutSessionParams} createStripeCheckoutSessionParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public createStripeCheckoutSession(userId: string, createStripeCheckoutSessionParams: CreateStripeCheckoutSessionParams, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).createStripeCheckoutSession(userId, createStripeCheckoutSessionParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a user info
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public deleteUser(userId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exchange or refresh a Google OAuth token on the SPA\'s behalf. The frontend\'s oidc-client-ts UserManager is configured to send its authorization_code and refresh_token grant requests here instead of directly to Google, so the confidential client\'s secret never has to live in browser-bundled code.
     * @param {string} [generatedClientType] oauth generated client type (web, mobile, desktop)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public exchangeGoogleOAuthToken(generatedClientType?: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).exchangeGoogleOAuthToken(generatedClientType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate a new JWT
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public generateJwt(userId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).generateJwt(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate a referral code for the authenticated user
     * @param {string} userId The user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public generateReferralCode(userId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).generateReferralCode(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get available subscriptions
     * @param {string} access Access type: \&quot;beta\&quot; | \&quot;basic\&quot; | \&quot;basic_price_up_202512\&quot;
     * @param {string} [provider] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getAvailableSubscriptions(access: string, provider?: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getAvailableSubscriptions(access, provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of devices
     * @param {string} deviceGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getDevices(deviceGroupId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getDevices(deviceGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get general preference
     * @param {string} preferenceId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getGeneralPreference(preferenceId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getGeneralPreference(preferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all preferences
     * @param {string} preferenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getPreferences(preferenceId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getPreferences(preferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a referral campaign
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getReferralCampaign(campaignId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getReferralCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get subscriptions
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getSubscriptions(userId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getSubscriptions(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a user info
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getUser(userId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get lifetime stats for a user
     * @param {string} userId 
     * @param {string} [metricId] Metric ID (required for health stats)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getUserStats(userId: string, metricId?: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getUserStats(userId, metricId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a user token
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getuserToken(userId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getuserToken(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh an access token
     * @param {string} refresh 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public refreshToken(refresh: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).refreshToken(refresh, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a device
     * @param {string} deviceGroupId 
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public removeDeviceV2(deviceGroupId: string, deviceId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).removeDeviceV2(deviceGroupId, deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a user device
     * @param {string} userId 
     * @param {string} deviceTerraId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public removeUserDevice(userId: string, deviceTerraId: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).removeUserDevice(userId, deviceTerraId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a subscription via Stripe
     * @param {string} userId 
     * @param {RequestSubscriptionPostRes} [requestSubscriptionPostRes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public requestStripeSubscription(userId: string, requestSubscriptionPostRes?: RequestSubscriptionPostRes, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).requestStripeSubscription(userId, requestSubscriptionPostRes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sign in or sign up a user
     * @param {string} userId 
     * @param {boolean} [withJwt] -- deprecated
     * @param {AccountAuthSignInPostReq} [accountAuthSignInPostReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public signIn(userId: string, withJwt?: boolean, accountAuthSignInPostReq?: AccountAuthSignInPostReq, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).signIn(userId, withJwt, accountAuthSignInPostReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Subscribe with skip card (no payment)
     * @param {SubscribeSkipCardSubscriptionParams} subscribeSkipCardSubscriptionParams { userId: string, deviceFrom: \&#39;mobile\&#39; | \&#39;web\&#39;, trialDays: number, offeringId: string, discountId: string }
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public subscribeSkipCardSubscription(subscribeSkipCardSubscriptionParams: SubscribeSkipCardSubscriptionParams, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).subscribeSkipCardSubscription(subscribeSkipCardSubscriptionParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync successful Stripe payment and update subscription in DB
     * @param {string} userId 
     * @param {SyncSuccessStripePaymentParams} syncSuccessStripePaymentParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public syncSuccessStripePayment(userId: string, syncSuccessStripePaymentParams: SyncSuccessStripePaymentParams, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).syncSuccessStripePayment(userId, syncSuccessStripePaymentParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update general preferences
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;GeneralPreference&gt;
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updatGeneralPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updatGeneralPreference(preferenceId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a device
     * @param {string} deviceGroupId 
     * @param {string} deviceId 
     * @param {object} body Partial&lt;FirestoreDevice&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateDeviceV2(deviceGroupId: string, deviceId: string, body: object, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateDeviceV2(deviceGroupId, deviceId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update devices\' priorities
     * @param {string} deviceGroupId 
     * @param {string} metricSource MetricSourceType
     * @param {object} body DevicePriorities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateDevicesPriorities(deviceGroupId: string, metricSource: string, body: object, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateDevicesPriorities(deviceGroupId, metricSource, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update email preferences
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;EmailPreference&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateEmailPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateEmailPreference(preferenceId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an onboarding status
     * @param {string} userId 
     * @param {object} body Partial&lt;OnboardingStatus&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateOnboardingStatus(userId: string, body: object, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateOnboardingStatus(userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a subscription
     * @param {string} userId 
     * @param {object} body Partial&lt;Subscription&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateSubscription(userId: string, body: object, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateSubscription(userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user info
     * @param {string} userId 
     * @param {object} body Parital&lt;FirestoreUser&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateUser(userId: string, body: object, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateUser(userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user devices
     * @param {string} userId 
     * @param {Array<object>} requestBody Array&lt;UserConnectedDevice&gt;
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateUserDevices(userId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateUserDevices(userId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user token
     * @param {string} userId 
     * @param {object} body Partial&lt;FirestoreToken&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateUserToken(userId: string, body: object, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateUserToken(userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify a discount or referral code
     * @param {string} code 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public verifyDiscountCode(code: string, userId?: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).verifyDiscountCode(code, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Watch a subscription status -- Connect to Stripe
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public watchStripeSubscriptionStatus(body?: object, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).watchStripeSubscriptionStatus(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Watch a subscription status -- Connect to RevenueCat
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public watchSubscriptionStatus(body?: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).watchSubscriptionStatus(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalendarApi - axios parameter creator
 * @export
 */
export const CalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search calendar event location suggestions
         * @param {string} q 
         * @param {string} sessionToken 
         * @param {string} [languageCode] 
         * @param {string} [regionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autocompleteCalendarEventLocations: async (q: string, sessionToken: string, languageCode?: string, regionCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('autocompleteCalendarEventLocations', 'q', q)
            // verify required parameter 'sessionToken' is not null or undefined
            assertParamExists('autocompleteCalendarEventLocations', 'sessionToken', sessionToken)
            const localVarPath = `/api/v1/calendar/events/locations/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (sessionToken !== undefined) {
                localVarQueryParameter['sessionToken'] = sessionToken;
            }

            if (languageCode !== undefined) {
                localVarQueryParameter['languageCode'] = languageCode;
            }

            if (regionCode !== undefined) {
                localVarQueryParameter['regionCode'] = regionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a all-day calendar event
         * @param {string} calendarId 
         * @param {string} userId 
         * @param {CalendarEventPostReq} [calendarEventPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAllDayCalendarEvent: async (calendarId: string, userId: string, calendarEventPostReq?: CalendarEventPostReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('createAllDayCalendarEvent', 'calendarId', calendarId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createAllDayCalendarEvent', 'userId', userId)
            const localVarPath = `/api/v1/calendar/events/{calendarId}/allDay`
                .replace(`{${"calendarId"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarEventPostReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a calendar event
         * @param {string} calendarId 
         * @param {string} userId 
         * @param {CalendarEventPostReq} [calendarEventPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarEvent: async (calendarId: string, userId: string, calendarEventPostReq?: CalendarEventPostReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('createCalendarEvent', 'calendarId', calendarId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createCalendarEvent', 'userId', userId)
            const localVarPath = `/api/v1/calendar/events/{calendarId}`
                .replace(`{${"calendarId"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarEventPostReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a calendar event
         * @param {string} userId 
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {boolean} [unSyncToCalendar] 
         * @param {string} [recurringDeleteSpan] \&quot;thisEvent\&quot; | \&quot;allEvents\&quot;. Default: thisEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarEvent: async (userId: string, calendarId: string, eventId: string, unSyncToCalendar?: boolean, recurringDeleteSpan?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteCalendarEvent', 'userId', userId)
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('deleteCalendarEvent', 'calendarId', calendarId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteCalendarEvent', 'eventId', eventId)
            const localVarPath = `/api/v1/calendar/events/{calendarId}/{eventId}`
                .replace(`{${"calendarId"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (unSyncToCalendar !== undefined) {
                localVarQueryParameter['unSyncToCalendar'] = unSyncToCalendar;
            }

            if (recurringDeleteSpan !== undefined) {
                localVarQueryParameter['recurringDeleteSpan'] = recurringDeleteSpan;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exchange or refresh a Google OAuth token for an already signed-in user connecting their Google Calendar. The frontend\'s oidc-client-ts UserManager for calendar connect is configured to send its authorization_code and refresh_token grant requests here (with our own JWT attached) instead of directly to Google, so the confidential client\'s secret never has to live in browser-bundled code.
         * @param {string} [generatedClientType] oauth generated client type (web, mobile, desktop)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeGoogleCalendarOAuthToken: async (generatedClientType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/calendar/auth/google/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (generatedClientType !== undefined) {
                localVarQueryParameter['generatedClientType'] = generatedClientType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exchange outlook token
         * @param {string} userId 
         * @param {string} code 
         * @param {string} redirectUri 
         * @param {string} [version] 
         * @param {Array<string>} [scopes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeOutlookToken: async (userId: string, code: string, redirectUri: string, version?: string, scopes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('exchangeOutlookToken', 'userId', userId)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('exchangeOutlookToken', 'code', code)
            // verify required parameter 'redirectUri' is not null or undefined
            assertParamExists('exchangeOutlookToken', 'redirectUri', redirectUri)
            const localVarPath = `/api/v1/calendar/auth/outlook/exchangeToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirectUri'] = redirectUri;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (scopes) {
                localVarQueryParameter['scopes[]'] = scopes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create energy calendar exported from Lifestack
         * @param {string} userId 
         * @param {string} preferenceId 
         * @param {string} metricId 
         * @param {ExportLifestackCalendarBody} exportLifestackCalendarBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLifestackCalendar: async (userId: string, preferenceId: string, metricId: string, exportLifestackCalendarBody: ExportLifestackCalendarBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('exportLifestackCalendar', 'userId', userId)
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('exportLifestackCalendar', 'preferenceId', preferenceId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('exportLifestackCalendar', 'metricId', metricId)
            // verify required parameter 'exportLifestackCalendarBody' is not null or undefined
            assertParamExists('exportLifestackCalendar', 'exportLifestackCalendarBody', exportLifestackCalendarBody)
            const localVarPath = `/api/v1/calendar/external/energy/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (preferenceId !== undefined) {
                localVarQueryParameter['preferenceId'] = preferenceId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportLifestackCalendarBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate the url to authorize outlook
         * @param {string} redirectUri 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOutlookAuthUrl: async (redirectUri: string, version?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redirectUri' is not null or undefined
            assertParamExists('generateOutlookAuthUrl', 'redirectUri', redirectUri)
            const localVarPath = `/api/v1/calendar/auth/outlook/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirectUri'] = redirectUri;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all-day calendar events
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllDayCalendarEvents: async (userId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAllDayCalendarEvents', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getAllDayCalendarEvents', 'date', date)
            const localVarPath = `/api/v1/calendar/events/allDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all-day calendar events (V2)
         * @param {string} userId 
         * @param {string} startDate start date - isoDate
         * @param {string} endDate end date - isoDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDayCalendarEventsV2: async (userId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAllDayCalendarEventsV2', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getAllDayCalendarEventsV2', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getAllDayCalendarEventsV2', 'endDate', endDate)
            const localVarPath = `/api/v1/calendar/events/allDay/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get calendar accesses
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarAccess: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCalendarAccess', 'userId', userId)
            const localVarPath = `/api/v1/calendar/auth/access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get calendar events
         * @param {string} userId 
         * @param {string} [startDate] start date - isoDate
         * @param {string} [endDate] end date - isoDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEvents: async (userId: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCalendarEvents', 'userId', userId)
            const localVarPath = `/api/v1/calendar/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get events in each ciradian phase
         * @param {Array<string>} calendarIds 
         * @param {string} date date - YYYY-MM-DD
         * @param {string} metricId 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventsForPhases: async (calendarIds: Array<string>, date: string, metricId: string, timezone: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarIds' is not null or undefined
            assertParamExists('getCalendarEventsForPhases', 'calendarIds', calendarIds)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getCalendarEventsForPhases', 'date', date)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getCalendarEventsForPhases', 'metricId', metricId)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('getCalendarEventsForPhases', 'timezone', timezone)
            const localVarPath = `/api/v1/calendar/events/phase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (calendarIds) {
                localVarQueryParameter['calendarIds[]'] = calendarIds;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get calendar preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCalendarPreference: async (preferenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('getCalendarPreference', 'preferenceId', preferenceId)
            const localVarPath = `/api/v1/calendar/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all calendars
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarsInfo: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCalendarsInfo', 'userId', userId)
            const localVarPath = `/api/v1/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get daily event trend
         * @param {string} dataTrendId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyEventTrend: async (dataTrendId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getDailyEventTrend', 'dataTrendId', dataTrendId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getDailyEventTrend', 'date', date)
            const localVarPath = `/api/v1/calendar/trend/{dataTrendId}/daily`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get visible calendar events
         * @param {string} userId 
         * @param {string} startDate start date - isoDate
         * @param {string} endDate end date - isoDate
         * @param {boolean} [includeAvailableEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisibleCalendarEvents: async (userId: string, startDate: string, endDate: string, includeAvailableEvent?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getVisibleCalendarEvents', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getVisibleCalendarEvents', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getVisibleCalendarEvents', 'endDate', endDate)
            const localVarPath = `/api/v1/calendar/events/visible`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (includeAvailableEvent !== undefined) {
                localVarQueryParameter['includeAvailableEvent'] = includeAvailableEvent;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get weekly event trend
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyEventTrend: async (dataTrendId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getWeeklyEventTrend', 'dataTrendId', dataTrendId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getWeeklyEventTrend', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getWeeklyEventTrend', 'endDate', endDate)
            const localVarPath = `/api/v1/calendar/trend/{dataTrendId}/weekly`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Google Calendar push notification receiver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleGoogleCalendarWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/calendar/webhook/google/receive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove calendars
         * @param {string} userId 
         * @param {RemoveCalendarsInfoBody} removeCalendarsInfoBody Calendar Ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCalendarsInfo: async (userId: string, removeCalendarsInfoBody: RemoveCalendarsInfoBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeCalendarsInfo', 'userId', userId)
            // verify required parameter 'removeCalendarsInfoBody' is not null or undefined
            assertParamExists('removeCalendarsInfo', 'removeCalendarsInfoBody', removeCalendarsInfoBody)
            const localVarPath = `/api/v1/calendar/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeCalendarsInfoBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Respond to a meeting invitation
         * @param {string} userId 
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {CalendarEventRespondReq} calendarEventRespondReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondCalendarEvent: async (userId: string, calendarId: string, eventId: string, calendarEventRespondReq: CalendarEventRespondReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('respondCalendarEvent', 'userId', userId)
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('respondCalendarEvent', 'calendarId', calendarId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('respondCalendarEvent', 'eventId', eventId)
            // verify required parameter 'calendarEventRespondReq' is not null or undefined
            assertParamExists('respondCalendarEvent', 'calendarEventRespondReq', calendarEventRespondReq)
            const localVarPath = `/api/v1/calendar/events/{calendarId}/{eventId}/respond`
                .replace(`{${"calendarId"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarEventRespondReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Subscribe Google Calendar watch channel for a calendar
         * @param {CalendarWebhookSubscribeReq} calendarWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeGoogleCalendarWatch: async (calendarWebhookSubscribeReq: CalendarWebhookSubscribeReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarWebhookSubscribeReq' is not null or undefined
            assertParamExists('subscribeGoogleCalendarWatch', 'calendarWebhookSubscribeReq', calendarWebhookSubscribeReq)
            const localVarPath = `/api/v1/calendar/webhook/google/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarWebhookSubscribeReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Subscribe Outlook Calendar webhook for a calendar
         * @param {CalendarWebhookSubscribeReq} calendarWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeOutlookCalendarWatch: async (calendarWebhookSubscribeReq: CalendarWebhookSubscribeReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarWebhookSubscribeReq' is not null or undefined
            assertParamExists('subscribeOutlookCalendarWatch', 'calendarWebhookSubscribeReq', calendarWebhookSubscribeReq)
            const localVarPath = `/api/v1/calendar/webhook/outlook/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarWebhookSubscribeReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Apple Calendar list and events
         * @param {string} uid 
         * @param {string} startTime Start time for event sync filtering (ISO string)
         * @param {string} endTime End time for event sync filtering (ISO string)
         * @param {AppleCalendarSyncReq} appleCalendarSyncReq Apple calendars data with events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAppleCalendarsList: async (uid: string, startTime: string, endTime: string, appleCalendarSyncReq: AppleCalendarSyncReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('syncAppleCalendarsList', 'uid', uid)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('syncAppleCalendarsList', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('syncAppleCalendarsList', 'endTime', endTime)
            // verify required parameter 'appleCalendarSyncReq' is not null or undefined
            assertParamExists('syncAppleCalendarsList', 'appleCalendarSyncReq', appleCalendarSyncReq)
            const localVarPath = `/api/v1/calendar/list/sync/apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appleCalendarSyncReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync calendar events
         * @param {string} userId 
         * @param {string} startTime start time - isoDate
         * @param {string} endTime end time - isoDate
         * @param {Array<string>} calendarIds 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        syncCalendarEvents: async (userId: string, startTime: string, endTime: string, calendarIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('syncCalendarEvents', 'userId', userId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('syncCalendarEvents', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('syncCalendarEvents', 'endTime', endTime)
            // verify required parameter 'calendarIds' is not null or undefined
            assertParamExists('syncCalendarEvents', 'calendarIds', calendarIds)
            const localVarPath = `/api/v1/calendar/events/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (calendarIds) {
                localVarQueryParameter['calendarIds[]'] = calendarIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Google Calendar list
         * @param {string} uid 
         * @param {string} rootEmail 
         * @param {CalendarListSyncGCalReq} [calendarListSyncGCalReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGCalendarsList: async (uid: string, rootEmail: string, calendarListSyncGCalReq?: CalendarListSyncGCalReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('syncGCalendarsList', 'uid', uid)
            // verify required parameter 'rootEmail' is not null or undefined
            assertParamExists('syncGCalendarsList', 'rootEmail', rootEmail)
            const localVarPath = `/api/v1/calendar/list/sync/gcal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            if (rootEmail !== undefined) {
                localVarQueryParameter['rootEmail'] = rootEmail;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarListSyncGCalReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Google Calendar events (full list)
         * @param {string} startTime start time - isoDate
         * @param {string} endTime end time - isoDate
         * @param {CalendarSyncBody} calendarSyncBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGoogleCalendarEvents: async (startTime: string, endTime: string, calendarSyncBody: CalendarSyncBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('syncGoogleCalendarEvents', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('syncGoogleCalendarEvents', 'endTime', endTime)
            // verify required parameter 'calendarSyncBody' is not null or undefined
            assertParamExists('syncGoogleCalendarEvents', 'calendarSyncBody', calendarSyncBody)
            const localVarPath = `/api/v1/calendar/events/sync/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarSyncBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Outlook Calendar events (full list)
         * @param {string} startTime start time - isoDate
         * @param {string} endTime end time - isoDate
         * @param {CalendarSyncBody} calendarSyncBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOutlookCalendarEvents: async (startTime: string, endTime: string, calendarSyncBody: CalendarSyncBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('syncOutlookCalendarEvents', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('syncOutlookCalendarEvents', 'endTime', endTime)
            // verify required parameter 'calendarSyncBody' is not null or undefined
            assertParamExists('syncOutlookCalendarEvents', 'calendarSyncBody', calendarSyncBody)
            const localVarPath = `/api/v1/calendar/events/sync/outlook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarSyncBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Outlook Calendar list
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        syncOutlookCalendarList: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('syncOutlookCalendarList', 'uid', uid)
            const localVarPath = `/api/v1/calendar/list/sync/outlook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Outlook Calendar list V2
         * @param {string} uid 
         * @param {string} rootEmail Outlook root email
         * @param {CalendarListSyncGCalReq} [calendarListSyncGCalReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOutlookCalendarListV2: async (uid: string, rootEmail: string, calendarListSyncGCalReq?: CalendarListSyncGCalReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('syncOutlookCalendarListV2', 'uid', uid)
            // verify required parameter 'rootEmail' is not null or undefined
            assertParamExists('syncOutlookCalendarListV2', 'rootEmail', rootEmail)
            const localVarPath = `/api/v1/calendar/list/sync/outlook/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            if (rootEmail !== undefined) {
                localVarQueryParameter['rootEmail'] = rootEmail;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarListSyncGCalReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update preferences for calendar
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;CalendarPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatCalendarPreference: async (preferenceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updatCalendarPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updatCalendarPreference', 'body', body)
            const localVarPath = `/api/v1/calendar/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a calendar event
         * @param {string} userId 
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {object} body Partial&lt;CalendarEvent&gt;
         * @param {string} [recurringUpdateSpan] \&quot;thisEvent\&quot; | \&quot;allEvents\&quot;. Default: thisEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarEvent: async (userId: string, calendarId: string, eventId: string, body: object, recurringUpdateSpan?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateCalendarEvent', 'userId', userId)
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('updateCalendarEvent', 'calendarId', calendarId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateCalendarEvent', 'eventId', eventId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCalendarEvent', 'body', body)
            const localVarPath = `/api/v1/calendar/events/{calendarId}/{eventId}`
                .replace(`{${"calendarId"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (recurringUpdateSpan !== undefined) {
                localVarQueryParameter['recurringUpdateSpan'] = recurringUpdateSpan;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update EMA energy for a calendar event
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {object} body CalendarEventMetrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarEventEnergy: async (calendarId: string, eventId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('updateCalendarEventEnergy', 'calendarId', calendarId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateCalendarEventEnergy', 'eventId', eventId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCalendarEventEnergy', 'body', body)
            const localVarPath = `/api/v1/calendar/events/{calendarId}/{eventId}/energy`
                .replace(`{${"calendarId"}}`, encodeURIComponent(String(calendarId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a calendar info
         * @param {string} calendarId 
         * @param {object} body Partial&lt;FirestoreCalendar&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarInfo: async (calendarId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('updateCalendarInfo', 'calendarId', calendarId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCalendarInfo', 'body', body)
            const localVarPath = `/api/v1/calendar/{calendarId}`
                .replace(`{${"calendarId"}}`, encodeURIComponent(String(calendarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update exported calendar events
         * @param {string} userId 
         * @param {string} metricId 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExportedCalendarEvents: async (userId: string, metricId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateExportedCalendarEvents', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('updateExportedCalendarEvents', 'metricId', metricId)
            const localVarPath = `/api/v1/calendar/external/energy/events/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update energy calendar settings
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;ExportedCalendar&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExportedCalendarPreference: async (preferenceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updateExportedCalendarPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateExportedCalendarPreference', 'body', body)
            const localVarPath = `/api/v1/calendar/external/energy/preference/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preferenceId !== undefined) {
                localVarQueryParameter['preferenceId'] = preferenceId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarApi - functional programming interface
 * @export
 */
export const CalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Search calendar event location suggestions
         * @param {string} q 
         * @param {string} sessionToken 
         * @param {string} [languageCode] 
         * @param {string} [regionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autocompleteCalendarEventLocations(q: string, sessionToken: string, languageCode?: string, regionCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventLocationAutocompleteRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autocompleteCalendarEventLocations(q, sessionToken, languageCode, regionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.autocompleteCalendarEventLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a all-day calendar event
         * @param {string} calendarId 
         * @param {string} userId 
         * @param {CalendarEventPostReq} [calendarEventPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAllDayCalendarEvent(calendarId: string, userId: string, calendarEventPostReq?: CalendarEventPostReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAllDayCalendarEvent(calendarId, userId, calendarEventPostReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.createAllDayCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a calendar event
         * @param {string} calendarId 
         * @param {string} userId 
         * @param {CalendarEventPostReq} [calendarEventPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalendarEvent(calendarId: string, userId: string, calendarEventPostReq?: CalendarEventPostReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarEvent(calendarId, userId, calendarEventPostReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.createCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a calendar event
         * @param {string} userId 
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {boolean} [unSyncToCalendar] 
         * @param {string} [recurringDeleteSpan] \&quot;thisEvent\&quot; | \&quot;allEvents\&quot;. Default: thisEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalendarEvent(userId: string, calendarId: string, eventId: string, unSyncToCalendar?: boolean, recurringDeleteSpan?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCalendarEvent(userId, calendarId, eventId, unSyncToCalendar, recurringDeleteSpan, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.deleteCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Exchange or refresh a Google OAuth token for an already signed-in user connecting their Google Calendar. The frontend\'s oidc-client-ts UserManager for calendar connect is configured to send its authorization_code and refresh_token grant requests here (with our own JWT attached) instead of directly to Google, so the confidential client\'s secret never has to live in browser-bundled code.
         * @param {string} [generatedClientType] oauth generated client type (web, mobile, desktop)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeGoogleCalendarOAuthToken(generatedClientType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeGoogleCalendarOAuthToken(generatedClientType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.exchangeGoogleCalendarOAuthToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Exchange outlook token
         * @param {string} userId 
         * @param {string} code 
         * @param {string} redirectUri 
         * @param {string} [version] 
         * @param {Array<string>} [scopes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeOutlookToken(userId: string, code: string, redirectUri: string, version?: string, scopes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarOutlookAuthTokenRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeOutlookToken(userId, code, redirectUri, version, scopes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.exchangeOutlookToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create energy calendar exported from Lifestack
         * @param {string} userId 
         * @param {string} preferenceId 
         * @param {string} metricId 
         * @param {ExportLifestackCalendarBody} exportLifestackCalendarBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportLifestackCalendar(userId: string, preferenceId: string, metricId: string, exportLifestackCalendarBody: ExportLifestackCalendarBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportLifestackCalendar(userId, preferenceId, metricId, exportLifestackCalendarBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.exportLifestackCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate the url to authorize outlook
         * @param {string} redirectUri 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOutlookAuthUrl(redirectUri: string, version?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOutlookAuthUrl(redirectUri, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.generateOutlookAuthUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all-day calendar events
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getAllDayCalendarEvents(userId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDayCalendarEvents(userId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getAllDayCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all-day calendar events (V2)
         * @param {string} userId 
         * @param {string} startDate start date - isoDate
         * @param {string} endDate end date - isoDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDayCalendarEventsV2(userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDayCalendarEventsV2(userId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getAllDayCalendarEventsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get calendar accesses
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarAccess(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarWithAccess>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarAccess(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getCalendarAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get calendar events
         * @param {string} userId 
         * @param {string} [startDate] start date - isoDate
         * @param {string} [endDate] end date - isoDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarEvents(userId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarEvents(userId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get events in each ciradian phase
         * @param {Array<string>} calendarIds 
         * @param {string} date date - YYYY-MM-DD
         * @param {string} metricId 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarEventsForPhases(calendarIds: Array<string>, date: string, metricId: string, timezone: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarEventsForPhases(calendarIds, date, metricId, timezone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getCalendarEventsForPhases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get calendar preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getCalendarPreference(preferenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarPreference(preferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getCalendarPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all calendars
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarsInfo(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarsInfo(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getCalendarsInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get daily event trend
         * @param {string} dataTrendId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyEventTrend(dataTrendId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyEventTrend(dataTrendId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getDailyEventTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get visible calendar events
         * @param {string} userId 
         * @param {string} startDate start date - isoDate
         * @param {string} endDate end date - isoDate
         * @param {boolean} [includeAvailableEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisibleCalendarEvents(userId: string, startDate: string, endDate: string, includeAvailableEvent?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisibleCalendarEvents(userId, startDate, endDate, includeAvailableEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getVisibleCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get weekly event trend
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyEventTrend(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDataTrendWeeklyRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyEventTrend(dataTrendId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getWeeklyEventTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Google Calendar push notification receiver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleGoogleCalendarWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleGoogleCalendarWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.handleGoogleCalendarWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove calendars
         * @param {string} userId 
         * @param {RemoveCalendarsInfoBody} removeCalendarsInfoBody Calendar Ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCalendarsInfo(userId: string, removeCalendarsInfoBody: RemoveCalendarsInfoBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCalendarsInfo(userId, removeCalendarsInfoBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.removeCalendarsInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Respond to a meeting invitation
         * @param {string} userId 
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {CalendarEventRespondReq} calendarEventRespondReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondCalendarEvent(userId: string, calendarId: string, eventId: string, calendarEventRespondReq: CalendarEventRespondReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondCalendarEvent(userId, calendarId, eventId, calendarEventRespondReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.respondCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Subscribe Google Calendar watch channel for a calendar
         * @param {CalendarWebhookSubscribeReq} calendarWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeGoogleCalendarWatch(calendarWebhookSubscribeReq: CalendarWebhookSubscribeReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeGoogleCalendarWatch(calendarWebhookSubscribeReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.subscribeGoogleCalendarWatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Subscribe Outlook Calendar webhook for a calendar
         * @param {CalendarWebhookSubscribeReq} calendarWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeOutlookCalendarWatch(calendarWebhookSubscribeReq: CalendarWebhookSubscribeReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeOutlookCalendarWatch(calendarWebhookSubscribeReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.subscribeOutlookCalendarWatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Apple Calendar list and events
         * @param {string} uid 
         * @param {string} startTime Start time for event sync filtering (ISO string)
         * @param {string} endTime End time for event sync filtering (ISO string)
         * @param {AppleCalendarSyncReq} appleCalendarSyncReq Apple calendars data with events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAppleCalendarsList(uid: string, startTime: string, endTime: string, appleCalendarSyncReq: AppleCalendarSyncReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAppleCalendarsList(uid, startTime, endTime, appleCalendarSyncReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncAppleCalendarsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync calendar events
         * @param {string} userId 
         * @param {string} startTime start time - isoDate
         * @param {string} endTime end time - isoDate
         * @param {Array<string>} calendarIds 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async syncCalendarEvents(userId: string, startTime: string, endTime: string, calendarIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEventsSyncRes>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncCalendarEvents(userId, startTime, endTime, calendarIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Google Calendar list
         * @param {string} uid 
         * @param {string} rootEmail 
         * @param {CalendarListSyncGCalReq} [calendarListSyncGCalReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncGCalendarsList(uid: string, rootEmail: string, calendarListSyncGCalReq?: CalendarListSyncGCalReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncGCalendarsList(uid, rootEmail, calendarListSyncGCalReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncGCalendarsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Google Calendar events (full list)
         * @param {string} startTime start time - isoDate
         * @param {string} endTime end time - isoDate
         * @param {CalendarSyncBody} calendarSyncBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncGoogleCalendarEvents(startTime: string, endTime: string, calendarSyncBody: CalendarSyncBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncGoogleCalendarEvents(startTime, endTime, calendarSyncBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncGoogleCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Outlook Calendar events (full list)
         * @param {string} startTime start time - isoDate
         * @param {string} endTime end time - isoDate
         * @param {CalendarSyncBody} calendarSyncBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncOutlookCalendarEvents(startTime: string, endTime: string, calendarSyncBody: CalendarSyncBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncOutlookCalendarEvents(startTime, endTime, calendarSyncBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncOutlookCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Outlook Calendar list
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async syncOutlookCalendarList(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncOutlookCalendarList(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncOutlookCalendarList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Outlook Calendar list V2
         * @param {string} uid 
         * @param {string} rootEmail Outlook root email
         * @param {CalendarListSyncGCalReq} [calendarListSyncGCalReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncOutlookCalendarListV2(uid: string, rootEmail: string, calendarListSyncGCalReq?: CalendarListSyncGCalReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncOutlookCalendarListV2(uid, rootEmail, calendarListSyncGCalReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncOutlookCalendarListV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update preferences for calendar
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;CalendarPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatCalendarPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatCalendarPreference(preferenceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.updatCalendarPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a calendar event
         * @param {string} userId 
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {object} body Partial&lt;CalendarEvent&gt;
         * @param {string} [recurringUpdateSpan] \&quot;thisEvent\&quot; | \&quot;allEvents\&quot;. Default: thisEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendarEvent(userId: string, calendarId: string, eventId: string, body: object, recurringUpdateSpan?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarEvent(userId, calendarId, eventId, body, recurringUpdateSpan, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.updateCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update EMA energy for a calendar event
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {object} body CalendarEventMetrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendarEventEnergy(calendarId: string, eventId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarEventEnergy(calendarId, eventId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.updateCalendarEventEnergy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a calendar info
         * @param {string} calendarId 
         * @param {object} body Partial&lt;FirestoreCalendar&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendarInfo(calendarId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarInfo(calendarId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.updateCalendarInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update exported calendar events
         * @param {string} userId 
         * @param {string} metricId 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExportedCalendarEvents(userId: string, metricId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExportedCalendarEvents(userId, metricId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.updateExportedCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update energy calendar settings
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;ExportedCalendar&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExportedCalendarPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExportedCalendarPreference(preferenceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.updateExportedCalendarPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalendarApi - factory interface
 * @export
 */
export const CalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalendarApiFp(configuration)
    return {
        /**
         * 
         * @summary Search calendar event location suggestions
         * @param {string} q 
         * @param {string} sessionToken 
         * @param {string} [languageCode] 
         * @param {string} [regionCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autocompleteCalendarEventLocations(q: string, sessionToken: string, languageCode?: string, regionCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventLocationAutocompleteRes> {
            return localVarFp.autocompleteCalendarEventLocations(q, sessionToken, languageCode, regionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a all-day calendar event
         * @param {string} calendarId 
         * @param {string} userId 
         * @param {CalendarEventPostReq} [calendarEventPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAllDayCalendarEvent(calendarId: string, userId: string, calendarEventPostReq?: CalendarEventPostReq, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.createAllDayCalendarEvent(calendarId, userId, calendarEventPostReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a calendar event
         * @param {string} calendarId 
         * @param {string} userId 
         * @param {CalendarEventPostReq} [calendarEventPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarEvent(calendarId: string, userId: string, calendarEventPostReq?: CalendarEventPostReq, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.createCalendarEvent(calendarId, userId, calendarEventPostReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a calendar event
         * @param {string} userId 
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {boolean} [unSyncToCalendar] 
         * @param {string} [recurringDeleteSpan] \&quot;thisEvent\&quot; | \&quot;allEvents\&quot;. Default: thisEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarEvent(userId: string, calendarId: string, eventId: string, unSyncToCalendar?: boolean, recurringDeleteSpan?: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.deleteCalendarEvent(userId, calendarId, eventId, unSyncToCalendar, recurringDeleteSpan, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exchange or refresh a Google OAuth token for an already signed-in user connecting their Google Calendar. The frontend\'s oidc-client-ts UserManager for calendar connect is configured to send its authorization_code and refresh_token grant requests here (with our own JWT attached) instead of directly to Google, so the confidential client\'s secret never has to live in browser-bundled code.
         * @param {string} [generatedClientType] oauth generated client type (web, mobile, desktop)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeGoogleCalendarOAuthToken(generatedClientType?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.exchangeGoogleCalendarOAuthToken(generatedClientType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exchange outlook token
         * @param {string} userId 
         * @param {string} code 
         * @param {string} redirectUri 
         * @param {string} [version] 
         * @param {Array<string>} [scopes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeOutlookToken(userId: string, code: string, redirectUri: string, version?: string, scopes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<CalendarOutlookAuthTokenRes> {
            return localVarFp.exchangeOutlookToken(userId, code, redirectUri, version, scopes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create energy calendar exported from Lifestack
         * @param {string} userId 
         * @param {string} preferenceId 
         * @param {string} metricId 
         * @param {ExportLifestackCalendarBody} exportLifestackCalendarBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLifestackCalendar(userId: string, preferenceId: string, metricId: string, exportLifestackCalendarBody: ExportLifestackCalendarBody, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.exportLifestackCalendar(userId, preferenceId, metricId, exportLifestackCalendarBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate the url to authorize outlook
         * @param {string} redirectUri 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOutlookAuthUrl(redirectUri: string, version?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generateOutlookAuthUrl(redirectUri, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all-day calendar events
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllDayCalendarEvents(userId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getAllDayCalendarEvents(userId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all-day calendar events (V2)
         * @param {string} userId 
         * @param {string} startDate start date - isoDate
         * @param {string} endDate end date - isoDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDayCalendarEventsV2(userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getAllDayCalendarEventsV2(userId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get calendar accesses
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarAccess(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarWithAccess>> {
            return localVarFp.getCalendarAccess(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get calendar events
         * @param {string} userId 
         * @param {string} [startDate] start date - isoDate
         * @param {string} [endDate] end date - isoDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEvents(userId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getCalendarEvents(userId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get events in each ciradian phase
         * @param {Array<string>} calendarIds 
         * @param {string} date date - YYYY-MM-DD
         * @param {string} metricId 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventsForPhases(calendarIds: Array<string>, date: string, metricId: string, timezone: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getCalendarEventsForPhases(calendarIds, date, metricId, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get calendar preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCalendarPreference(preferenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getCalendarPreference(preferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all calendars
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarsInfo(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getCalendarsInfo(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get daily event trend
         * @param {string} dataTrendId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyEventTrend(dataTrendId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getDailyEventTrend(dataTrendId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get visible calendar events
         * @param {string} userId 
         * @param {string} startDate start date - isoDate
         * @param {string} endDate end date - isoDate
         * @param {boolean} [includeAvailableEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisibleCalendarEvents(userId: string, startDate: string, endDate: string, includeAvailableEvent?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getVisibleCalendarEvents(userId, startDate, endDate, includeAvailableEvent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get weekly event trend
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyEventTrend(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<EventDataTrendWeeklyRes> {
            return localVarFp.getWeeklyEventTrend(dataTrendId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Google Calendar push notification receiver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleGoogleCalendarWebhook(options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.handleGoogleCalendarWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove calendars
         * @param {string} userId 
         * @param {RemoveCalendarsInfoBody} removeCalendarsInfoBody Calendar Ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCalendarsInfo(userId: string, removeCalendarsInfoBody: RemoveCalendarsInfoBody, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.removeCalendarsInfo(userId, removeCalendarsInfoBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Respond to a meeting invitation
         * @param {string} userId 
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {CalendarEventRespondReq} calendarEventRespondReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondCalendarEvent(userId: string, calendarId: string, eventId: string, calendarEventRespondReq: CalendarEventRespondReq, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.respondCalendarEvent(userId, calendarId, eventId, calendarEventRespondReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Subscribe Google Calendar watch channel for a calendar
         * @param {CalendarWebhookSubscribeReq} calendarWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeGoogleCalendarWatch(calendarWebhookSubscribeReq: CalendarWebhookSubscribeReq, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.subscribeGoogleCalendarWatch(calendarWebhookSubscribeReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Subscribe Outlook Calendar webhook for a calendar
         * @param {CalendarWebhookSubscribeReq} calendarWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeOutlookCalendarWatch(calendarWebhookSubscribeReq: CalendarWebhookSubscribeReq, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.subscribeOutlookCalendarWatch(calendarWebhookSubscribeReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Apple Calendar list and events
         * @param {string} uid 
         * @param {string} startTime Start time for event sync filtering (ISO string)
         * @param {string} endTime End time for event sync filtering (ISO string)
         * @param {AppleCalendarSyncReq} appleCalendarSyncReq Apple calendars data with events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAppleCalendarsList(uid: string, startTime: string, endTime: string, appleCalendarSyncReq: AppleCalendarSyncReq, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.syncAppleCalendarsList(uid, startTime, endTime, appleCalendarSyncReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync calendar events
         * @param {string} userId 
         * @param {string} startTime start time - isoDate
         * @param {string} endTime end time - isoDate
         * @param {Array<string>} calendarIds 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        syncCalendarEvents(userId: string, startTime: string, endTime: string, calendarIds: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarEventsSyncRes>> {
            return localVarFp.syncCalendarEvents(userId, startTime, endTime, calendarIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Google Calendar list
         * @param {string} uid 
         * @param {string} rootEmail 
         * @param {CalendarListSyncGCalReq} [calendarListSyncGCalReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGCalendarsList(uid: string, rootEmail: string, calendarListSyncGCalReq?: CalendarListSyncGCalReq, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.syncGCalendarsList(uid, rootEmail, calendarListSyncGCalReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Google Calendar events (full list)
         * @param {string} startTime start time - isoDate
         * @param {string} endTime end time - isoDate
         * @param {CalendarSyncBody} calendarSyncBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGoogleCalendarEvents(startTime: string, endTime: string, calendarSyncBody: CalendarSyncBody, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.syncGoogleCalendarEvents(startTime, endTime, calendarSyncBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Outlook Calendar events (full list)
         * @param {string} startTime start time - isoDate
         * @param {string} endTime end time - isoDate
         * @param {CalendarSyncBody} calendarSyncBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOutlookCalendarEvents(startTime: string, endTime: string, calendarSyncBody: CalendarSyncBody, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.syncOutlookCalendarEvents(startTime, endTime, calendarSyncBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Outlook Calendar list
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        syncOutlookCalendarList(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.syncOutlookCalendarList(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Outlook Calendar list V2
         * @param {string} uid 
         * @param {string} rootEmail Outlook root email
         * @param {CalendarListSyncGCalReq} [calendarListSyncGCalReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOutlookCalendarListV2(uid: string, rootEmail: string, calendarListSyncGCalReq?: CalendarListSyncGCalReq, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.syncOutlookCalendarListV2(uid, rootEmail, calendarListSyncGCalReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update preferences for calendar
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;CalendarPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatCalendarPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updatCalendarPreference(preferenceId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a calendar event
         * @param {string} userId 
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {object} body Partial&lt;CalendarEvent&gt;
         * @param {string} [recurringUpdateSpan] \&quot;thisEvent\&quot; | \&quot;allEvents\&quot;. Default: thisEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarEvent(userId: string, calendarId: string, eventId: string, body: object, recurringUpdateSpan?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateCalendarEvent(userId, calendarId, eventId, body, recurringUpdateSpan, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update EMA energy for a calendar event
         * @param {string} calendarId 
         * @param {string} eventId 
         * @param {object} body CalendarEventMetrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarEventEnergy(calendarId: string, eventId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateCalendarEventEnergy(calendarId, eventId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a calendar info
         * @param {string} calendarId 
         * @param {object} body Partial&lt;FirestoreCalendar&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarInfo(calendarId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateCalendarInfo(calendarId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update exported calendar events
         * @param {string} userId 
         * @param {string} metricId 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExportedCalendarEvents(userId: string, metricId: string, body?: object, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.updateExportedCalendarEvents(userId, metricId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update energy calendar settings
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;ExportedCalendar&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExportedCalendarPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateExportedCalendarPreference(preferenceId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarApi - object-oriented interface
 * @export
 * @class CalendarApi
 * @extends {BaseAPI}
 */
export class CalendarApi extends BaseAPI {
    /**
     * 
     * @summary Search calendar event location suggestions
     * @param {string} q 
     * @param {string} sessionToken 
     * @param {string} [languageCode] 
     * @param {string} [regionCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public autocompleteCalendarEventLocations(q: string, sessionToken: string, languageCode?: string, regionCode?: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).autocompleteCalendarEventLocations(q, sessionToken, languageCode, regionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a all-day calendar event
     * @param {string} calendarId 
     * @param {string} userId 
     * @param {CalendarEventPostReq} [calendarEventPostReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public createAllDayCalendarEvent(calendarId: string, userId: string, calendarEventPostReq?: CalendarEventPostReq, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).createAllDayCalendarEvent(calendarId, userId, calendarEventPostReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a calendar event
     * @param {string} calendarId 
     * @param {string} userId 
     * @param {CalendarEventPostReq} [calendarEventPostReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public createCalendarEvent(calendarId: string, userId: string, calendarEventPostReq?: CalendarEventPostReq, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).createCalendarEvent(calendarId, userId, calendarEventPostReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a calendar event
     * @param {string} userId 
     * @param {string} calendarId 
     * @param {string} eventId 
     * @param {boolean} [unSyncToCalendar] 
     * @param {string} [recurringDeleteSpan] \&quot;thisEvent\&quot; | \&quot;allEvents\&quot;. Default: thisEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public deleteCalendarEvent(userId: string, calendarId: string, eventId: string, unSyncToCalendar?: boolean, recurringDeleteSpan?: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).deleteCalendarEvent(userId, calendarId, eventId, unSyncToCalendar, recurringDeleteSpan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exchange or refresh a Google OAuth token for an already signed-in user connecting their Google Calendar. The frontend\'s oidc-client-ts UserManager for calendar connect is configured to send its authorization_code and refresh_token grant requests here (with our own JWT attached) instead of directly to Google, so the confidential client\'s secret never has to live in browser-bundled code.
     * @param {string} [generatedClientType] oauth generated client type (web, mobile, desktop)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public exchangeGoogleCalendarOAuthToken(generatedClientType?: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).exchangeGoogleCalendarOAuthToken(generatedClientType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exchange outlook token
     * @param {string} userId 
     * @param {string} code 
     * @param {string} redirectUri 
     * @param {string} [version] 
     * @param {Array<string>} [scopes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public exchangeOutlookToken(userId: string, code: string, redirectUri: string, version?: string, scopes?: Array<string>, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).exchangeOutlookToken(userId, code, redirectUri, version, scopes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create energy calendar exported from Lifestack
     * @param {string} userId 
     * @param {string} preferenceId 
     * @param {string} metricId 
     * @param {ExportLifestackCalendarBody} exportLifestackCalendarBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public exportLifestackCalendar(userId: string, preferenceId: string, metricId: string, exportLifestackCalendarBody: ExportLifestackCalendarBody, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).exportLifestackCalendar(userId, preferenceId, metricId, exportLifestackCalendarBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate the url to authorize outlook
     * @param {string} redirectUri 
     * @param {string} [version] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public generateOutlookAuthUrl(redirectUri: string, version?: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).generateOutlookAuthUrl(redirectUri, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all-day calendar events
     * @param {string} userId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getAllDayCalendarEvents(userId: string, date: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getAllDayCalendarEvents(userId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all-day calendar events (V2)
     * @param {string} userId 
     * @param {string} startDate start date - isoDate
     * @param {string} endDate end date - isoDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getAllDayCalendarEventsV2(userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getAllDayCalendarEventsV2(userId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get calendar accesses
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getCalendarAccess(userId: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getCalendarAccess(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get calendar events
     * @param {string} userId 
     * @param {string} [startDate] start date - isoDate
     * @param {string} [endDate] end date - isoDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getCalendarEvents(userId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getCalendarEvents(userId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get events in each ciradian phase
     * @param {Array<string>} calendarIds 
     * @param {string} date date - YYYY-MM-DD
     * @param {string} metricId 
     * @param {string} timezone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getCalendarEventsForPhases(calendarIds: Array<string>, date: string, metricId: string, timezone: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getCalendarEventsForPhases(calendarIds, date, metricId, timezone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get calendar preference
     * @param {string} preferenceId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getCalendarPreference(preferenceId: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getCalendarPreference(preferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all calendars
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getCalendarsInfo(userId: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getCalendarsInfo(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get daily event trend
     * @param {string} dataTrendId 
     * @param {string} date YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getDailyEventTrend(dataTrendId: string, date: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getDailyEventTrend(dataTrendId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get visible calendar events
     * @param {string} userId 
     * @param {string} startDate start date - isoDate
     * @param {string} endDate end date - isoDate
     * @param {boolean} [includeAvailableEvent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getVisibleCalendarEvents(userId: string, startDate: string, endDate: string, includeAvailableEvent?: boolean, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getVisibleCalendarEvents(userId, startDate, endDate, includeAvailableEvent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get weekly event trend
     * @param {string} dataTrendId 
     * @param {string} startDate YYYY-MM-DD
     * @param {string} endDate YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getWeeklyEventTrend(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getWeeklyEventTrend(dataTrendId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Google Calendar push notification receiver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public handleGoogleCalendarWebhook(options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).handleGoogleCalendarWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove calendars
     * @param {string} userId 
     * @param {RemoveCalendarsInfoBody} removeCalendarsInfoBody Calendar Ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public removeCalendarsInfo(userId: string, removeCalendarsInfoBody: RemoveCalendarsInfoBody, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).removeCalendarsInfo(userId, removeCalendarsInfoBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Respond to a meeting invitation
     * @param {string} userId 
     * @param {string} calendarId 
     * @param {string} eventId 
     * @param {CalendarEventRespondReq} calendarEventRespondReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public respondCalendarEvent(userId: string, calendarId: string, eventId: string, calendarEventRespondReq: CalendarEventRespondReq, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).respondCalendarEvent(userId, calendarId, eventId, calendarEventRespondReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Subscribe Google Calendar watch channel for a calendar
     * @param {CalendarWebhookSubscribeReq} calendarWebhookSubscribeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public subscribeGoogleCalendarWatch(calendarWebhookSubscribeReq: CalendarWebhookSubscribeReq, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).subscribeGoogleCalendarWatch(calendarWebhookSubscribeReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Subscribe Outlook Calendar webhook for a calendar
     * @param {CalendarWebhookSubscribeReq} calendarWebhookSubscribeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public subscribeOutlookCalendarWatch(calendarWebhookSubscribeReq: CalendarWebhookSubscribeReq, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).subscribeOutlookCalendarWatch(calendarWebhookSubscribeReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Apple Calendar list and events
     * @param {string} uid 
     * @param {string} startTime Start time for event sync filtering (ISO string)
     * @param {string} endTime End time for event sync filtering (ISO string)
     * @param {AppleCalendarSyncReq} appleCalendarSyncReq Apple calendars data with events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncAppleCalendarsList(uid: string, startTime: string, endTime: string, appleCalendarSyncReq: AppleCalendarSyncReq, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncAppleCalendarsList(uid, startTime, endTime, appleCalendarSyncReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync calendar events
     * @param {string} userId 
     * @param {string} startTime start time - isoDate
     * @param {string} endTime end time - isoDate
     * @param {Array<string>} calendarIds 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncCalendarEvents(userId: string, startTime: string, endTime: string, calendarIds: Array<string>, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncCalendarEvents(userId, startTime, endTime, calendarIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Google Calendar list
     * @param {string} uid 
     * @param {string} rootEmail 
     * @param {CalendarListSyncGCalReq} [calendarListSyncGCalReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncGCalendarsList(uid: string, rootEmail: string, calendarListSyncGCalReq?: CalendarListSyncGCalReq, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncGCalendarsList(uid, rootEmail, calendarListSyncGCalReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Google Calendar events (full list)
     * @param {string} startTime start time - isoDate
     * @param {string} endTime end time - isoDate
     * @param {CalendarSyncBody} calendarSyncBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncGoogleCalendarEvents(startTime: string, endTime: string, calendarSyncBody: CalendarSyncBody, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncGoogleCalendarEvents(startTime, endTime, calendarSyncBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Outlook Calendar events (full list)
     * @param {string} startTime start time - isoDate
     * @param {string} endTime end time - isoDate
     * @param {CalendarSyncBody} calendarSyncBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncOutlookCalendarEvents(startTime: string, endTime: string, calendarSyncBody: CalendarSyncBody, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncOutlookCalendarEvents(startTime, endTime, calendarSyncBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Outlook Calendar list
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncOutlookCalendarList(uid: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncOutlookCalendarList(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Outlook Calendar list V2
     * @param {string} uid 
     * @param {string} rootEmail Outlook root email
     * @param {CalendarListSyncGCalReq} [calendarListSyncGCalReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncOutlookCalendarListV2(uid: string, rootEmail: string, calendarListSyncGCalReq?: CalendarListSyncGCalReq, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncOutlookCalendarListV2(uid, rootEmail, calendarListSyncGCalReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update preferences for calendar
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;CalendarPreference&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updatCalendarPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updatCalendarPreference(preferenceId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a calendar event
     * @param {string} userId 
     * @param {string} calendarId 
     * @param {string} eventId 
     * @param {object} body Partial&lt;CalendarEvent&gt;
     * @param {string} [recurringUpdateSpan] \&quot;thisEvent\&quot; | \&quot;allEvents\&quot;. Default: thisEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateCalendarEvent(userId: string, calendarId: string, eventId: string, body: object, recurringUpdateSpan?: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateCalendarEvent(userId, calendarId, eventId, body, recurringUpdateSpan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update EMA energy for a calendar event
     * @param {string} calendarId 
     * @param {string} eventId 
     * @param {object} body CalendarEventMetrics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateCalendarEventEnergy(calendarId: string, eventId: string, body: object, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateCalendarEventEnergy(calendarId, eventId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a calendar info
     * @param {string} calendarId 
     * @param {object} body Partial&lt;FirestoreCalendar&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateCalendarInfo(calendarId: string, body: object, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateCalendarInfo(calendarId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update exported calendar events
     * @param {string} userId 
     * @param {string} metricId 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateExportedCalendarEvents(userId: string, metricId: string, body?: object, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateExportedCalendarEvents(userId, metricId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update energy calendar settings
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;ExportedCalendar&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateExportedCalendarPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateExportedCalendarPreference(preferenceId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get chat message histories for a specific session type
         * @param {string} chatId Chat ID
         * @param {string} sessionType Type of chat session (scheduler, recommendation, sleep, meal)
         * @param {number} [sessionLimit] Number of sessions to fetch (default: 5)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistories: async (chatId: string, sessionType: string, sessionLimit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('getChatHistories', 'chatId', chatId)
            // verify required parameter 'sessionType' is not null or undefined
            assertParamExists('getChatHistories', 'sessionType', sessionType)
            const localVarPath = `/api/v1/chat/{chatId}/histories`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionType !== undefined) {
                localVarQueryParameter['sessionType'] = sessionType;
            }

            if (sessionLimit !== undefined) {
                localVarQueryParameter['sessionLimit'] = sessionLimit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Relay a JSON chat turn to science end-to-end streaming v4. Web posts here with a Bearer token; the GET `/e2e-stream/v4/start` route stays for EventSource clients.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChatE2EStreamV4: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chat/end_to_end_streaming/v4`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Relay a JSON chat turn to science end-to-end streaming v5, including the client job id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChatE2EStreamV5: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chat/end_to_end_streaming/v5`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a chat stream using end-to-end streaming (creates session and streams response in one call). only for general chat session.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStream: async (userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('startChatE2EStream', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('startChatE2EStream', 'metricId', metricId)
            // verify required parameter 'sessionType' is not null or undefined
            assertParamExists('startChatE2EStream', 'sessionType', sessionType)
            // verify required parameter 'userMessage' is not null or undefined
            assertParamExists('startChatE2EStream', 'userMessage', userMessage)
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('startChatE2EStream', 'preferenceId', preferenceId)
            // verify required parameter 'routineId' is not null or undefined
            assertParamExists('startChatE2EStream', 'routineId', routineId)
            // verify required parameter 'jwtToken' is not null or undefined
            assertParamExists('startChatE2EStream', 'jwtToken', jwtToken)
            const localVarPath = `/api/v1/chat/e2e-stream/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (sessionType !== undefined) {
                localVarQueryParameter['sessionType'] = sessionType;
            }

            if (userMessage !== undefined) {
                localVarQueryParameter['userMessage'] = userMessage;
            }

            if (preferenceId !== undefined) {
                localVarQueryParameter['preferenceId'] = preferenceId;
            }

            if (routineId !== undefined) {
                localVarQueryParameter['routineId'] = routineId;
            }

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = targetDate;
            }

            if (jwtToken !== undefined) {
                localVarQueryParameter['jwtToken'] = jwtToken;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a chat stream using end-to-end streaming v2 (creates session and streams response in one call). only for general chat session.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStreamV2: async (userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, hiddenContext?: object, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('startChatE2EStreamV2', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('startChatE2EStreamV2', 'metricId', metricId)
            // verify required parameter 'sessionType' is not null or undefined
            assertParamExists('startChatE2EStreamV2', 'sessionType', sessionType)
            // verify required parameter 'userMessage' is not null or undefined
            assertParamExists('startChatE2EStreamV2', 'userMessage', userMessage)
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('startChatE2EStreamV2', 'preferenceId', preferenceId)
            // verify required parameter 'routineId' is not null or undefined
            assertParamExists('startChatE2EStreamV2', 'routineId', routineId)
            // verify required parameter 'jwtToken' is not null or undefined
            assertParamExists('startChatE2EStreamV2', 'jwtToken', jwtToken)
            const localVarPath = `/api/v1/chat/e2e-stream/v2/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (sessionType !== undefined) {
                localVarQueryParameter['sessionType'] = sessionType;
            }

            if (userMessage !== undefined) {
                localVarQueryParameter['userMessage'] = userMessage;
            }

            if (preferenceId !== undefined) {
                localVarQueryParameter['preferenceId'] = preferenceId;
            }

            if (routineId !== undefined) {
                localVarQueryParameter['routineId'] = routineId;
            }

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = targetDate;
            }

            if (hiddenContext !== undefined) {
                for (const [key, value] of Object.entries(hiddenContext)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (jwtToken !== undefined) {
                localVarQueryParameter['jwtToken'] = jwtToken;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a chat stream using science end-to-end streaming v3.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [sessionId] Session ID for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStreamV3: async (userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('startChatE2EStreamV3', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('startChatE2EStreamV3', 'metricId', metricId)
            // verify required parameter 'sessionType' is not null or undefined
            assertParamExists('startChatE2EStreamV3', 'sessionType', sessionType)
            // verify required parameter 'userMessage' is not null or undefined
            assertParamExists('startChatE2EStreamV3', 'userMessage', userMessage)
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('startChatE2EStreamV3', 'preferenceId', preferenceId)
            // verify required parameter 'routineId' is not null or undefined
            assertParamExists('startChatE2EStreamV3', 'routineId', routineId)
            // verify required parameter 'jwtToken' is not null or undefined
            assertParamExists('startChatE2EStreamV3', 'jwtToken', jwtToken)
            const localVarPath = `/api/v1/chat/e2e-stream/v3/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (sessionType !== undefined) {
                localVarQueryParameter['sessionType'] = sessionType;
            }

            if (userMessage !== undefined) {
                localVarQueryParameter['userMessage'] = userMessage;
            }

            if (preferenceId !== undefined) {
                localVarQueryParameter['preferenceId'] = preferenceId;
            }

            if (routineId !== undefined) {
                localVarQueryParameter['routineId'] = routineId;
            }

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = targetDate;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            if (hiddenContext !== undefined) {
                for (const [key, value] of Object.entries(hiddenContext)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (jwtToken !== undefined) {
                localVarQueryParameter['jwtToken'] = jwtToken;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a chat stream using science end-to-end streaming v4.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [sessionId] Session ID for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {Array<PendingItem>} [pendingItems] Uncommitted suggest cards still on screen (science &#x60;PendingItem&#x60;). Each needs &#x60;action_id&#x60; + &#x60;name&#x60;. Omit or send an empty array when there are none. Alias: &#x60;schedulerPlan&#x60;.
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStreamV4: async (userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, pendingItems?: Array<PendingItem>, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('startChatE2EStreamV4', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('startChatE2EStreamV4', 'metricId', metricId)
            // verify required parameter 'sessionType' is not null or undefined
            assertParamExists('startChatE2EStreamV4', 'sessionType', sessionType)
            // verify required parameter 'userMessage' is not null or undefined
            assertParamExists('startChatE2EStreamV4', 'userMessage', userMessage)
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('startChatE2EStreamV4', 'preferenceId', preferenceId)
            // verify required parameter 'routineId' is not null or undefined
            assertParamExists('startChatE2EStreamV4', 'routineId', routineId)
            // verify required parameter 'jwtToken' is not null or undefined
            assertParamExists('startChatE2EStreamV4', 'jwtToken', jwtToken)
            const localVarPath = `/api/v1/chat/e2e-stream/v4/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (sessionType !== undefined) {
                localVarQueryParameter['sessionType'] = sessionType;
            }

            if (userMessage !== undefined) {
                localVarQueryParameter['userMessage'] = userMessage;
            }

            if (preferenceId !== undefined) {
                localVarQueryParameter['preferenceId'] = preferenceId;
            }

            if (routineId !== undefined) {
                localVarQueryParameter['routineId'] = routineId;
            }

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = targetDate;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            if (hiddenContext !== undefined) {
                for (const [key, value] of Object.entries(hiddenContext)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pendingItems) {
                localVarQueryParameter['pendingItems[]'] = pendingItems;
            }

            if (jwtToken !== undefined) {
                localVarQueryParameter['jwtToken'] = jwtToken;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a chat stream using science end-to-end streaming v5. Unlike v4, generation survives the client disconnecting (science runs it in a background thread and persists progress to Redis as a job); poll `GET /api/v1/jobs/{jobId}` to recover status/result later.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [sessionId] Session ID for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {Array<PendingItem>} [pendingItems] Uncommitted suggest cards still on screen (science &#x60;PendingItem&#x60;). Each needs &#x60;action_id&#x60; + &#x60;name&#x60;. Omit or send an empty array when there are none.
         * @param {string} [jobId] Client-supplied idempotency key for the job (science mints one and returns it in the leading &#x60;job&#x60; SSE event when omitted)
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStreamV5: async (userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, pendingItems?: Array<PendingItem>, jobId?: string, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('startChatE2EStreamV5', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('startChatE2EStreamV5', 'metricId', metricId)
            // verify required parameter 'sessionType' is not null or undefined
            assertParamExists('startChatE2EStreamV5', 'sessionType', sessionType)
            // verify required parameter 'userMessage' is not null or undefined
            assertParamExists('startChatE2EStreamV5', 'userMessage', userMessage)
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('startChatE2EStreamV5', 'preferenceId', preferenceId)
            // verify required parameter 'routineId' is not null or undefined
            assertParamExists('startChatE2EStreamV5', 'routineId', routineId)
            // verify required parameter 'jwtToken' is not null or undefined
            assertParamExists('startChatE2EStreamV5', 'jwtToken', jwtToken)
            const localVarPath = `/api/v1/chat/e2e-stream/v5/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (sessionType !== undefined) {
                localVarQueryParameter['sessionType'] = sessionType;
            }

            if (userMessage !== undefined) {
                localVarQueryParameter['userMessage'] = userMessage;
            }

            if (preferenceId !== undefined) {
                localVarQueryParameter['preferenceId'] = preferenceId;
            }

            if (routineId !== undefined) {
                localVarQueryParameter['routineId'] = routineId;
            }

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = targetDate;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            if (hiddenContext !== undefined) {
                for (const [key, value] of Object.entries(hiddenContext)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pendingItems) {
                localVarQueryParameter['pendingItems[]'] = pendingItems;
            }

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }

            if (jwtToken !== undefined) {
                localVarQueryParameter['jwtToken'] = jwtToken;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new streaming chat session
         * @param {StartChatSessionParams} startChatSessionParams Request body
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        startChatSession: async (startChatSessionParams: StartChatSessionParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startChatSessionParams' is not null or undefined
            assertParamExists('startChatSession', 'startChatSessionParams', startChatSessionParams)
            const localVarPath = `/api/v1/chat/session/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startChatSessionParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stream real-time chat responses using Server-Sent Events
         * @param {string} sessionId Unique session identifier from start-session
         * @param {string} [prompt] Optional additional prompt to extend the conversation
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        streamChatResponse: async (sessionId: string, prompt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('streamChatResponse', 'sessionId', sessionId)
            const localVarPath = `/api/v1/chat/session/{sessionId}/stream`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (prompt !== undefined) {
                localVarQueryParameter['prompt'] = prompt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync chat result by processing result_json and calling appropriate suggest functions
         * @param {string} sessionId Unique session identifier from start-session
         * @param {SyncChatResultParams} syncChatResultParams Request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncChatResult: async (sessionId: string, syncChatResultParams: SyncChatResultParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('syncChatResult', 'sessionId', sessionId)
            // verify required parameter 'syncChatResultParams' is not null or undefined
            assertParamExists('syncChatResult', 'syncChatResultParams', syncChatResultParams)
            const localVarPath = `/api/v1/chat/session/{sessionId}/sync`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncChatResultParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get chat message histories for a specific session type
         * @param {string} chatId Chat ID
         * @param {string} sessionType Type of chat session (scheduler, recommendation, sleep, meal)
         * @param {number} [sessionLimit] Number of sessions to fetch (default: 5)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatHistories(chatId: string, sessionType: string, sessionLimit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SessionMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatHistories(chatId, sessionType, sessionLimit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatHistories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Relay a JSON chat turn to science end-to-end streaming v4. Web posts here with a Bearer token; the GET `/e2e-stream/v4/start` route stays for EventSource clients.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postChatE2EStreamV4(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postChatE2EStreamV4(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.postChatE2EStreamV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Relay a JSON chat turn to science end-to-end streaming v5, including the client job id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postChatE2EStreamV5(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postChatE2EStreamV5(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.postChatE2EStreamV5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a chat stream using end-to-end streaming (creates session and streams response in one call). only for general chat session.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatE2EStream(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatE2EStream(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.startChatE2EStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a chat stream using end-to-end streaming v2 (creates session and streams response in one call). only for general chat session.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatE2EStreamV2(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, hiddenContext?: object, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatE2EStreamV2(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, hiddenContext, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.startChatE2EStreamV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a chat stream using science end-to-end streaming v3.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [sessionId] Session ID for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatE2EStreamV3(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatE2EStreamV3(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, sessionId, hiddenContext, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.startChatE2EStreamV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a chat stream using science end-to-end streaming v4.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [sessionId] Session ID for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {Array<PendingItem>} [pendingItems] Uncommitted suggest cards still on screen (science &#x60;PendingItem&#x60;). Each needs &#x60;action_id&#x60; + &#x60;name&#x60;. Omit or send an empty array when there are none. Alias: &#x60;schedulerPlan&#x60;.
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatE2EStreamV4(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, pendingItems?: Array<PendingItem>, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatE2EStreamV4(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, sessionId, hiddenContext, pendingItems, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.startChatE2EStreamV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a chat stream using science end-to-end streaming v5. Unlike v4, generation survives the client disconnecting (science runs it in a background thread and persists progress to Redis as a job); poll `GET /api/v1/jobs/{jobId}` to recover status/result later.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [sessionId] Session ID for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {Array<PendingItem>} [pendingItems] Uncommitted suggest cards still on screen (science &#x60;PendingItem&#x60;). Each needs &#x60;action_id&#x60; + &#x60;name&#x60;. Omit or send an empty array when there are none.
         * @param {string} [jobId] Client-supplied idempotency key for the job (science mints one and returns it in the leading &#x60;job&#x60; SSE event when omitted)
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatE2EStreamV5(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, pendingItems?: Array<PendingItem>, jobId?: string, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatE2EStreamV5(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, sessionId, hiddenContext, pendingItems, jobId, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.startChatE2EStreamV5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a new streaming chat session
         * @param {StartChatSessionParams} startChatSessionParams Request body
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async startChatSession(startChatSessionParams: StartChatSessionParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartChatSessionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatSession(startChatSessionParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.startChatSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stream real-time chat responses using Server-Sent Events
         * @param {string} sessionId Unique session identifier from start-session
         * @param {string} [prompt] Optional additional prompt to extend the conversation
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async streamChatResponse(sessionId: string, prompt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.streamChatResponse(sessionId, prompt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.streamChatResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync chat result by processing result_json and calling appropriate suggest functions
         * @param {string} sessionId Unique session identifier from start-session
         * @param {SyncChatResultParams} syncChatResultParams Request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncChatResult(sessionId: string, syncChatResultParams: SyncChatResultParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncChatResultOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncChatResult(sessionId, syncChatResultParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.syncChatResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * 
         * @summary Get chat message histories for a specific session type
         * @param {string} chatId Chat ID
         * @param {string} sessionType Type of chat session (scheduler, recommendation, sleep, meal)
         * @param {number} [sessionLimit] Number of sessions to fetch (default: 5)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistories(chatId: string, sessionType: string, sessionLimit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SessionMessage>> {
            return localVarFp.getChatHistories(chatId, sessionType, sessionLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Relay a JSON chat turn to science end-to-end streaming v4. Web posts here with a Bearer token; the GET `/e2e-stream/v4/start` route stays for EventSource clients.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChatE2EStreamV4(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.postChatE2EStreamV4(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Relay a JSON chat turn to science end-to-end streaming v5, including the client job id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChatE2EStreamV5(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.postChatE2EStreamV5(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a chat stream using end-to-end streaming (creates session and streams response in one call). only for general chat session.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStream(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, timeZone?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.startChatE2EStream(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a chat stream using end-to-end streaming v2 (creates session and streams response in one call). only for general chat session.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStreamV2(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, hiddenContext?: object, timeZone?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.startChatE2EStreamV2(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, hiddenContext, timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a chat stream using science end-to-end streaming v3.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [sessionId] Session ID for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStreamV3(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, timeZone?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.startChatE2EStreamV3(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, sessionId, hiddenContext, timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a chat stream using science end-to-end streaming v4.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [sessionId] Session ID for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {Array<PendingItem>} [pendingItems] Uncommitted suggest cards still on screen (science &#x60;PendingItem&#x60;). Each needs &#x60;action_id&#x60; + &#x60;name&#x60;. Omit or send an empty array when there are none. Alias: &#x60;schedulerPlan&#x60;.
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStreamV4(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, pendingItems?: Array<PendingItem>, timeZone?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.startChatE2EStreamV4(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, sessionId, hiddenContext, pendingItems, timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a chat stream using science end-to-end streaming v5. Unlike v4, generation survives the client disconnecting (science runs it in a background thread and persists progress to Redis as a job); poll `GET /api/v1/jobs/{jobId}` to recover status/result later.
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
         * @param {string} userMessage User\&#39;s message to the assistant
         * @param {string} preferenceId Preference ID for the chat
         * @param {string} routineId Routine ID for the chat
         * @param {string} jwtToken JWT access token for authentication
         * @param {string} [targetDate] Target date for the chat
         * @param {string} [sessionId] Session ID for the chat
         * @param {object} [hiddenContext] Hidden context for the chat
         * @param {Array<PendingItem>} [pendingItems] Uncommitted suggest cards still on screen (science &#x60;PendingItem&#x60;). Each needs &#x60;action_id&#x60; + &#x60;name&#x60;. Omit or send an empty array when there are none.
         * @param {string} [jobId] Client-supplied idempotency key for the job (science mints one and returns it in the leading &#x60;job&#x60; SSE event when omitted)
         * @param {string} [timeZone] Time zone for the chat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatE2EStreamV5(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, pendingItems?: Array<PendingItem>, jobId?: string, timeZone?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.startChatE2EStreamV5(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, sessionId, hiddenContext, pendingItems, jobId, timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new streaming chat session
         * @param {StartChatSessionParams} startChatSessionParams Request body
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        startChatSession(startChatSessionParams: StartChatSessionParams, options?: RawAxiosRequestConfig): AxiosPromise<StartChatSessionOutput> {
            return localVarFp.startChatSession(startChatSessionParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stream real-time chat responses using Server-Sent Events
         * @param {string} sessionId Unique session identifier from start-session
         * @param {string} [prompt] Optional additional prompt to extend the conversation
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        streamChatResponse(sessionId: string, prompt?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.streamChatResponse(sessionId, prompt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync chat result by processing result_json and calling appropriate suggest functions
         * @param {string} sessionId Unique session identifier from start-session
         * @param {SyncChatResultParams} syncChatResultParams Request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncChatResult(sessionId: string, syncChatResultParams: SyncChatResultParams, options?: RawAxiosRequestConfig): AxiosPromise<SyncChatResultOutput> {
            return localVarFp.syncChatResult(sessionId, syncChatResultParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * 
     * @summary Get chat message histories for a specific session type
     * @param {string} chatId Chat ID
     * @param {string} sessionType Type of chat session (scheduler, recommendation, sleep, meal)
     * @param {number} [sessionLimit] Number of sessions to fetch (default: 5)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatHistories(chatId: string, sessionType: string, sessionLimit?: number, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatHistories(chatId, sessionType, sessionLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Relay a JSON chat turn to science end-to-end streaming v4. Web posts here with a Bearer token; the GET `/e2e-stream/v4/start` route stays for EventSource clients.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public postChatE2EStreamV4(options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).postChatE2EStreamV4(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Relay a JSON chat turn to science end-to-end streaming v5, including the client job id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public postChatE2EStreamV5(options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).postChatE2EStreamV5(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a chat stream using end-to-end streaming (creates session and streams response in one call). only for general chat session.
     * @param {string} userId User ID
     * @param {string} metricId Metric ID
     * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
     * @param {string} userMessage User\&#39;s message to the assistant
     * @param {string} preferenceId Preference ID for the chat
     * @param {string} routineId Routine ID for the chat
     * @param {string} jwtToken JWT access token for authentication
     * @param {string} [targetDate] Target date for the chat
     * @param {string} [timeZone] Time zone for the chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public startChatE2EStream(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, timeZone?: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).startChatE2EStream(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a chat stream using end-to-end streaming v2 (creates session and streams response in one call). only for general chat session.
     * @param {string} userId User ID
     * @param {string} metricId Metric ID
     * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
     * @param {string} userMessage User\&#39;s message to the assistant
     * @param {string} preferenceId Preference ID for the chat
     * @param {string} routineId Routine ID for the chat
     * @param {string} jwtToken JWT access token for authentication
     * @param {string} [targetDate] Target date for the chat
     * @param {object} [hiddenContext] Hidden context for the chat
     * @param {string} [timeZone] Time zone for the chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public startChatE2EStreamV2(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, hiddenContext?: object, timeZone?: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).startChatE2EStreamV2(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, hiddenContext, timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a chat stream using science end-to-end streaming v3.
     * @param {string} userId User ID
     * @param {string} metricId Metric ID
     * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
     * @param {string} userMessage User\&#39;s message to the assistant
     * @param {string} preferenceId Preference ID for the chat
     * @param {string} routineId Routine ID for the chat
     * @param {string} jwtToken JWT access token for authentication
     * @param {string} [targetDate] Target date for the chat
     * @param {string} [sessionId] Session ID for the chat
     * @param {object} [hiddenContext] Hidden context for the chat
     * @param {string} [timeZone] Time zone for the chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public startChatE2EStreamV3(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, timeZone?: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).startChatE2EStreamV3(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, sessionId, hiddenContext, timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a chat stream using science end-to-end streaming v4.
     * @param {string} userId User ID
     * @param {string} metricId Metric ID
     * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
     * @param {string} userMessage User\&#39;s message to the assistant
     * @param {string} preferenceId Preference ID for the chat
     * @param {string} routineId Routine ID for the chat
     * @param {string} jwtToken JWT access token for authentication
     * @param {string} [targetDate] Target date for the chat
     * @param {string} [sessionId] Session ID for the chat
     * @param {object} [hiddenContext] Hidden context for the chat
     * @param {Array<PendingItem>} [pendingItems] Uncommitted suggest cards still on screen (science &#x60;PendingItem&#x60;). Each needs &#x60;action_id&#x60; + &#x60;name&#x60;. Omit or send an empty array when there are none. Alias: &#x60;schedulerPlan&#x60;.
     * @param {string} [timeZone] Time zone for the chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public startChatE2EStreamV4(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, pendingItems?: Array<PendingItem>, timeZone?: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).startChatE2EStreamV4(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, sessionId, hiddenContext, pendingItems, timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a chat stream using science end-to-end streaming v5. Unlike v4, generation survives the client disconnecting (science runs it in a background thread and persists progress to Redis as a job); poll `GET /api/v1/jobs/{jobId}` to recover status/result later.
     * @param {string} userId User ID
     * @param {string} metricId Metric ID
     * @param {string} sessionType Type of chat session (sleep, meal, task, general) StreamChatSessionType
     * @param {string} userMessage User\&#39;s message to the assistant
     * @param {string} preferenceId Preference ID for the chat
     * @param {string} routineId Routine ID for the chat
     * @param {string} jwtToken JWT access token for authentication
     * @param {string} [targetDate] Target date for the chat
     * @param {string} [sessionId] Session ID for the chat
     * @param {object} [hiddenContext] Hidden context for the chat
     * @param {Array<PendingItem>} [pendingItems] Uncommitted suggest cards still on screen (science &#x60;PendingItem&#x60;). Each needs &#x60;action_id&#x60; + &#x60;name&#x60;. Omit or send an empty array when there are none.
     * @param {string} [jobId] Client-supplied idempotency key for the job (science mints one and returns it in the leading &#x60;job&#x60; SSE event when omitted)
     * @param {string} [timeZone] Time zone for the chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public startChatE2EStreamV5(userId: string, metricId: string, sessionType: string, userMessage: string, preferenceId: string, routineId: string, jwtToken: string, targetDate?: string, sessionId?: string, hiddenContext?: object, pendingItems?: Array<PendingItem>, jobId?: string, timeZone?: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).startChatE2EStreamV5(userId, metricId, sessionType, userMessage, preferenceId, routineId, jwtToken, targetDate, sessionId, hiddenContext, pendingItems, jobId, timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new streaming chat session
     * @param {StartChatSessionParams} startChatSessionParams Request body
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public startChatSession(startChatSessionParams: StartChatSessionParams, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).startChatSession(startChatSessionParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stream real-time chat responses using Server-Sent Events
     * @param {string} sessionId Unique session identifier from start-session
     * @param {string} [prompt] Optional additional prompt to extend the conversation
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public streamChatResponse(sessionId: string, prompt?: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).streamChatResponse(sessionId, prompt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync chat result by processing result_json and calling appropriate suggest functions
     * @param {string} sessionId Unique session identifier from start-session
     * @param {SyncChatResultParams} syncChatResultParams Request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public syncChatResult(sessionId: string, syncChatResultParams: SyncChatResultParams, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).syncChatResult(sessionId, syncChatResultParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataTrendApi - axios parameter creator
 * @export
 */
export const DataTrendApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get daily calendar trend data
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarDailyTrend: async (userId: string, date: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCalendarDailyTrend', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getCalendarDailyTrend', 'date', date)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getCalendarDailyTrend', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/{dataTrendId}/calendar/daily`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get weekly calendar trend data
         * @param {string} userId User ID
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarWeeklyTrend: async (userId: string, startDate: string, endDate: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCalendarWeeklyTrend', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getCalendarWeeklyTrend', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getCalendarWeeklyTrend', 'endDate', endDate)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getCalendarWeeklyTrend', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/{dataTrendId}/calendar/weekly`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get summary of the day
         * @param {string} userId 
         * @param {string} date 
         * @param {string} dataTrendId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getDaySummary: async (userId: string, date: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getDaySummary', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getDaySummary', 'date', date)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getDaySummary', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (dataTrendId !== undefined) {
                localVarQueryParameter['dataTrendId'] = dataTrendId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get summary of the day
         * @param {string} userId 
         * @param {string} date 
         * @param {string} dataTrendId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDaySummaryV2: async (userId: string, date: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getDaySummaryV2', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getDaySummaryV2', 'date', date)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getDaySummaryV2', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/{dataTrendId}/summary`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get weekly exercise trend data
         * @param {string} metricId Metric ID
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseWeeklyTrend: async (metricId: string, startDate: string, endDate: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getExerciseWeeklyTrend', 'metricId', metricId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getExerciseWeeklyTrend', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getExerciseWeeklyTrend', 'endDate', endDate)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getExerciseWeeklyTrend', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/{dataTrendId}/exercise/weekly`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get daily focus (deep work) session data
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFocusDailyTrend: async (userId: string, date: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getFocusDailyTrend', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getFocusDailyTrend', 'date', date)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getFocusDailyTrend', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/{dataTrendId}/focus/daily`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get daily health summary (steps, resting HR, active calories)
         * @param {string} metricId Metric ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthDailySummary: async (metricId: string, date: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getHealthDailySummary', 'metricId', metricId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getHealthDailySummary', 'date', date)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getHealthDailySummary', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/{dataTrendId}/health/daily`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get daily schedule trend data
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleDailyTrend: async (date: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getScheduleDailyTrend', 'date', date)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getScheduleDailyTrend', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/{dataTrendId}/schedule/daily`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get daily wellness score
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWellnessScoreDaily: async (userId: string, metricId: string, date: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWellnessScoreDaily', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getWellnessScoreDaily', 'metricId', metricId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getWellnessScoreDaily', 'date', date)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getWellnessScoreDaily', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/{dataTrendId}/score/daily`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get wellness score history for a date range
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWellnessScoreWeekly: async (userId: string, metricId: string, startDate: string, endDate: string, dataTrendId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWellnessScoreWeekly', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getWellnessScoreWeekly', 'metricId', metricId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getWellnessScoreWeekly', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getWellnessScoreWeekly', 'endDate', endDate)
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getWellnessScoreWeekly', 'dataTrendId', dataTrendId)
            const localVarPath = `/api/v1/dataTrend/{dataTrendId}/score/weekly`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataTrendApi - functional programming interface
 * @export
 */
export const DataTrendApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataTrendApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get daily calendar trend data
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarDailyTrend(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarDailyTrend(userId, date, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getCalendarDailyTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get weekly calendar trend data
         * @param {string} userId User ID
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarWeeklyTrend(userId: string, startDate: string, endDate: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarWeeklyTrend(userId, startDate, endDate, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getCalendarWeeklyTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get summary of the day
         * @param {string} userId 
         * @param {string} date 
         * @param {string} dataTrendId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getDaySummary(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DaySummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDaySummary(userId, date, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getDaySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get summary of the day
         * @param {string} userId 
         * @param {string} date 
         * @param {string} dataTrendId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDaySummaryV2(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DaySummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDaySummaryV2(userId, date, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getDaySummaryV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get weekly exercise trend data
         * @param {string} metricId Metric ID
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExerciseWeeklyTrend(metricId: string, startDate: string, endDate: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExerciseWeeklyTrend(metricId, startDate, endDate, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getExerciseWeeklyTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get daily focus (deep work) session data
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFocusDailyTrend(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFocusDailyTrend(userId, date, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getFocusDailyTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get daily health summary (steps, resting HR, active calories)
         * @param {string} metricId Metric ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHealthDailySummary(metricId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHealthDailySummary(metricId, date, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getHealthDailySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get daily schedule trend data
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduleDailyTrend(date: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduleDailyTrend(date, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getScheduleDailyTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get daily wellness score
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWellnessScoreDaily(userId: string, metricId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWellnessScoreDaily(userId, metricId, date, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getWellnessScoreDaily']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get wellness score history for a date range
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWellnessScoreWeekly(userId: string, metricId: string, startDate: string, endDate: string, dataTrendId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWellnessScoreWeekly(userId, metricId, startDate, endDate, dataTrendId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataTrendApi.getWellnessScoreWeekly']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataTrendApi - factory interface
 * @export
 */
export const DataTrendApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataTrendApiFp(configuration)
    return {
        /**
         * 
         * @summary Get daily calendar trend data
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarDailyTrend(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getCalendarDailyTrend(userId, date, dataTrendId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get weekly calendar trend data
         * @param {string} userId User ID
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarWeeklyTrend(userId: string, startDate: string, endDate: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getCalendarWeeklyTrend(userId, startDate, endDate, dataTrendId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get summary of the day
         * @param {string} userId 
         * @param {string} date 
         * @param {string} dataTrendId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getDaySummary(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<DaySummary> {
            return localVarFp.getDaySummary(userId, date, dataTrendId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get summary of the day
         * @param {string} userId 
         * @param {string} date 
         * @param {string} dataTrendId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDaySummaryV2(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<DaySummary> {
            return localVarFp.getDaySummaryV2(userId, date, dataTrendId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get weekly exercise trend data
         * @param {string} metricId Metric ID
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseWeeklyTrend(metricId: string, startDate: string, endDate: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getExerciseWeeklyTrend(metricId, startDate, endDate, dataTrendId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get daily focus (deep work) session data
         * @param {string} userId User ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFocusDailyTrend(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getFocusDailyTrend(userId, date, dataTrendId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get daily health summary (steps, resting HR, active calories)
         * @param {string} metricId Metric ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthDailySummary(metricId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getHealthDailySummary(metricId, date, dataTrendId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get daily schedule trend data
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleDailyTrend(date: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getScheduleDailyTrend(date, dataTrendId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get daily wellness score
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} date Date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWellnessScoreDaily(userId: string, metricId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getWellnessScoreDaily(userId, metricId, date, dataTrendId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get wellness score history for a date range
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {string} dataTrendId Data trend ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWellnessScoreWeekly(userId: string, metricId: string, startDate: string, endDate: string, dataTrendId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getWellnessScoreWeekly(userId, metricId, startDate, endDate, dataTrendId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataTrendApi - object-oriented interface
 * @export
 * @class DataTrendApi
 * @extends {BaseAPI}
 */
export class DataTrendApi extends BaseAPI {
    /**
     * 
     * @summary Get daily calendar trend data
     * @param {string} userId User ID
     * @param {string} date Date in YYYY-MM-DD format
     * @param {string} dataTrendId Data trend ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getCalendarDailyTrend(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getCalendarDailyTrend(userId, date, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get weekly calendar trend data
     * @param {string} userId User ID
     * @param {string} startDate Start date in YYYY-MM-DD format
     * @param {string} endDate End date in YYYY-MM-DD format
     * @param {string} dataTrendId Data trend ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getCalendarWeeklyTrend(userId: string, startDate: string, endDate: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getCalendarWeeklyTrend(userId, startDate, endDate, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get summary of the day
     * @param {string} userId 
     * @param {string} date 
     * @param {string} dataTrendId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getDaySummary(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getDaySummary(userId, date, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get summary of the day
     * @param {string} userId 
     * @param {string} date 
     * @param {string} dataTrendId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getDaySummaryV2(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getDaySummaryV2(userId, date, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get weekly exercise trend data
     * @param {string} metricId Metric ID
     * @param {string} startDate Start date in YYYY-MM-DD format
     * @param {string} endDate End date in YYYY-MM-DD format
     * @param {string} dataTrendId Data trend ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getExerciseWeeklyTrend(metricId: string, startDate: string, endDate: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getExerciseWeeklyTrend(metricId, startDate, endDate, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get daily focus (deep work) session data
     * @param {string} userId User ID
     * @param {string} date Date in YYYY-MM-DD format
     * @param {string} dataTrendId Data trend ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getFocusDailyTrend(userId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getFocusDailyTrend(userId, date, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get daily health summary (steps, resting HR, active calories)
     * @param {string} metricId Metric ID
     * @param {string} date Date in YYYY-MM-DD format
     * @param {string} dataTrendId Data trend ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getHealthDailySummary(metricId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getHealthDailySummary(metricId, date, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get daily schedule trend data
     * @param {string} date Date in YYYY-MM-DD format
     * @param {string} dataTrendId Data trend ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getScheduleDailyTrend(date: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getScheduleDailyTrend(date, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get daily wellness score
     * @param {string} userId User ID
     * @param {string} metricId Metric ID
     * @param {string} date Date in YYYY-MM-DD format
     * @param {string} dataTrendId Data trend ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getWellnessScoreDaily(userId: string, metricId: string, date: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getWellnessScoreDaily(userId, metricId, date, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get wellness score history for a date range
     * @param {string} userId User ID
     * @param {string} metricId Metric ID
     * @param {string} startDate Start date in YYYY-MM-DD format
     * @param {string} endDate End date in YYYY-MM-DD format
     * @param {string} dataTrendId Data trend ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataTrendApi
     */
    public getWellnessScoreWeekly(userId: string, metricId: string, startDate: string, endDate: string, dataTrendId: string, options?: RawAxiosRequestConfig) {
        return DataTrendApiFp(this.configuration).getWellnessScoreWeekly(userId, metricId, startDate, endDate, dataTrendId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DevApi - axios parameter creator
 * @export
 */
export const DevApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Run analytics
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAnalytics: async (startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('runAnalytics', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('runAnalytics', 'endDate', endDate)
            const localVarPath = `/api/v1/dev/analytics/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger weekly report email for a single user (dev only)
         * @param {string} userId User ID to send the test email to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testWeeklyReportEmail: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('testWeeklyReportEmail', 'userId', userId)
            const localVarPath = `/api/v1/dev/analytics/weekly-report/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevApi - functional programming interface
 * @export
 */
export const DevApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Run analytics
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAnalytics(startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAnalytics(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevApi.runAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger weekly report email for a single user (dev only)
         * @param {string} userId User ID to send the test email to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testWeeklyReportEmail(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testWeeklyReportEmail(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevApi.testWeeklyReportEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevApi - factory interface
 * @export
 */
export const DevApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevApiFp(configuration)
    return {
        /**
         * 
         * @summary Run analytics
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAnalytics(startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.runAnalytics(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger weekly report email for a single user (dev only)
         * @param {string} userId User ID to send the test email to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testWeeklyReportEmail(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.testWeeklyReportEmail(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevApi - object-oriented interface
 * @export
 * @class DevApi
 * @extends {BaseAPI}
 */
export class DevApi extends BaseAPI {
    /**
     * 
     * @summary Run analytics
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevApi
     */
    public runAnalytics(startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return DevApiFp(this.configuration).runAnalytics(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger weekly report email for a single user (dev only)
     * @param {string} userId User ID to send the test email to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevApi
     */
    public testWeeklyReportEmail(userId: string, options?: RawAxiosRequestConfig) {
        return DevApiFp(this.configuration).testWeeklyReportEmail(userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailApi - axios parameter creator
 * @export
 */
export const EmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Record email CTA click event and redirect to destination
         * @param {string} userId User ID
         * @param {string} type Email type (e.g. weeklyReport)
         * @param {string} url Destination URL to redirect to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailTrackClickGet: async (userId: string, type: string, url: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1EmailTrackClickGet', 'userId', userId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('apiV1EmailTrackClickGet', 'type', type)
            // verify required parameter 'url' is not null or undefined
            assertParamExists('apiV1EmailTrackClickGet', 'url', url)
            const localVarPath = `/api/v1/email/track/click`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record email open event and return a 1×1 tracking pixel
         * @param {string} userId User ID
         * @param {string} type Email type (e.g. weeklyReport)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailTrackOpenGet: async (userId: string, type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1EmailTrackOpenGet', 'userId', userId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('apiV1EmailTrackOpenGet', 'type', type)
            const localVarPath = `/api/v1/email/track/open`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailApi - functional programming interface
 * @export
 */
export const EmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Record email CTA click event and redirect to destination
         * @param {string} userId User ID
         * @param {string} type Email type (e.g. weeklyReport)
         * @param {string} url Destination URL to redirect to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EmailTrackClickGet(userId: string, type: string, url: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EmailTrackClickGet(userId, type, url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiV1EmailTrackClickGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record email open event and return a 1×1 tracking pixel
         * @param {string} userId User ID
         * @param {string} type Email type (e.g. weeklyReport)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EmailTrackOpenGet(userId: string, type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EmailTrackOpenGet(userId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiV1EmailTrackOpenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailApi - factory interface
 * @export
 */
export const EmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailApiFp(configuration)
    return {
        /**
         * 
         * @summary Record email CTA click event and redirect to destination
         * @param {string} userId User ID
         * @param {string} type Email type (e.g. weeklyReport)
         * @param {string} url Destination URL to redirect to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailTrackClickGet(userId: string, type: string, url: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1EmailTrackClickGet(userId, type, url, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record email open event and return a 1×1 tracking pixel
         * @param {string} userId User ID
         * @param {string} type Email type (e.g. weeklyReport)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailTrackOpenGet(userId: string, type: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.apiV1EmailTrackOpenGet(userId, type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
export class EmailApi extends BaseAPI {
    /**
     * 
     * @summary Record email CTA click event and redirect to destination
     * @param {string} userId User ID
     * @param {string} type Email type (e.g. weeklyReport)
     * @param {string} url Destination URL to redirect to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiV1EmailTrackClickGet(userId: string, type: string, url: string, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiV1EmailTrackClickGet(userId, type, url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record email open event and return a 1×1 tracking pixel
     * @param {string} userId User ID
     * @param {string} type Email type (e.g. weeklyReport)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiV1EmailTrackOpenGet(userId: string, type: string, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiV1EmailTrackOpenGet(userId, type, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EnergyApi - axios parameter creator
 * @export
 */
export const EnergyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get average circadian rhythm
         * @param {string} userId 
         * @param {string} metricId 
         * @param {string} referenceDate 
         * @param {string} [chronotype] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvgCircadian: async (userId: string, metricId: string, referenceDate: string, chronotype?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAvgCircadian', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getAvgCircadian', 'metricId', metricId)
            // verify required parameter 'referenceDate' is not null or undefined
            assertParamExists('getAvgCircadian', 'referenceDate', referenceDate)
            const localVarPath = `/api/v1/energy/circadian/avg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (referenceDate !== undefined) {
                localVarQueryParameter['referenceDate'] = referenceDate;
            }

            if (chronotype !== undefined) {
                localVarQueryParameter['chronotype'] = chronotype;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get circadian rhythm
         * @param {string} userId 
         * @param {Array<string>} calendarIds 
         * @param {string} metricId 
         * @param {string} date 
         * @param {string} timezone 
         * @param {boolean} [enableStressCombine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircadian: async (userId: string, calendarIds: Array<string>, metricId: string, date: string, timezone: string, enableStressCombine?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCircadian', 'userId', userId)
            // verify required parameter 'calendarIds' is not null or undefined
            assertParamExists('getCircadian', 'calendarIds', calendarIds)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getCircadian', 'metricId', metricId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getCircadian', 'date', date)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('getCircadian', 'timezone', timezone)
            const localVarPath = `/api/v1/energy/circadian`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (calendarIds) {
                localVarQueryParameter['calendarIds[]'] = calendarIds;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (enableStressCombine !== undefined) {
                localVarQueryParameter['enableStressCombine'] = enableStressCombine;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get daily energy trend
         * @param {string} dataTrendId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyEnergyTrend: async (dataTrendId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getDailyEnergyTrend', 'dataTrendId', dataTrendId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getDailyEnergyTrend', 'date', date)
            const localVarPath = `/api/v1/energy/trend/{dataTrendId}/daily`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get energy preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEnergyPreference: async (preferenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('getEnergyPreference', 'preferenceId', preferenceId)
            const localVarPath = `/api/v1/energy/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a phase ema
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhaseEmas: async (userId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPhaseEmas', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getPhaseEmas', 'date', date)
            const localVarPath = `/api/v1/energy/ema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get satisfaction emas within a date range
         * @param {string} userId 
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSatisfactionEma: async (userId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSatisfactionEma', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getSatisfactionEma', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getSatisfactionEma', 'endDate', endDate)
            const localVarPath = `/api/v1/energy/ema/satisfaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get weekly energy trend
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyEnergyTrend: async (dataTrendId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getWeeklyEnergyTrend', 'dataTrendId', dataTrendId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getWeeklyEnergyTrend', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getWeeklyEnergyTrend', 'endDate', endDate)
            const localVarPath = `/api/v1/energy/trend/{dataTrendId}/weekly`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update preferences for event categoiries\' energy
         * @param {string} preferenceId 
         * @param {Array<object>} requestBody EventCategoryEnergyPreference[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventCategoryPreference: async (preferenceId: string, requestBody: Array<object>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updateEventCategoryPreference', 'preferenceId', preferenceId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateEventCategoryPreference', 'requestBody', requestBody)
            const localVarPath = `/api/v1/energy/preference/{preferenceId}/eventCategory`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a phase ema
         * @param {string} userId 
         * @param {string} date 
         * @param {string} timezone 
         * @param {object} body EMADatePhaseScoreSet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhaseEma: async (userId: string, date: string, timezone: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updatePhaseEma', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('updatePhaseEma', 'date', date)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('updatePhaseEma', 'timezone', timezone)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updatePhaseEma', 'body', body)
            const localVarPath = `/api/v1/energy/ema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a satisfaction ema
         * @param {string} userId 
         * @param {string} date 
         * @param {UpdateSatisfactionEmaParams} updateSatisfactionEmaParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSatisfactionEma: async (userId: string, date: string, updateSatisfactionEmaParams: UpdateSatisfactionEmaParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateSatisfactionEma', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('updateSatisfactionEma', 'date', date)
            // verify required parameter 'updateSatisfactionEmaParams' is not null or undefined
            assertParamExists('updateSatisfactionEma', 'updateSatisfactionEmaParams', updateSatisfactionEmaParams)
            const localVarPath = `/api/v1/energy/ema/satisfaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSatisfactionEmaParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnergyApi - functional programming interface
 * @export
 */
export const EnergyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnergyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get average circadian rhythm
         * @param {string} userId 
         * @param {string} metricId 
         * @param {string} referenceDate 
         * @param {string} [chronotype] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvgCircadian(userId: string, metricId: string, referenceDate: string, chronotype?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvgCircadian(userId, metricId, referenceDate, chronotype, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.getAvgCircadian']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get circadian rhythm
         * @param {string} userId 
         * @param {Array<string>} calendarIds 
         * @param {string} metricId 
         * @param {string} date 
         * @param {string} timezone 
         * @param {boolean} [enableStressCombine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCircadian(userId: string, calendarIds: Array<string>, metricId: string, date: string, timezone: string, enableStressCombine?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnergyCircadianGetRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCircadian(userId, calendarIds, metricId, date, timezone, enableStressCombine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.getCircadian']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get daily energy trend
         * @param {string} dataTrendId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyEnergyTrend(dataTrendId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyEnergyTrend(dataTrendId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.getDailyEnergyTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get energy preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getEnergyPreference(preferenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnergyPreference(preferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.getEnergyPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a phase ema
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhaseEmas(userId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhaseEmas(userId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.getPhaseEmas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get satisfaction emas within a date range
         * @param {string} userId 
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSatisfactionEma(userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSatisfactionEma(userId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.getSatisfactionEma']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get weekly energy trend
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyEnergyTrend(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnergyDataTrendWeeklyRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyEnergyTrend(dataTrendId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.getWeeklyEnergyTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update preferences for event categoiries\' energy
         * @param {string} preferenceId 
         * @param {Array<object>} requestBody EventCategoryEnergyPreference[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventCategoryPreference(preferenceId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventCategoryPreference(preferenceId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.updateEventCategoryPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a phase ema
         * @param {string} userId 
         * @param {string} date 
         * @param {string} timezone 
         * @param {object} body EMADatePhaseScoreSet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhaseEma(userId: string, date: string, timezone: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhaseEma(userId, date, timezone, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.updatePhaseEma']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a satisfaction ema
         * @param {string} userId 
         * @param {string} date 
         * @param {UpdateSatisfactionEmaParams} updateSatisfactionEmaParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSatisfactionEma(userId: string, date: string, updateSatisfactionEmaParams: UpdateSatisfactionEmaParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSatisfactionEma(userId, date, updateSatisfactionEmaParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyApi.updateSatisfactionEma']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnergyApi - factory interface
 * @export
 */
export const EnergyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnergyApiFp(configuration)
    return {
        /**
         * 
         * @summary Get average circadian rhythm
         * @param {string} userId 
         * @param {string} metricId 
         * @param {string} referenceDate 
         * @param {string} [chronotype] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvgCircadian(userId: string, metricId: string, referenceDate: string, chronotype?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getAvgCircadian(userId, metricId, referenceDate, chronotype, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get circadian rhythm
         * @param {string} userId 
         * @param {Array<string>} calendarIds 
         * @param {string} metricId 
         * @param {string} date 
         * @param {string} timezone 
         * @param {boolean} [enableStressCombine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircadian(userId: string, calendarIds: Array<string>, metricId: string, date: string, timezone: string, enableStressCombine?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<EnergyCircadianGetRes> {
            return localVarFp.getCircadian(userId, calendarIds, metricId, date, timezone, enableStressCombine, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get daily energy trend
         * @param {string} dataTrendId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyEnergyTrend(dataTrendId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getDailyEnergyTrend(dataTrendId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get energy preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEnergyPreference(preferenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getEnergyPreference(preferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a phase ema
         * @param {string} userId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhaseEmas(userId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getPhaseEmas(userId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get satisfaction emas within a date range
         * @param {string} userId 
         * @param {string} startDate Start date in YYYY-MM-DD format
         * @param {string} endDate End date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSatisfactionEma(userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getSatisfactionEma(userId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get weekly energy trend
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyEnergyTrend(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<EnergyDataTrendWeeklyRes> {
            return localVarFp.getWeeklyEnergyTrend(dataTrendId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update preferences for event categoiries\' energy
         * @param {string} preferenceId 
         * @param {Array<object>} requestBody EventCategoryEnergyPreference[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventCategoryPreference(preferenceId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateEventCategoryPreference(preferenceId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a phase ema
         * @param {string} userId 
         * @param {string} date 
         * @param {string} timezone 
         * @param {object} body EMADatePhaseScoreSet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhaseEma(userId: string, date: string, timezone: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updatePhaseEma(userId, date, timezone, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a satisfaction ema
         * @param {string} userId 
         * @param {string} date 
         * @param {UpdateSatisfactionEmaParams} updateSatisfactionEmaParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSatisfactionEma(userId: string, date: string, updateSatisfactionEmaParams: UpdateSatisfactionEmaParams, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateSatisfactionEma(userId, date, updateSatisfactionEmaParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnergyApi - object-oriented interface
 * @export
 * @class EnergyApi
 * @extends {BaseAPI}
 */
export class EnergyApi extends BaseAPI {
    /**
     * 
     * @summary Get average circadian rhythm
     * @param {string} userId 
     * @param {string} metricId 
     * @param {string} referenceDate 
     * @param {string} [chronotype] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public getAvgCircadian(userId: string, metricId: string, referenceDate: string, chronotype?: string, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).getAvgCircadian(userId, metricId, referenceDate, chronotype, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get circadian rhythm
     * @param {string} userId 
     * @param {Array<string>} calendarIds 
     * @param {string} metricId 
     * @param {string} date 
     * @param {string} timezone 
     * @param {boolean} [enableStressCombine] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public getCircadian(userId: string, calendarIds: Array<string>, metricId: string, date: string, timezone: string, enableStressCombine?: boolean, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).getCircadian(userId, calendarIds, metricId, date, timezone, enableStressCombine, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get daily energy trend
     * @param {string} dataTrendId 
     * @param {string} date YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public getDailyEnergyTrend(dataTrendId: string, date: string, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).getDailyEnergyTrend(dataTrendId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get energy preference
     * @param {string} preferenceId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public getEnergyPreference(preferenceId: string, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).getEnergyPreference(preferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a phase ema
     * @param {string} userId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public getPhaseEmas(userId: string, date: string, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).getPhaseEmas(userId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get satisfaction emas within a date range
     * @param {string} userId 
     * @param {string} startDate Start date in YYYY-MM-DD format
     * @param {string} endDate End date in YYYY-MM-DD format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public getSatisfactionEma(userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).getSatisfactionEma(userId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get weekly energy trend
     * @param {string} dataTrendId 
     * @param {string} startDate YYYY-MM-DD
     * @param {string} endDate YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public getWeeklyEnergyTrend(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).getWeeklyEnergyTrend(dataTrendId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update preferences for event categoiries\' energy
     * @param {string} preferenceId 
     * @param {Array<object>} requestBody EventCategoryEnergyPreference[]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public updateEventCategoryPreference(preferenceId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).updateEventCategoryPreference(preferenceId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a phase ema
     * @param {string} userId 
     * @param {string} date 
     * @param {string} timezone 
     * @param {object} body EMADatePhaseScoreSet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public updatePhaseEma(userId: string, date: string, timezone: string, body: object, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).updatePhaseEma(userId, date, timezone, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a satisfaction ema
     * @param {string} userId 
     * @param {string} date 
     * @param {UpdateSatisfactionEmaParams} updateSatisfactionEmaParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergyApi
     */
    public updateSatisfactionEma(userId: string, date: string, updateSatisfactionEmaParams: UpdateSatisfactionEmaParams, options?: RawAxiosRequestConfig) {
        return EnergyApiFp(this.configuration).updateSatisfactionEma(userId, date, updateSatisfactionEmaParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalApi - axios parameter creator
 * @export
 */
export const ExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update a slack profile status based on energy levels
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleSlackBotWebhook: async (body?: Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/external/slack/bot/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Receive inbound Telegram messages from the Bot API
         * @param {TelegramUpdate} telegramUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveTelegramWebhook: async (telegramUpdate: TelegramUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'telegramUpdate' is not null or undefined
            assertParamExists('receiveTelegramWebhook', 'telegramUpdate', telegramUpdate)
            const localVarPath = `/api/v1/external/telegram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(telegramUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Canny post
         * @param {UpdateCannyPostRequest} updateCannyPostRequest Request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCannyPost: async (updateCannyPostRequest: UpdateCannyPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCannyPostRequest' is not null or undefined
            assertParamExists('updateCannyPost', 'updateCannyPostRequest', updateCannyPostRequest)
            const localVarPath = `/api/v1/external/canny`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCannyPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a slack profile status based on energy levels
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackProfileStatus: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('updateSlackProfileStatus', 'code', code)
            const localVarPath = `/api/v1/external/slack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalApi - functional programming interface
 * @export
 */
export const ExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update a slack profile status based on energy levels
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleSlackBotWebhook(body?: Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleSlackBotWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.handleSlackBotWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Receive inbound Telegram messages from the Bot API
         * @param {TelegramUpdate} telegramUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveTelegramWebhook(telegramUpdate: TelegramUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveTelegramWebhook(telegramUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.receiveTelegramWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Canny post
         * @param {UpdateCannyPostRequest} updateCannyPostRequest Request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCannyPost(updateCannyPostRequest: UpdateCannyPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCannyPost(updateCannyPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.updateCannyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a slack profile status based on energy levels
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlackProfileStatus(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlackProfileStatus(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.updateSlackProfileStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalApi - factory interface
 * @export
 */
export const ExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalApiFp(configuration)
    return {
        /**
         * 
         * @summary Update a slack profile status based on energy levels
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleSlackBotWebhook(body?: Request, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.handleSlackBotWebhook(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Receive inbound Telegram messages from the Bot API
         * @param {TelegramUpdate} telegramUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveTelegramWebhook(telegramUpdate: TelegramUpdate, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.receiveTelegramWebhook(telegramUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Canny post
         * @param {UpdateCannyPostRequest} updateCannyPostRequest Request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCannyPost(updateCannyPostRequest: UpdateCannyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateCannyPost(updateCannyPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a slack profile status based on energy levels
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackProfileStatus(code: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateSlackProfileStatus(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalApi - object-oriented interface
 * @export
 * @class ExternalApi
 * @extends {BaseAPI}
 */
export class ExternalApi extends BaseAPI {
    /**
     * 
     * @summary Update a slack profile status based on energy levels
     * @param {Request} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalApi
     */
    public handleSlackBotWebhook(body?: Request, options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).handleSlackBotWebhook(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Receive inbound Telegram messages from the Bot API
     * @param {TelegramUpdate} telegramUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalApi
     */
    public receiveTelegramWebhook(telegramUpdate: TelegramUpdate, options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).receiveTelegramWebhook(telegramUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Canny post
     * @param {UpdateCannyPostRequest} updateCannyPostRequest Request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalApi
     */
    public updateCannyPost(updateCannyPostRequest: UpdateCannyPostRequest, options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).updateCannyPost(updateCannyPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a slack profile status based on energy levels
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalApi
     */
    public updateSlackProfileStatus(code: string, options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).updateSlackProfileStatus(code, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntegrationsApi - axios parameter creator
 * @export
 */
export const IntegrationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Exchange code for todo integrations
         * @param {string} code 
         * @param {string} todoType TodoIntegrationType
         * @param {string} [redirectUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeCode: async (code: string, todoType: string, redirectUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('exchangeCode', 'code', code)
            // verify required parameter 'todoType' is not null or undefined
            assertParamExists('exchangeCode', 'todoType', todoType)
            const localVarPath = `/api/v1/integrations/todo/exchangeCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirectUrl'] = redirectUrl;
            }

            if (todoType !== undefined) {
                localVarQueryParameter['todoType'] = todoType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a Terra widget
         * @param {string} metricId Metric ID
         * @param {string} [redirectTo] Redirect to URL
         * @param {string} [sourceType] Source type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTerraWidget: async (metricId: string, redirectTo?: string, sourceType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('generateTerraWidget', 'metricId', metricId)
            const localVarPath = `/api/v1/integrations/terra/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (redirectTo !== undefined) {
                localVarQueryParameter['redirectTo'] = redirectTo;
            }

            if (sourceType !== undefined) {
                localVarQueryParameter['sourceType'] = sourceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generate auth url for todo integrations
         * @param {string} todoType TodoIntegrationType
         * @param {string} [callback] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTodoAuthUrl: async (todoType: string, callback?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoType' is not null or undefined
            assertParamExists('generateTodoAuthUrl', 'todoType', todoType)
            const localVarPath = `/api/v1/integrations/todo/generateAuthUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (todoType !== undefined) {
                localVarQueryParameter['todoType'] = todoType;
            }

            if (callback !== undefined) {
                localVarQueryParameter['callback'] = callback;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Calendly available slots
         * @param {string} calendlyIntegId 
         * @param {string} startTime 
         * @param {string} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendlyAvailableSlots: async (calendlyIntegId: string, startTime: string, endTime: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendlyIntegId' is not null or undefined
            assertParamExists('getCalendlyAvailableSlots', 'calendlyIntegId', calendlyIntegId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getCalendlyAvailableSlots', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getCalendlyAvailableSlots', 'endTime', endTime)
            const localVarPath = `/api/v1/integrations/calendly/{calendlyIntegId}/slots`
                .replace(`{${"calendlyIntegId"}}`, encodeURIComponent(String(calendlyIntegId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch available event types for Calendly integration
         * @param {string} calendlyIntegId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendlyEventTypes: async (calendlyIntegId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendlyIntegId' is not null or undefined
            assertParamExists('getCalendlyEventTypes', 'calendlyIntegId', calendlyIntegId)
            const localVarPath = `/api/v1/integrations/calendly/{calendlyIntegId}/event-types`
                .replace(`{${"calendlyIntegId"}}`, encodeURIComponent(String(calendlyIntegId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Calendly integration info
         * @param {string} calendlyIntegId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendlyIntegInfo: async (calendlyIntegId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendlyIntegId' is not null or undefined
            assertParamExists('getCalendlyIntegInfo', 'calendlyIntegId', calendlyIntegId)
            const localVarPath = `/api/v1/integrations/calendly/{calendlyIntegId}`
                .replace(`{${"calendlyIntegId"}}`, encodeURIComponent(String(calendlyIntegId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch todo boards for a given todo type
         * @param {string} todoType TodoIntegrationType
         * @param {string} token 
         * @param {string} [search] Optional Notion search text
         * @param {number} [limit] Optional Notion result cap (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOriginalTodoBoards: async (todoType: string, token: string, search?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoType' is not null or undefined
            assertParamExists('getOriginalTodoBoards', 'todoType', todoType)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getOriginalTodoBoards', 'token', token)
            const localVarPath = `/api/v1/integrations/todo/originalBoards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (todoType !== undefined) {
                localVarQueryParameter['todoType'] = todoType;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the Terra user status
         * @param {Array<string>} terraUserIds User ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraUserStatus: async (terraUserIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraUserIds' is not null or undefined
            assertParamExists('getTerraUserStatus', 'terraUserIds', terraUserIds)
            const localVarPath = `/api/v1/integrations/terra/auth/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (terraUserIds) {
                localVarQueryParameter['terraUserIds[]'] = terraUserIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get todo integrations
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoIntegrations: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTodoIntegrations', 'userId', userId)
            const localVarPath = `/api/v1/integrations/todo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initialize Calendly integration
         * @param {string} userId 
         * @param {InitCalendlyBody} initCalendlyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initCalendly: async (userId: string, initCalendlyBody: InitCalendlyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('initCalendly', 'userId', userId)
            // verify required parameter 'initCalendlyBody' is not null or undefined
            assertParamExists('initCalendly', 'initCalendlyBody', initCalendlyBody)
            const localVarPath = `/api/v1/integrations/calendly/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initCalendlyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initialize todo integrations
         * @param {string} todoType TodoIntegrationType
         * @param {string} token 
         * @param {string} userId 
         * @param {string} [refreshToken] 
         * @param {string} [tokenExpiryDate] 
         * @param {boolean} [shouldSyncTasks] 
         * @param {InitTodoPutReq} [initTodoPutReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initTodoIntegrations: async (todoType: string, token: string, userId: string, refreshToken?: string, tokenExpiryDate?: string, shouldSyncTasks?: boolean, initTodoPutReq?: InitTodoPutReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoType' is not null or undefined
            assertParamExists('initTodoIntegrations', 'todoType', todoType)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('initTodoIntegrations', 'token', token)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('initTodoIntegrations', 'userId', userId)
            const localVarPath = `/api/v1/integrations/todo/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (todoType !== undefined) {
                localVarQueryParameter['todoType'] = todoType;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (refreshToken !== undefined) {
                localVarQueryParameter['refreshToken'] = refreshToken;
            }

            if (tokenExpiryDate !== undefined) {
                localVarQueryParameter['tokenExpiryDate'] = tokenExpiryDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (shouldSyncTasks !== undefined) {
                localVarQueryParameter['shouldSyncTasks'] = shouldSyncTasks;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initTodoPutReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove todo integrations
         * @param {string} userId 
         * @param {string} todoIntegrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTodoIntegration: async (userId: string, todoIntegrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeTodoIntegration', 'userId', userId)
            // verify required parameter 'todoIntegrationId' is not null or undefined
            assertParamExists('removeTodoIntegration', 'todoIntegrationId', todoIntegrationId)
            const localVarPath = `/api/v1/integrations/todo/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (todoIntegrationId !== undefined) {
                localVarQueryParameter['todoIntegrationId'] = todoIntegrationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Calendly preferences
         * @param {string} calendlyIntegId 
         * @param {object} body Partial&lt;CalendlyPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendlyPreference: async (calendlyIntegId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendlyIntegId' is not null or undefined
            assertParamExists('updateCalendlyPreference', 'calendlyIntegId', calendlyIntegId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCalendlyPreference', 'body', body)
            const localVarPath = `/api/v1/integrations/calendly/preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (calendlyIntegId !== undefined) {
                localVarQueryParameter['calendlyIntegId'] = calendlyIntegId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationsApi - functional programming interface
 * @export
 */
export const IntegrationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Exchange code for todo integrations
         * @param {string} code 
         * @param {string} todoType TodoIntegrationType
         * @param {string} [redirectUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeCode(code: string, todoType: string, redirectUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeCode(code, todoType, redirectUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.exchangeCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate a Terra widget
         * @param {string} metricId Metric ID
         * @param {string} [redirectTo] Redirect to URL
         * @param {string} [sourceType] Source type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTerraWidget(metricId: string, redirectTo?: string, sourceType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTerraWidget(metricId, redirectTo, sourceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.generateTerraWidget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary generate auth url for todo integrations
         * @param {string} todoType TodoIntegrationType
         * @param {string} [callback] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTodoAuthUrl(todoType: string, callback?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTodoAuthUrl(todoType, callback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.generateTodoAuthUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch Calendly available slots
         * @param {string} calendlyIntegId 
         * @param {string} startTime 
         * @param {string} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendlyAvailableSlots(calendlyIntegId: string, startTime: string, endTime: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCalendlyAvailableSlotsRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendlyAvailableSlots(calendlyIntegId, startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.getCalendlyAvailableSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch available event types for Calendly integration
         * @param {string} calendlyIntegId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendlyEventTypes(calendlyIntegId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendlyEventTypes(calendlyIntegId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.getCalendlyEventTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch Calendly integration info
         * @param {string} calendlyIntegId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendlyIntegInfo(calendlyIntegId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendlyIntegInfo(calendlyIntegId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.getCalendlyIntegInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch todo boards for a given todo type
         * @param {string} todoType TodoIntegrationType
         * @param {string} token 
         * @param {string} [search] Optional Notion search text
         * @param {number} [limit] Optional Notion result cap (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOriginalTodoBoards(todoType: string, token: string, search?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOriginalTodoBoards(todoType, token, search, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.getOriginalTodoBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the Terra user status
         * @param {Array<string>} terraUserIds User ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraUserStatus(terraUserIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTerraUserStatusRes>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraUserStatus(terraUserIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.getTerraUserStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get todo integrations
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodoIntegrations(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodoIntegrations(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.getTodoIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initialize Calendly integration
         * @param {string} userId 
         * @param {InitCalendlyBody} initCalendlyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initCalendly(userId: string, initCalendlyBody: InitCalendlyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitCalendlyRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initCalendly(userId, initCalendlyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.initCalendly']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initialize todo integrations
         * @param {string} todoType TodoIntegrationType
         * @param {string} token 
         * @param {string} userId 
         * @param {string} [refreshToken] 
         * @param {string} [tokenExpiryDate] 
         * @param {boolean} [shouldSyncTasks] 
         * @param {InitTodoPutReq} [initTodoPutReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initTodoIntegrations(todoType: string, token: string, userId: string, refreshToken?: string, tokenExpiryDate?: string, shouldSyncTasks?: boolean, initTodoPutReq?: InitTodoPutReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitTodoPutRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initTodoIntegrations(todoType, token, userId, refreshToken, tokenExpiryDate, shouldSyncTasks, initTodoPutReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.initTodoIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove todo integrations
         * @param {string} userId 
         * @param {string} todoIntegrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTodoIntegration(userId: string, todoIntegrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTodoIntegration(userId, todoIntegrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.removeTodoIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Calendly preferences
         * @param {string} calendlyIntegId 
         * @param {object} body Partial&lt;CalendlyPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendlyPreference(calendlyIntegId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendlyPreference(calendlyIntegId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.updateCalendlyPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntegrationsApi - factory interface
 * @export
 */
export const IntegrationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Exchange code for todo integrations
         * @param {string} code 
         * @param {string} todoType TodoIntegrationType
         * @param {string} [redirectUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeCode(code: string, todoType: string, redirectUrl?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.exchangeCode(code, todoType, redirectUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a Terra widget
         * @param {string} metricId Metric ID
         * @param {string} [redirectTo] Redirect to URL
         * @param {string} [sourceType] Source type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTerraWidget(metricId: string, redirectTo?: string, sourceType?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.generateTerraWidget(metricId, redirectTo, sourceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generate auth url for todo integrations
         * @param {string} todoType TodoIntegrationType
         * @param {string} [callback] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTodoAuthUrl(todoType: string, callback?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generateTodoAuthUrl(todoType, callback, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch Calendly available slots
         * @param {string} calendlyIntegId 
         * @param {string} startTime 
         * @param {string} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendlyAvailableSlots(calendlyIntegId: string, startTime: string, endTime: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCalendlyAvailableSlotsRes> {
            return localVarFp.getCalendlyAvailableSlots(calendlyIntegId, startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch available event types for Calendly integration
         * @param {string} calendlyIntegId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendlyEventTypes(calendlyIntegId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getCalendlyEventTypes(calendlyIntegId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch Calendly integration info
         * @param {string} calendlyIntegId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendlyIntegInfo(calendlyIntegId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getCalendlyIntegInfo(calendlyIntegId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch todo boards for a given todo type
         * @param {string} todoType TodoIntegrationType
         * @param {string} token 
         * @param {string} [search] Optional Notion search text
         * @param {number} [limit] Optional Notion result cap (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOriginalTodoBoards(todoType: string, token: string, search?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getOriginalTodoBoards(todoType, token, search, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the Terra user status
         * @param {Array<string>} terraUserIds User ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraUserStatus(terraUserIds: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetTerraUserStatusRes>> {
            return localVarFp.getTerraUserStatus(terraUserIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get todo integrations
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoIntegrations(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getTodoIntegrations(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initialize Calendly integration
         * @param {string} userId 
         * @param {InitCalendlyBody} initCalendlyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initCalendly(userId: string, initCalendlyBody: InitCalendlyBody, options?: RawAxiosRequestConfig): AxiosPromise<InitCalendlyRes> {
            return localVarFp.initCalendly(userId, initCalendlyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initialize todo integrations
         * @param {string} todoType TodoIntegrationType
         * @param {string} token 
         * @param {string} userId 
         * @param {string} [refreshToken] 
         * @param {string} [tokenExpiryDate] 
         * @param {boolean} [shouldSyncTasks] 
         * @param {InitTodoPutReq} [initTodoPutReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initTodoIntegrations(todoType: string, token: string, userId: string, refreshToken?: string, tokenExpiryDate?: string, shouldSyncTasks?: boolean, initTodoPutReq?: InitTodoPutReq, options?: RawAxiosRequestConfig): AxiosPromise<InitTodoPutRes> {
            return localVarFp.initTodoIntegrations(todoType, token, userId, refreshToken, tokenExpiryDate, shouldSyncTasks, initTodoPutReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove todo integrations
         * @param {string} userId 
         * @param {string} todoIntegrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTodoIntegration(userId: string, todoIntegrationId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.removeTodoIntegration(userId, todoIntegrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Calendly preferences
         * @param {string} calendlyIntegId 
         * @param {object} body Partial&lt;CalendlyPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendlyPreference(calendlyIntegId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateCalendlyPreference(calendlyIntegId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationsApi - object-oriented interface
 * @export
 * @class IntegrationsApi
 * @extends {BaseAPI}
 */
export class IntegrationsApi extends BaseAPI {
    /**
     * 
     * @summary Exchange code for todo integrations
     * @param {string} code 
     * @param {string} todoType TodoIntegrationType
     * @param {string} [redirectUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public exchangeCode(code: string, todoType: string, redirectUrl?: string, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).exchangeCode(code, todoType, redirectUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate a Terra widget
     * @param {string} metricId Metric ID
     * @param {string} [redirectTo] Redirect to URL
     * @param {string} [sourceType] Source type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public generateTerraWidget(metricId: string, redirectTo?: string, sourceType?: string, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).generateTerraWidget(metricId, redirectTo, sourceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generate auth url for todo integrations
     * @param {string} todoType TodoIntegrationType
     * @param {string} [callback] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public generateTodoAuthUrl(todoType: string, callback?: string, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).generateTodoAuthUrl(todoType, callback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch Calendly available slots
     * @param {string} calendlyIntegId 
     * @param {string} startTime 
     * @param {string} endTime 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public getCalendlyAvailableSlots(calendlyIntegId: string, startTime: string, endTime: string, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).getCalendlyAvailableSlots(calendlyIntegId, startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch available event types for Calendly integration
     * @param {string} calendlyIntegId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public getCalendlyEventTypes(calendlyIntegId: string, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).getCalendlyEventTypes(calendlyIntegId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch Calendly integration info
     * @param {string} calendlyIntegId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public getCalendlyIntegInfo(calendlyIntegId: string, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).getCalendlyIntegInfo(calendlyIntegId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch todo boards for a given todo type
     * @param {string} todoType TodoIntegrationType
     * @param {string} token 
     * @param {string} [search] Optional Notion search text
     * @param {number} [limit] Optional Notion result cap (default 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public getOriginalTodoBoards(todoType: string, token: string, search?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).getOriginalTodoBoards(todoType, token, search, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the Terra user status
     * @param {Array<string>} terraUserIds User ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public getTerraUserStatus(terraUserIds: Array<string>, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).getTerraUserStatus(terraUserIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get todo integrations
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public getTodoIntegrations(userId: string, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).getTodoIntegrations(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initialize Calendly integration
     * @param {string} userId 
     * @param {InitCalendlyBody} initCalendlyBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public initCalendly(userId: string, initCalendlyBody: InitCalendlyBody, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).initCalendly(userId, initCalendlyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initialize todo integrations
     * @param {string} todoType TodoIntegrationType
     * @param {string} token 
     * @param {string} userId 
     * @param {string} [refreshToken] 
     * @param {string} [tokenExpiryDate] 
     * @param {boolean} [shouldSyncTasks] 
     * @param {InitTodoPutReq} [initTodoPutReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public initTodoIntegrations(todoType: string, token: string, userId: string, refreshToken?: string, tokenExpiryDate?: string, shouldSyncTasks?: boolean, initTodoPutReq?: InitTodoPutReq, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).initTodoIntegrations(todoType, token, userId, refreshToken, tokenExpiryDate, shouldSyncTasks, initTodoPutReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove todo integrations
     * @param {string} userId 
     * @param {string} todoIntegrationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public removeTodoIntegration(userId: string, todoIntegrationId: string, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).removeTodoIntegration(userId, todoIntegrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Calendly preferences
     * @param {string} calendlyIntegId 
     * @param {object} body Partial&lt;CalendlyPreference&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public updateCalendlyPreference(calendlyIntegId: string, body: object, options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).updateCalendlyPreference(calendlyIntegId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Stop a v5 chat / daily-plan job. Thin proxy to science. A dropped SSE connection still does not cancel (reload recovery); this is the explicit stop.
         * @param {string} jobId Job ID returned in the leading &#x60;job&#x60; SSE event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('cancelJob', 'jobId', jobId)
            const localVarPath = `/api/v1/jobs/{jobId}/cancel`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll a v5 chat / daily-plan job\'s status and accumulated result. Thin proxy to science — no state kept in this tier. 404 when the job id doesn\'t exist or expired (jobs TTL is 6 hours).
         * @param {string} jobId Job ID returned in the leading &#x60;job&#x60; SSE event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatus: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobStatus', 'jobId', jobId)
            const localVarPath = `/api/v1/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Stop a v5 chat / daily-plan job. Thin proxy to science. A dropped SSE connection still does not cancel (reload recovery); this is the explicit stop.
         * @param {string} jobId Job ID returned in the leading &#x60;job&#x60; SSE event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.cancelJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Poll a v5 chat / daily-plan job\'s status and accumulated result. Thin proxy to science — no state kept in this tier. 404 when the job id doesn\'t exist or expired (jobs TTL is 6 hours).
         * @param {string} jobId Job ID returned in the leading &#x60;job&#x60; SSE event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobStatus(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobStatusRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobStatus(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * 
         * @summary Stop a v5 chat / daily-plan job. Thin proxy to science. A dropped SSE connection still does not cancel (reload recovery); this is the explicit stop.
         * @param {string} jobId Job ID returned in the leading &#x60;job&#x60; SSE event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelJob(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.cancelJob(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll a v5 chat / daily-plan job\'s status and accumulated result. Thin proxy to science — no state kept in this tier. 404 when the job id doesn\'t exist or expired (jobs TTL is 6 hours).
         * @param {string} jobId Job ID returned in the leading &#x60;job&#x60; SSE event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatus(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<JobStatusRes> {
            return localVarFp.getJobStatus(jobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * 
     * @summary Stop a v5 chat / daily-plan job. Thin proxy to science. A dropped SSE connection still does not cancel (reload recovery); this is the explicit stop.
     * @param {string} jobId Job ID returned in the leading &#x60;job&#x60; SSE event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public cancelJob(jobId: string, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).cancelJob(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll a v5 chat / daily-plan job\'s status and accumulated result. Thin proxy to science — no state kept in this tier. 404 when the job id doesn\'t exist or expired (jobs TTL is 6 hours).
     * @param {string} jobId Job ID returned in the leading &#x60;job&#x60; SSE event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobStatus(jobId: string, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobStatus(jobId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MetricsApi - axios parameter creator
 * @export
 */
export const MetricsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Consume Terra webhook
         * @param {MetricsWebhookTerraPutReq} [metricsWebhookTerraPutReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeTerraWebhook: async (metricsWebhookTerraPutReq?: MetricsWebhookTerraPutReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/metrics/webhook/terra`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metricsWebhookTerraPutReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete nap detail
         * @param {string} metricId 
         * @param {string} userId 
         * @param {string} date YYYY-MM-DD
         * @param {string} metricNapId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNapDetails: async (metricId: string, userId: string, date: string, metricNapId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('deleteNapDetails', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteNapDetails', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('deleteNapDetails', 'date', date)
            // verify required parameter 'metricNapId' is not null or undefined
            assertParamExists('deleteNapDetails', 'metricNapId', metricNapId)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}/nap`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (metricNapId !== undefined) {
                localVarQueryParameter['metricNapId'] = metricNapId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Diagnose chronotype
         * @param {string} userId 
         * @param {string} metricId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnoseChronotype: async (userId: string, metricId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('diagnoseChronotype', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('diagnoseChronotype', 'metricId', metricId)
            const localVarPath = `/api/v1/metrics/sleep/diagnoseChronotype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch real-time AQI data from the Open-Meteo Air Quality API
         * @param {string} metricId 
         * @param {number} lat Latitude
         * @param {number} lng Longitude
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAqiSignal: async (metricId: string, lat: number, lng: number, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getAqiSignal', 'metricId', metricId)
            // verify required parameter 'lat' is not null or undefined
            assertParamExists('getAqiSignal', 'lat', lat)
            // verify required parameter 'lng' is not null or undefined
            assertParamExists('getAqiSignal', 'lng', lng)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getAqiSignal', 'date', date)
            const localVarPath = `/api/v1/metrics/weather/{metricId}/aqi`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get exercise details
         * @param {string} metricId 
         * @param {Array<string>} dates 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseDetails: async (metricId: string, dates: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getExerciseDetails', 'metricId', metricId)
            // verify required parameter 'dates' is not null or undefined
            assertParamExists('getExerciseDetails', 'dates', dates)
            const localVarPath = `/api/v1/metrics/exercise/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dates) {
                localVarQueryParameter['dates[]'] = dates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get heart rate details
         * @param {string} metricId 
         * @param {Array<string>} dates dates - List of YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeartRateDetails: async (metricId: string, dates: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getHeartRateDetails', 'metricId', metricId)
            // verify required parameter 'dates' is not null or undefined
            assertParamExists('getHeartRateDetails', 'dates', dates)
            const localVarPath = `/api/v1/metrics/heartRate/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dates) {
                localVarQueryParameter['dates[]'] = dates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get location signal(s)
         * @param {string} metricId 
         * @param {string} [startDate] YYYY-MM-DD
         * @param {string} [endDate] YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationSignalLatest: async (metricId: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getLocationSignalLatest', 'metricId', metricId)
            const localVarPath = `/api/v1/metrics/location/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get meal details
         * @param {string} metricId 
         * @param {Array<string>} dates dates - List of YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMealDetails: async (metricId: string, dates: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getMealDetails', 'metricId', metricId)
            // verify required parameter 'dates' is not null or undefined
            assertParamExists('getMealDetails', 'dates', dates)
            const localVarPath = `/api/v1/metrics/meal/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dates) {
                localVarQueryParameter['dates[]'] = dates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get meal prediction
         * @param {string} metricId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMealPrediction: async (metricId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getMealPrediction', 'metricId', metricId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getMealPrediction', 'date', date)
            const localVarPath = `/api/v1/metrics/meal/{metricId}/prediction`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get nap details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<string>} dates 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNapDetails: async (metricId: string, userId: string, dates: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getNapDetails', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getNapDetails', 'userId', userId)
            // verify required parameter 'dates' is not null or undefined
            assertParamExists('getNapDetails', 'dates', dates)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}/nap`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (dates) {
                localVarQueryParameter['dates[]'] = dates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get phase details
         * @param {string} metricId 
         * @param {Array<string>} dates dates - List of YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhases: async (metricId: string, dates: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getPhases', 'metricId', metricId)
            // verify required parameter 'dates' is not null or undefined
            assertParamExists('getPhases', 'dates', dates)
            const localVarPath = `/api/v1/metrics/phase/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dates) {
                localVarQueryParameter['dates[]'] = dates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<string>} dates 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepDetails: async (metricId: string, userId: string, dates: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getSleepDetails', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSleepDetails', 'userId', userId)
            // verify required parameter 'dates' is not null or undefined
            assertParamExists('getSleepDetails', 'dates', dates)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (dates) {
                localVarQueryParameter['dates[]'] = dates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sleep prediction
         * @param {string} metricId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepPrediction: async (metricId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getSleepPrediction', 'metricId', metricId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getSleepPrediction', 'date', date)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}/prediction`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get recent valid sleep details prioritized by device
         * @param {string} metricId 
         * @param {string} userId 
         * @param {number} [limit] Number of recent days to return (default 7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidSleep: async (metricId: string, userId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getValidSleep', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getValidSleep', 'userId', userId)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}/valid`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get weather signal(s)
         * @param {string} metricId 
         * @param {string} [startDate] YYYY-MM-DD
         * @param {string} [endDate] YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeatherSignalLatest: async (metricId: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getWeatherSignalLatest', 'metricId', metricId)
            const localVarPath = `/api/v1/metrics/weather/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get weekly sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {string} startDate start date - YYYY-MM-DD
         * @param {string} endDate end date - YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklySleepTrend: async (metricId: string, userId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getWeeklySleepTrend', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWeeklySleepTrend', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getWeeklySleepTrend', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getWeeklySleepTrend', 'endDate', endDate)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}/trend/weekly`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hide exercise activity
         * @param {string} metricId 
         * @param {string} date 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideExercise: async (metricId: string, date: string, activityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('hideExercise', 'metricId', metricId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('hideExercise', 'date', date)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('hideExercise', 'activityId', activityId)
            const localVarPath = `/api/v1/metrics/exercise/{metricId}/hide`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (activityId !== undefined) {
                localVarQueryParameter['activityId'] = activityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hide meal activity
         * @param {string} metricId 
         * @param {string} date date - YYYY-MM-DD
         * @param {string} mealActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideMeal: async (metricId: string, date: string, mealActivityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('hideMeal', 'metricId', metricId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('hideMeal', 'date', date)
            // verify required parameter 'mealActivityId' is not null or undefined
            assertParamExists('hideMeal', 'mealActivityId', mealActivityId)
            const localVarPath = `/api/v1/metrics/meal/{metricId}/hide`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (mealActivityId !== undefined) {
                localVarQueryParameter['mealActivityId'] = mealActivityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save heart rate data
         * @param {string} userId 
         * @param {string} date 
         * @param {string} device 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHeartRate: async (userId: string, date: string, device: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('saveHeartRate', 'userId', userId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('saveHeartRate', 'date', date)
            // verify required parameter 'device' is not null or undefined
            assertParamExists('saveHeartRate', 'device', device)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveHeartRate', 'body', body)
            const localVarPath = `/api/v1/metrics/heartRate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (device !== undefined) {
                localVarQueryParameter['device'] = device;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync exercise
         * @param {string} metricId 
         * @param {SyncExerciseBody} syncExerciseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncExercise: async (metricId: string, syncExerciseBody: SyncExerciseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('syncExercise', 'metricId', metricId)
            // verify required parameter 'syncExerciseBody' is not null or undefined
            assertParamExists('syncExercise', 'syncExerciseBody', syncExerciseBody)
            const localVarPath = `/api/v1/metrics/exercise/{metricId}/sync`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncExerciseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync meal
         * @param {string} metricId 
         * @param {SyncMealBody} syncMealBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMeal: async (metricId: string, syncMealBody: SyncMealBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('syncMeal', 'metricId', metricId)
            // verify required parameter 'syncMealBody' is not null or undefined
            assertParamExists('syncMeal', 'syncMealBody', syncMealBody)
            const localVarPath = `/api/v1/metrics/meal/{metricId}/sync`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncMealBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync location + weather + more into metrics subcollection
         * @param {string} metricId 
         * @param {SyncLocationPayload} syncLocationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMetricsContext: async (metricId: string, syncLocationPayload: SyncLocationPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('syncMetricsContext', 'metricId', metricId)
            // verify required parameter 'syncLocationPayload' is not null or undefined
            assertParamExists('syncMetricsContext', 'syncLocationPayload', syncLocationPayload)
            const localVarPath = `/api/v1/metrics/context/{metricId}/sync`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncLocationPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<string>} terraUserIds 
         * @param {string} startDate start date - isoDate
         * @param {string} endDate end date - isoDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSleepDetails: async (metricId: string, userId: string, terraUserIds: Array<string>, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('syncSleepDetails', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('syncSleepDetails', 'userId', userId)
            // verify required parameter 'terraUserIds' is not null or undefined
            assertParamExists('syncSleepDetails', 'terraUserIds', terraUserIds)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('syncSleepDetails', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('syncSleepDetails', 'endDate', endDate)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}/sync`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (terraUserIds) {
                localVarQueryParameter['terraUserIds[]'] = terraUserIds;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update exercise
         * @param {string} metricId 
         * @param {string} userId 
         * @param {UpdateExerciseBody} updateExerciseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExercise: async (metricId: string, userId: string, updateExerciseBody: UpdateExerciseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('updateExercise', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateExercise', 'userId', userId)
            // verify required parameter 'updateExerciseBody' is not null or undefined
            assertParamExists('updateExercise', 'updateExerciseBody', updateExerciseBody)
            const localVarPath = `/api/v1/metrics/exercise/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExerciseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update heart rate data
         * @param {string} metricId 
         * @param {Array<object>} requestBody MetricHeartRate[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHeartRate: async (metricId: string, requestBody: Array<object>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('updateHeartRate', 'metricId', metricId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateHeartRate', 'requestBody', requestBody)
            const localVarPath = `/api/v1/metrics/heartRate/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update location preference (home/work/custom addresses)
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;LocationPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationPreference: async (preferenceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updateLocationPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateLocationPreference', 'body', body)
            const localVarPath = `/api/v1/metrics/location/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update meal
         * @param {string} metricId 
         * @param {string} userId 
         * @param {UpdateMealBody} updateMealBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeal: async (metricId: string, userId: string, updateMealBody: UpdateMealBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('updateMeal', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateMeal', 'userId', userId)
            // verify required parameter 'updateMealBody' is not null or undefined
            assertParamExists('updateMeal', 'updateMealBody', updateMealBody)
            const localVarPath = `/api/v1/metrics/meal/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMealBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update meal prediction
         * @param {string} metricId 
         * @param {UpdateMealPredictionBody} updateMealPredictionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMealPrediction: async (metricId: string, updateMealPredictionBody: UpdateMealPredictionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('updateMealPrediction', 'metricId', metricId)
            // verify required parameter 'updateMealPredictionBody' is not null or undefined
            assertParamExists('updateMealPrediction', 'updateMealPredictionBody', updateMealPredictionBody)
            const localVarPath = `/api/v1/metrics/meal/{metricId}/prediction`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMealPredictionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update nap details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<object>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNapDetails: async (metricId: string, userId: string, requestBody: Array<object>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('updateNapDetails', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateNapDetails', 'userId', userId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateNapDetails', 'requestBody', requestBody)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}/nap`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<object>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSleepDetails: async (metricId: string, userId: string, requestBody: Array<object>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('updateSleepDetails', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateSleepDetails', 'userId', userId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateSleepDetails', 'requestBody', requestBody)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSleepDetails_1: async (metricId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('updateSleepDetails_1', 'metricId', metricId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateSleepDetails_1', 'userId', userId)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}/`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update sleep prediction
         * @param {string} metricId 
         * @param {UpdateSleepPredictionBody} updateSleepPredictionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSleepPrediction: async (metricId: string, updateSleepPredictionBody: UpdateSleepPredictionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('updateSleepPrediction', 'metricId', metricId)
            // verify required parameter 'updateSleepPredictionBody' is not null or undefined
            assertParamExists('updateSleepPrediction', 'updateSleepPredictionBody', updateSleepPredictionBody)
            const localVarPath = `/api/v1/metrics/sleep/{metricId}/prediction`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSleepPredictionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetricsApi - functional programming interface
 * @export
 */
export const MetricsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetricsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Consume Terra webhook
         * @param {MetricsWebhookTerraPutReq} [metricsWebhookTerraPutReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consumeTerraWebhook(metricsWebhookTerraPutReq?: MetricsWebhookTerraPutReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consumeTerraWebhook(metricsWebhookTerraPutReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.consumeTerraWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete nap detail
         * @param {string} metricId 
         * @param {string} userId 
         * @param {string} date YYYY-MM-DD
         * @param {string} metricNapId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNapDetails(metricId: string, userId: string, date: string, metricNapId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNapDetails(metricId, userId, date, metricNapId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.deleteNapDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Diagnose chronotype
         * @param {string} userId 
         * @param {string} metricId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async diagnoseChronotype(userId: string, metricId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.diagnoseChronotype(userId, metricId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.diagnoseChronotype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch real-time AQI data from the Open-Meteo Air Quality API
         * @param {string} metricId 
         * @param {number} lat Latitude
         * @param {number} lng Longitude
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAqiSignal(metricId: string, lat: number, lng: number, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAqiSignal(metricId, lat, lng, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getAqiSignal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get exercise details
         * @param {string} metricId 
         * @param {Array<string>} dates 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExerciseDetails(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExerciseDetails(metricId, dates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getExerciseDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get heart rate details
         * @param {string} metricId 
         * @param {Array<string>} dates dates - List of YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHeartRateDetails(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHeartRateDetails(metricId, dates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getHeartRateDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get location signal(s)
         * @param {string} metricId 
         * @param {string} [startDate] YYYY-MM-DD
         * @param {string} [endDate] YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationSignalLatest(metricId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationSignalLatest(metricId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getLocationSignalLatest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get meal details
         * @param {string} metricId 
         * @param {Array<string>} dates dates - List of YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMealDetails(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMealDetails(metricId, dates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getMealDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get meal prediction
         * @param {string} metricId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMealPrediction(metricId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMealPrediction(metricId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getMealPrediction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get nap details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<string>} dates 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNapDetails(metricId: string, userId: string, dates: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNapDetails(metricId, userId, dates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getNapDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get phase details
         * @param {string} metricId 
         * @param {Array<string>} dates dates - List of YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhases(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhases(metricId, dates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getPhases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<string>} dates 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSleepDetails(metricId: string, userId: string, dates: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSleepDetails(metricId, userId, dates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getSleepDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sleep prediction
         * @param {string} metricId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSleepPrediction(metricId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSleepPrediction(metricId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getSleepPrediction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get recent valid sleep details prioritized by device
         * @param {string} metricId 
         * @param {string} userId 
         * @param {number} [limit] Number of recent days to return (default 7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidSleep(metricId: string, userId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidSleep(metricId, userId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getValidSleep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get weather signal(s)
         * @param {string} metricId 
         * @param {string} [startDate] YYYY-MM-DD
         * @param {string} [endDate] YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeatherSignalLatest(metricId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeatherSignalLatest(metricId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getWeatherSignalLatest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get weekly sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {string} startDate start date - YYYY-MM-DD
         * @param {string} endDate end date - YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklySleepTrend(metricId: string, userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SleepDataTrendWeeklyRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklySleepTrend(metricId, userId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getWeeklySleepTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hide exercise activity
         * @param {string} metricId 
         * @param {string} date 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hideExercise(metricId: string, date: string, activityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hideExercise(metricId, date, activityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.hideExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hide meal activity
         * @param {string} metricId 
         * @param {string} date date - YYYY-MM-DD
         * @param {string} mealActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hideMeal(metricId: string, date: string, mealActivityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hideMeal(metricId, date, mealActivityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.hideMeal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save heart rate data
         * @param {string} userId 
         * @param {string} date 
         * @param {string} device 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveHeartRate(userId: string, date: string, device: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveHeartRate(userId, date, device, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.saveHeartRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync exercise
         * @param {string} metricId 
         * @param {SyncExerciseBody} syncExerciseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncExercise(metricId: string, syncExerciseBody: SyncExerciseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncSuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncExercise(metricId, syncExerciseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.syncExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync meal
         * @param {string} metricId 
         * @param {SyncMealBody} syncMealBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncMeal(metricId: string, syncMealBody: SyncMealBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncSuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncMeal(metricId, syncMealBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.syncMeal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync location + weather + more into metrics subcollection
         * @param {string} metricId 
         * @param {SyncLocationPayload} syncLocationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncMetricsContext(metricId: string, syncLocationPayload: SyncLocationPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncMetricsContext(metricId, syncLocationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.syncMetricsContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<string>} terraUserIds 
         * @param {string} startDate start date - isoDate
         * @param {string} endDate end date - isoDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncSleepDetails(metricId: string, userId: string, terraUserIds: Array<string>, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncSuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncSleepDetails(metricId, userId, terraUserIds, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.syncSleepDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update exercise
         * @param {string} metricId 
         * @param {string} userId 
         * @param {UpdateExerciseBody} updateExerciseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExercise(metricId: string, userId: string, updateExerciseBody: UpdateExerciseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExercise(metricId, userId, updateExerciseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.updateExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update heart rate data
         * @param {string} metricId 
         * @param {Array<object>} requestBody MetricHeartRate[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHeartRate(metricId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateHeartRate200Res>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHeartRate(metricId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.updateHeartRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update location preference (home/work/custom addresses)
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;LocationPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocationPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocationPreference(preferenceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.updateLocationPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update meal
         * @param {string} metricId 
         * @param {string} userId 
         * @param {UpdateMealBody} updateMealBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMeal(metricId: string, userId: string, updateMealBody: UpdateMealBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMeal(metricId, userId, updateMealBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.updateMeal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update meal prediction
         * @param {string} metricId 
         * @param {UpdateMealPredictionBody} updateMealPredictionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMealPrediction(metricId: string, updateMealPredictionBody: UpdateMealPredictionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMealPrediction(metricId, updateMealPredictionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.updateMealPrediction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update nap details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<object>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNapDetails(metricId: string, userId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNapDetails(metricId, userId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.updateNapDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<object>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSleepDetails(metricId: string, userId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSleepDetails(metricId, userId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.updateSleepDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSleepDetails_1(metricId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSleepDetails_1(metricId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.updateSleepDetails_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update sleep prediction
         * @param {string} metricId 
         * @param {UpdateSleepPredictionBody} updateSleepPredictionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSleepPrediction(metricId: string, updateSleepPredictionBody: UpdateSleepPredictionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSleepPrediction(metricId, updateSleepPredictionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.updateSleepPrediction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetricsApi - factory interface
 * @export
 */
export const MetricsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetricsApiFp(configuration)
    return {
        /**
         * 
         * @summary Consume Terra webhook
         * @param {MetricsWebhookTerraPutReq} [metricsWebhookTerraPutReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeTerraWebhook(metricsWebhookTerraPutReq?: MetricsWebhookTerraPutReq, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.consumeTerraWebhook(metricsWebhookTerraPutReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete nap detail
         * @param {string} metricId 
         * @param {string} userId 
         * @param {string} date YYYY-MM-DD
         * @param {string} metricNapId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNapDetails(metricId: string, userId: string, date: string, metricNapId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.deleteNapDetails(metricId, userId, date, metricNapId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Diagnose chronotype
         * @param {string} userId 
         * @param {string} metricId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnoseChronotype(userId: string, metricId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.diagnoseChronotype(userId, metricId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch real-time AQI data from the Open-Meteo Air Quality API
         * @param {string} metricId 
         * @param {number} lat Latitude
         * @param {number} lng Longitude
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAqiSignal(metricId: string, lat: number, lng: number, date: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getAqiSignal(metricId, lat, lng, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get exercise details
         * @param {string} metricId 
         * @param {Array<string>} dates 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseDetails(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getExerciseDetails(metricId, dates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get heart rate details
         * @param {string} metricId 
         * @param {Array<string>} dates dates - List of YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeartRateDetails(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getHeartRateDetails(metricId, dates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get location signal(s)
         * @param {string} metricId 
         * @param {string} [startDate] YYYY-MM-DD
         * @param {string} [endDate] YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationSignalLatest(metricId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getLocationSignalLatest(metricId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get meal details
         * @param {string} metricId 
         * @param {Array<string>} dates dates - List of YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMealDetails(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getMealDetails(metricId, dates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get meal prediction
         * @param {string} metricId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMealPrediction(metricId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getMealPrediction(metricId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get nap details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<string>} dates 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNapDetails(metricId: string, userId: string, dates: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getNapDetails(metricId, userId, dates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get phase details
         * @param {string} metricId 
         * @param {Array<string>} dates dates - List of YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhases(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getPhases(metricId, dates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<string>} dates 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepDetails(metricId: string, userId: string, dates: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getSleepDetails(metricId, userId, dates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sleep prediction
         * @param {string} metricId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepPrediction(metricId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getSleepPrediction(metricId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get recent valid sleep details prioritized by device
         * @param {string} metricId 
         * @param {string} userId 
         * @param {number} [limit] Number of recent days to return (default 7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidSleep(metricId: string, userId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getValidSleep(metricId, userId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get weather signal(s)
         * @param {string} metricId 
         * @param {string} [startDate] YYYY-MM-DD
         * @param {string} [endDate] YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeatherSignalLatest(metricId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getWeatherSignalLatest(metricId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get weekly sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {string} startDate start date - YYYY-MM-DD
         * @param {string} endDate end date - YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklySleepTrend(metricId: string, userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<SleepDataTrendWeeklyRes> {
            return localVarFp.getWeeklySleepTrend(metricId, userId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hide exercise activity
         * @param {string} metricId 
         * @param {string} date 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideExercise(metricId: string, date: string, activityId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.hideExercise(metricId, date, activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hide meal activity
         * @param {string} metricId 
         * @param {string} date date - YYYY-MM-DD
         * @param {string} mealActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideMeal(metricId: string, date: string, mealActivityId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.hideMeal(metricId, date, mealActivityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save heart rate data
         * @param {string} userId 
         * @param {string} date 
         * @param {string} device 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHeartRate(userId: string, date: string, device: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.saveHeartRate(userId, date, device, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync exercise
         * @param {string} metricId 
         * @param {SyncExerciseBody} syncExerciseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncExercise(metricId: string, syncExerciseBody: SyncExerciseBody, options?: RawAxiosRequestConfig): AxiosPromise<SyncSuccessRes> {
            return localVarFp.syncExercise(metricId, syncExerciseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync meal
         * @param {string} metricId 
         * @param {SyncMealBody} syncMealBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMeal(metricId: string, syncMealBody: SyncMealBody, options?: RawAxiosRequestConfig): AxiosPromise<SyncSuccessRes> {
            return localVarFp.syncMeal(metricId, syncMealBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync location + weather + more into metrics subcollection
         * @param {string} metricId 
         * @param {SyncLocationPayload} syncLocationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMetricsContext(metricId: string, syncLocationPayload: SyncLocationPayload, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.syncMetricsContext(metricId, syncLocationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<string>} terraUserIds 
         * @param {string} startDate start date - isoDate
         * @param {string} endDate end date - isoDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSleepDetails(metricId: string, userId: string, terraUserIds: Array<string>, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<SyncSuccessRes> {
            return localVarFp.syncSleepDetails(metricId, userId, terraUserIds, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update exercise
         * @param {string} metricId 
         * @param {string} userId 
         * @param {UpdateExerciseBody} updateExerciseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExercise(metricId: string, userId: string, updateExerciseBody: UpdateExerciseBody, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateExercise(metricId, userId, updateExerciseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update heart rate data
         * @param {string} metricId 
         * @param {Array<object>} requestBody MetricHeartRate[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHeartRate(metricId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): AxiosPromise<UpdateHeartRate200Res> {
            return localVarFp.updateHeartRate(metricId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update location preference (home/work/custom addresses)
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;LocationPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateLocationPreference(preferenceId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update meal
         * @param {string} metricId 
         * @param {string} userId 
         * @param {UpdateMealBody} updateMealBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeal(metricId: string, userId: string, updateMealBody: UpdateMealBody, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateMeal(metricId, userId, updateMealBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update meal prediction
         * @param {string} metricId 
         * @param {UpdateMealPredictionBody} updateMealPredictionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMealPrediction(metricId: string, updateMealPredictionBody: UpdateMealPredictionBody, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateMealPrediction(metricId, updateMealPredictionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update nap details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<object>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNapDetails(metricId: string, userId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateNapDetails(metricId, userId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {Array<object>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSleepDetails(metricId: string, userId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateSleepDetails(metricId, userId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update sleep details
         * @param {string} metricId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSleepDetails_1(metricId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateSleepDetails_1(metricId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update sleep prediction
         * @param {string} metricId 
         * @param {UpdateSleepPredictionBody} updateSleepPredictionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSleepPrediction(metricId: string, updateSleepPredictionBody: UpdateSleepPredictionBody, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateSleepPrediction(metricId, updateSleepPredictionBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetricsApi - object-oriented interface
 * @export
 * @class MetricsApi
 * @extends {BaseAPI}
 */
export class MetricsApi extends BaseAPI {
    /**
     * 
     * @summary Consume Terra webhook
     * @param {MetricsWebhookTerraPutReq} [metricsWebhookTerraPutReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public consumeTerraWebhook(metricsWebhookTerraPutReq?: MetricsWebhookTerraPutReq, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).consumeTerraWebhook(metricsWebhookTerraPutReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete nap detail
     * @param {string} metricId 
     * @param {string} userId 
     * @param {string} date YYYY-MM-DD
     * @param {string} metricNapId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public deleteNapDetails(metricId: string, userId: string, date: string, metricNapId: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).deleteNapDetails(metricId, userId, date, metricNapId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Diagnose chronotype
     * @param {string} userId 
     * @param {string} metricId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public diagnoseChronotype(userId: string, metricId: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).diagnoseChronotype(userId, metricId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch real-time AQI data from the Open-Meteo Air Quality API
     * @param {string} metricId 
     * @param {number} lat Latitude
     * @param {number} lng Longitude
     * @param {string} date YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getAqiSignal(metricId: string, lat: number, lng: number, date: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getAqiSignal(metricId, lat, lng, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get exercise details
     * @param {string} metricId 
     * @param {Array<string>} dates 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getExerciseDetails(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getExerciseDetails(metricId, dates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get heart rate details
     * @param {string} metricId 
     * @param {Array<string>} dates dates - List of YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getHeartRateDetails(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getHeartRateDetails(metricId, dates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get location signal(s)
     * @param {string} metricId 
     * @param {string} [startDate] YYYY-MM-DD
     * @param {string} [endDate] YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getLocationSignalLatest(metricId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getLocationSignalLatest(metricId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get meal details
     * @param {string} metricId 
     * @param {Array<string>} dates dates - List of YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getMealDetails(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getMealDetails(metricId, dates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get meal prediction
     * @param {string} metricId 
     * @param {string} date YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getMealPrediction(metricId: string, date: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getMealPrediction(metricId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get nap details
     * @param {string} metricId 
     * @param {string} userId 
     * @param {Array<string>} dates 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getNapDetails(metricId: string, userId: string, dates: Array<string>, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getNapDetails(metricId, userId, dates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get phase details
     * @param {string} metricId 
     * @param {Array<string>} dates dates - List of YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getPhases(metricId: string, dates: Array<string>, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getPhases(metricId, dates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sleep details
     * @param {string} metricId 
     * @param {string} userId 
     * @param {Array<string>} dates 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getSleepDetails(metricId: string, userId: string, dates: Array<string>, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getSleepDetails(metricId, userId, dates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sleep prediction
     * @param {string} metricId 
     * @param {string} date YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getSleepPrediction(metricId: string, date: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getSleepPrediction(metricId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get recent valid sleep details prioritized by device
     * @param {string} metricId 
     * @param {string} userId 
     * @param {number} [limit] Number of recent days to return (default 7)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getValidSleep(metricId: string, userId: string, limit?: number, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getValidSleep(metricId, userId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get weather signal(s)
     * @param {string} metricId 
     * @param {string} [startDate] YYYY-MM-DD
     * @param {string} [endDate] YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getWeatherSignalLatest(metricId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getWeatherSignalLatest(metricId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get weekly sleep details
     * @param {string} metricId 
     * @param {string} userId 
     * @param {string} startDate start date - YYYY-MM-DD
     * @param {string} endDate end date - YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getWeeklySleepTrend(metricId: string, userId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getWeeklySleepTrend(metricId, userId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hide exercise activity
     * @param {string} metricId 
     * @param {string} date 
     * @param {string} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public hideExercise(metricId: string, date: string, activityId: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).hideExercise(metricId, date, activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hide meal activity
     * @param {string} metricId 
     * @param {string} date date - YYYY-MM-DD
     * @param {string} mealActivityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public hideMeal(metricId: string, date: string, mealActivityId: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).hideMeal(metricId, date, mealActivityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save heart rate data
     * @param {string} userId 
     * @param {string} date 
     * @param {string} device 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public saveHeartRate(userId: string, date: string, device: string, body: object, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).saveHeartRate(userId, date, device, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync exercise
     * @param {string} metricId 
     * @param {SyncExerciseBody} syncExerciseBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public syncExercise(metricId: string, syncExerciseBody: SyncExerciseBody, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).syncExercise(metricId, syncExerciseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync meal
     * @param {string} metricId 
     * @param {SyncMealBody} syncMealBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public syncMeal(metricId: string, syncMealBody: SyncMealBody, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).syncMeal(metricId, syncMealBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync location + weather + more into metrics subcollection
     * @param {string} metricId 
     * @param {SyncLocationPayload} syncLocationPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public syncMetricsContext(metricId: string, syncLocationPayload: SyncLocationPayload, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).syncMetricsContext(metricId, syncLocationPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync sleep details
     * @param {string} metricId 
     * @param {string} userId 
     * @param {Array<string>} terraUserIds 
     * @param {string} startDate start date - isoDate
     * @param {string} endDate end date - isoDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public syncSleepDetails(metricId: string, userId: string, terraUserIds: Array<string>, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).syncSleepDetails(metricId, userId, terraUserIds, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update exercise
     * @param {string} metricId 
     * @param {string} userId 
     * @param {UpdateExerciseBody} updateExerciseBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public updateExercise(metricId: string, userId: string, updateExerciseBody: UpdateExerciseBody, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).updateExercise(metricId, userId, updateExerciseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update heart rate data
     * @param {string} metricId 
     * @param {Array<object>} requestBody MetricHeartRate[]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public updateHeartRate(metricId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).updateHeartRate(metricId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update location preference (home/work/custom addresses)
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;LocationPreference&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public updateLocationPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).updateLocationPreference(preferenceId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update meal
     * @param {string} metricId 
     * @param {string} userId 
     * @param {UpdateMealBody} updateMealBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public updateMeal(metricId: string, userId: string, updateMealBody: UpdateMealBody, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).updateMeal(metricId, userId, updateMealBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update meal prediction
     * @param {string} metricId 
     * @param {UpdateMealPredictionBody} updateMealPredictionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public updateMealPrediction(metricId: string, updateMealPredictionBody: UpdateMealPredictionBody, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).updateMealPrediction(metricId, updateMealPredictionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update nap details
     * @param {string} metricId 
     * @param {string} userId 
     * @param {Array<object>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public updateNapDetails(metricId: string, userId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).updateNapDetails(metricId, userId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update sleep details
     * @param {string} metricId 
     * @param {string} userId 
     * @param {Array<object>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public updateSleepDetails(metricId: string, userId: string, requestBody: Array<object>, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).updateSleepDetails(metricId, userId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update sleep details
     * @param {string} metricId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public updateSleepDetails_1(metricId: string, userId: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).updateSleepDetails_1(metricId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update sleep prediction
     * @param {string} metricId 
     * @param {UpdateSleepPredictionBody} updateSleepPredictionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public updateSleepPrediction(metricId: string, updateSleepPredictionBody: UpdateSleepPredictionBody, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).updateSleepPrediction(metricId, updateSleepPredictionBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchedulerApi - axios parameter creator
 * @export
 */
export const SchedulerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new routine activity
         * @param {string} routineId 
         * @param {object} body RoutineActivity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoutineActivity: async (routineId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'routineId' is not null or undefined
            assertParamExists('createRoutineActivity', 'routineId', routineId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createRoutineActivity', 'body', body)
            const localVarPath = `/api/v1/scheduler/routine/{routineId}/activity`
                .replace(`{${"routineId"}}`, encodeURIComponent(String(routineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new scheduler rule
         * @param {string} userId 
         * @param {SchedulerRuleWithoutId} schedulerRuleWithoutId SchedulerRuleWithoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedulerRule: async (userId: string, schedulerRuleWithoutId: SchedulerRuleWithoutId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createSchedulerRule', 'userId', userId)
            // verify required parameter 'schedulerRuleWithoutId' is not null or undefined
            assertParamExists('createSchedulerRule', 'schedulerRuleWithoutId', schedulerRuleWithoutId)
            const localVarPath = `/api/v1/scheduler/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schedulerRuleWithoutId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a scheduler rule
         * @param {string} userId 
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedulerRule: async (userId: string, ruleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteSchedulerRule', 'userId', userId)
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('deleteSchedulerRule', 'ruleId', ruleId)
            const localVarPath = `/api/v1/scheduler/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Science-path alias of AI Scheduler V9. Web posts here with `job_id` in the body.
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDailyPlanV5: async (userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('generateDailyPlanV5', 'userId', userId)
            // verify required parameter 'runAISchedulerV5Params' is not null or undefined
            assertParamExists('generateDailyPlanV5', 'runAISchedulerV5Params', runAISchedulerV5Params)
            const localVarPath = `/api/v1/scheduler/daily_plan/generate/v5`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV5Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get energy-boost preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEnergyBoostPreference: async (preferenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('getEnergyBoostPreference', 'preferenceId', preferenceId)
            const localVarPath = `/api/v1/scheduler/preference/{preferenceId}/energyBoost`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get routine by ID
         * @param {string} routineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoutine: async (routineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'routineId' is not null or undefined
            assertParamExists('getRoutine', 'routineId', routineId)
            const localVarPath = `/api/v1/scheduler/routine/{routineId}`
                .replace(`{${"routineId"}}`, encodeURIComponent(String(routineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get scheduler preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSchedulerPreference: async (preferenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('getSchedulerPreference', 'preferenceId', preferenceId)
            const localVarPath = `/api/v1/scheduler/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all scheduler rules for a user
         * @param {string} userId 
         * @param {number} [limit] Maximum number of rules to return
         * @param {boolean} [hideHealthSummary] Whether to hide HEALTH_SUMMARY rules. Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulerRules: async (userId: string, limit?: number, hideHealthSummary?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSchedulerRules', 'userId', userId)
            const localVarPath = `/api/v1/scheduler/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (hideHealthSummary !== undefined) {
                localVarQueryParameter['hideHealthSummary'] = hideHealthSummary;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hide a routine activity
         * @param {string} routineId 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideRoutineActivity: async (routineId: string, activityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'routineId' is not null or undefined
            assertParamExists('hideRoutineActivity', 'routineId', routineId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('hideRoutineActivity', 'activityId', activityId)
            const localVarPath = `/api/v1/scheduler/routine/{routineId}/activity/{activityId}/hide`
                .replace(`{${"routineId"}}`, encodeURIComponent(String(routineId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run AI Replan Scheduler V5 (Returns before/after schedule changes)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        runAIReplanSchedulerV5: async (userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('runAIReplanSchedulerV5', 'userId', userId)
            // verify required parameter 'runAISchedulerV5Params' is not null or undefined
            assertParamExists('runAIReplanSchedulerV5', 'runAISchedulerV5Params', runAISchedulerV5Params)
            const localVarPath = `/api/v1/scheduler/aiScheduler/v5/replan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV5Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run AI Replan Scheduler V6 (Returns before/after schedule changes)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAIReplanSchedulerV6: async (userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('runAIReplanSchedulerV6', 'userId', userId)
            // verify required parameter 'runAISchedulerV5Params' is not null or undefined
            assertParamExists('runAIReplanSchedulerV6', 'runAISchedulerV5Params', runAISchedulerV5Params)
            const localVarPath = `/api/v1/scheduler/aiScheduler/v6/replan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV5Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run AI Scheduler V5 (Enhanced with Redis Memory)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        runAISchedulerV5: async (userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('runAISchedulerV5', 'userId', userId)
            // verify required parameter 'runAISchedulerV5Params' is not null or undefined
            assertParamExists('runAISchedulerV5', 'runAISchedulerV5Params', runAISchedulerV5Params)
            const localVarPath = `/api/v1/scheduler/aiScheduler/v5`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV5Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run AI Scheduler V5 (Streaming)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        runAISchedulerV5Stream: async (userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('runAISchedulerV5Stream', 'userId', userId)
            // verify required parameter 'runAISchedulerV5Params' is not null or undefined
            assertParamExists('runAISchedulerV5Stream', 'runAISchedulerV5Params', runAISchedulerV5Params)
            const localVarPath = `/api/v1/scheduler/aiScheduler/v5/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV5Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run AI Scheduler V6 (Streaming)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAISchedulerV6Stream: async (userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('runAISchedulerV6Stream', 'userId', userId)
            // verify required parameter 'runAISchedulerV5Params' is not null or undefined
            assertParamExists('runAISchedulerV6Stream', 'runAISchedulerV5Params', runAISchedulerV5Params)
            const localVarPath = `/api/v1/scheduler/aiScheduler/v6/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV5Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run AI Scheduler V7 (Streaming, daily_plan_v3)
         * @param {string} userId 
         * @param {RunAISchedulerV7Params} runAISchedulerV7Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAISchedulerV7Stream: async (userId: string, runAISchedulerV7Params: RunAISchedulerV7Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('runAISchedulerV7Stream', 'userId', userId)
            // verify required parameter 'runAISchedulerV7Params' is not null or undefined
            assertParamExists('runAISchedulerV7Stream', 'runAISchedulerV7Params', runAISchedulerV7Params)
            const localVarPath = `/api/v1/scheduler/aiScheduler/v7/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV7Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run AI Scheduler V8 (Streaming, daily_plan_v4)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAISchedulerV8Stream: async (userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('runAISchedulerV8Stream', 'userId', userId)
            // verify required parameter 'runAISchedulerV5Params' is not null or undefined
            assertParamExists('runAISchedulerV8Stream', 'runAISchedulerV5Params', runAISchedulerV5Params)
            const localVarPath = `/api/v1/scheduler/aiScheduler/v8/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV5Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run AI Scheduler V9 (Streaming, daily_plan_v5). Unlike v8, generation survives the client disconnecting (science runs it in a background thread and persists progress to Redis as a job); poll GET /api/v1/jobs/{jobId} to recover status/result later.
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAISchedulerV9Stream: async (userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('runAISchedulerV9Stream', 'userId', userId)
            // verify required parameter 'runAISchedulerV5Params' is not null or undefined
            assertParamExists('runAISchedulerV9Stream', 'runAISchedulerV5Params', runAISchedulerV5Params)
            const localVarPath = `/api/v1/scheduler/aiScheduler/v9/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV5Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run AI Stream V7 Mock (Streaming, onboarding)
         * @param {string} userId 
         * @param {RunAISchedulerV7Params} runAISchedulerV7Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAIStreamV7Mock: async (userId: string, runAISchedulerV7Params: RunAISchedulerV7Params, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('runAIStreamV7Mock', 'userId', userId)
            // verify required parameter 'runAISchedulerV7Params' is not null or undefined
            assertParamExists('runAIStreamV7Mock', 'runAISchedulerV7Params', runAISchedulerV7Params)
            const localVarPath = `/api/v1/scheduler/aiScheduler/v7/mock/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAISchedulerV7Params, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate weekly plan (Streaming)
         * @param {RunAIWeekPlanParams} runAIWeekPlanParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAIWeekPlanStream: async (runAIWeekPlanParams: RunAIWeekPlanParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runAIWeekPlanParams' is not null or undefined
            assertParamExists('runAIWeekPlanStream', 'runAIWeekPlanParams', runAIWeekPlanParams)
            const localVarPath = `/api/v1/scheduler/week_plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAIWeekPlanParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate weekly plan as a background job (Streaming, survives client disconnect)
         * @param {RunAIWeekPlanParams} runAIWeekPlanParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAIWeekPlanStreamV2: async (runAIWeekPlanParams: RunAIWeekPlanParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runAIWeekPlanParams' is not null or undefined
            assertParamExists('runAIWeekPlanStreamV2', 'runAIWeekPlanParams', runAIWeekPlanParams)
            const localVarPath = `/api/v1/scheduler/week_plan/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAIWeekPlanParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suggest time for an individual task
         * @param {SuggestIndividualTaskTimeParams} suggestIndividualTaskTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestIndividualTaskTime: async (suggestIndividualTaskTimeParams: SuggestIndividualTaskTimeParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suggestIndividualTaskTimeParams' is not null or undefined
            assertParamExists('suggestIndividualTaskTime', 'suggestIndividualTaskTimeParams', suggestIndividualTaskTimeParams)
            const localVarPath = `/api/v1/scheduler/task/suggest/individual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suggestIndividualTaskTimeParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suggest meal times
         * @param {SuggestMealTimeParams} suggestMealTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestMealTime: async (suggestMealTimeParams: SuggestMealTimeParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suggestMealTimeParams' is not null or undefined
            assertParamExists('suggestMealTime', 'suggestMealTimeParams', suggestMealTimeParams)
            const localVarPath = `/api/v1/scheduler/meal/suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suggestMealTimeParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suggest recommendations now
         * @param {SuggestRecommendationNowParams} suggestRecommendationNowParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestRecommendationNow: async (suggestRecommendationNowParams: SuggestRecommendationNowParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suggestRecommendationNowParams' is not null or undefined
            assertParamExists('suggestRecommendationNow', 'suggestRecommendationNowParams', suggestRecommendationNowParams)
            const localVarPath = `/api/v1/scheduler/recommendations/suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suggestRecommendationNowParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suggest time for an individual routine activity
         * @param {SuggestRoutineTimeParams} suggestRoutineTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestRoutineTime: async (suggestRoutineTimeParams: SuggestRoutineTimeParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suggestRoutineTimeParams' is not null or undefined
            assertParamExists('suggestRoutineTime', 'suggestRoutineTimeParams', suggestRoutineTimeParams)
            const localVarPath = `/api/v1/scheduler/routine/suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suggestRoutineTimeParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suggest sleep time
         * @param {SuggestSleepTimeParams} suggestSleepTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestSleepTime: async (suggestSleepTimeParams: SuggestSleepTimeParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suggestSleepTimeParams' is not null or undefined
            assertParamExists('suggestSleepTime', 'suggestSleepTimeParams', suggestSleepTimeParams)
            const localVarPath = `/api/v1/scheduler/sleep/suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suggestSleepTimeParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suggest task times
         * @param {SuggestTaskTimeParams} suggestTaskTimeParams 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        suggestTaskTime: async (suggestTaskTimeParams: SuggestTaskTimeParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suggestTaskTimeParams' is not null or undefined
            assertParamExists('suggestTaskTime', 'suggestTaskTimeParams', suggestTaskTimeParams)
            const localVarPath = `/api/v1/scheduler/task/suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suggestTaskTimeParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update preferences for scheduler
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;EnergyBoostPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnergyBoostPreference: async (preferenceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updateEnergyBoostPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateEnergyBoostPreference', 'body', body)
            const localVarPath = `/api/v1/scheduler/preference/{preferenceId}/energyBoost`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update preferences for meal
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;MealPreference&gt;
         * @param {string} [routineId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMealPreference: async (preferenceId: string, body: object, routineId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updateMealPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateMealPreference', 'body', body)
            const localVarPath = `/api/v1/scheduler/preference/{preferenceId}/meal`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (routineId !== undefined) {
                localVarQueryParameter['routineId'] = routineId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing routine activity
         * @param {string} routineId 
         * @param {string} activityId 
         * @param {object} body Partial&lt;RoutineActivity&gt;
         * @param {string} [preferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoutineActivity: async (routineId: string, activityId: string, body: object, preferenceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'routineId' is not null or undefined
            assertParamExists('updateRoutineActivity', 'routineId', routineId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('updateRoutineActivity', 'activityId', activityId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateRoutineActivity', 'body', body)
            const localVarPath = `/api/v1/scheduler/routine/{routineId}/activity/{activityId}`
                .replace(`{${"routineId"}}`, encodeURIComponent(String(routineId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preferenceId !== undefined) {
                localVarQueryParameter['preferenceId'] = preferenceId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update preferences for scheduler
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;SchedulerPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerPreference: async (preferenceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updateSchedulerPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateSchedulerPreference', 'body', body)
            const localVarPath = `/api/v1/scheduler/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing scheduler rule
         * @param {string} userId 
         * @param {string} ruleId 
         * @param {SchedulerRuleWithoutId} schedulerRuleWithoutId SchedulerRuleWithoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerRule: async (userId: string, ruleId: string, schedulerRuleWithoutId: SchedulerRuleWithoutId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateSchedulerRule', 'userId', userId)
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateSchedulerRule', 'ruleId', ruleId)
            // verify required parameter 'schedulerRuleWithoutId' is not null or undefined
            assertParamExists('updateSchedulerRule', 'schedulerRuleWithoutId', schedulerRuleWithoutId)
            const localVarPath = `/api/v1/scheduler/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schedulerRuleWithoutId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update workout preference
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;WorkoutPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkoutPreference: async (preferenceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updateWorkoutPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateWorkoutPreference', 'body', body)
            const localVarPath = `/api/v1/scheduler/preference/{preferenceId}/workout`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulerApi - functional programming interface
 * @export
 */
export const SchedulerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new routine activity
         * @param {string} routineId 
         * @param {object} body RoutineActivity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoutineActivity(routineId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoutineActivity(routineId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.createRoutineActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new scheduler rule
         * @param {string} userId 
         * @param {SchedulerRuleWithoutId} schedulerRuleWithoutId SchedulerRuleWithoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSchedulerRule(userId: string, schedulerRuleWithoutId: SchedulerRuleWithoutId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSchedulerRule(userId, schedulerRuleWithoutId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.createSchedulerRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a scheduler rule
         * @param {string} userId 
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSchedulerRule(userId: string, ruleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteSchedulerRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSchedulerRule(userId, ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.deleteSchedulerRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Science-path alias of AI Scheduler V9. Web posts here with `job_id` in the body.
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDailyPlanV5(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDailyPlanV5(userId, runAISchedulerV5Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateDailyPlanV5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get energy-boost preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getEnergyBoostPreference(preferenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnergyBoostPreference(preferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.getEnergyBoostPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get routine by ID
         * @param {string} routineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoutine(routineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoutine(routineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.getRoutine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get scheduler preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getSchedulerPreference(preferenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchedulerPreference(preferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.getSchedulerPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all scheduler rules for a user
         * @param {string} userId 
         * @param {number} [limit] Maximum number of rules to return
         * @param {boolean} [hideHealthSummary] Whether to hide HEALTH_SUMMARY rules. Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchedulerRules(userId: string, limit?: number, hideHealthSummary?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SchedulerRule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchedulerRules(userId, limit, hideHealthSummary, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.getSchedulerRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hide a routine activity
         * @param {string} routineId 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hideRoutineActivity(routineId: string, activityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hideRoutineActivity(routineId, activityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.hideRoutineActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run AI Replan Scheduler V5 (Returns before/after schedule changes)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async runAIReplanSchedulerV5(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerAIReplanSchedulerV5PutFormattedRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAIReplanSchedulerV5(userId, runAISchedulerV5Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAIReplanSchedulerV5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run AI Replan Scheduler V6 (Returns before/after schedule changes)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAIReplanSchedulerV6(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerAIReplanSchedulerV5PutFormattedRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAIReplanSchedulerV6(userId, runAISchedulerV5Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAIReplanSchedulerV6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run AI Scheduler V5 (Enhanced with Redis Memory)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async runAISchedulerV5(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerAISchedulerV5PutFormattedRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAISchedulerV5(userId, runAISchedulerV5Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAISchedulerV5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run AI Scheduler V5 (Streaming)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async runAISchedulerV5Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAISchedulerV5Stream(userId, runAISchedulerV5Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAISchedulerV5Stream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run AI Scheduler V6 (Streaming)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAISchedulerV6Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAISchedulerV6Stream(userId, runAISchedulerV5Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAISchedulerV6Stream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run AI Scheduler V7 (Streaming, daily_plan_v3)
         * @param {string} userId 
         * @param {RunAISchedulerV7Params} runAISchedulerV7Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAISchedulerV7Stream(userId: string, runAISchedulerV7Params: RunAISchedulerV7Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAISchedulerV7Stream(userId, runAISchedulerV7Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAISchedulerV7Stream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run AI Scheduler V8 (Streaming, daily_plan_v4)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAISchedulerV8Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAISchedulerV8Stream(userId, runAISchedulerV5Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAISchedulerV8Stream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run AI Scheduler V9 (Streaming, daily_plan_v5). Unlike v8, generation survives the client disconnecting (science runs it in a background thread and persists progress to Redis as a job); poll GET /api/v1/jobs/{jobId} to recover status/result later.
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAISchedulerV9Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAISchedulerV9Stream(userId, runAISchedulerV5Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAISchedulerV9Stream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run AI Stream V7 Mock (Streaming, onboarding)
         * @param {string} userId 
         * @param {RunAISchedulerV7Params} runAISchedulerV7Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAIStreamV7Mock(userId: string, runAISchedulerV7Params: RunAISchedulerV7Params, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAIStreamV7Mock(userId, runAISchedulerV7Params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAIStreamV7Mock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate weekly plan (Streaming)
         * @param {RunAIWeekPlanParams} runAIWeekPlanParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAIWeekPlanStream(runAIWeekPlanParams: RunAIWeekPlanParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAIWeekPlanStream(runAIWeekPlanParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAIWeekPlanStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate weekly plan as a background job (Streaming, survives client disconnect)
         * @param {RunAIWeekPlanParams} runAIWeekPlanParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAIWeekPlanStreamV2(runAIWeekPlanParams: RunAIWeekPlanParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAIWeekPlanStreamV2(runAIWeekPlanParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runAIWeekPlanStreamV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suggest time for an individual task
         * @param {SuggestIndividualTaskTimeParams} suggestIndividualTaskTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestIndividualTaskTime(suggestIndividualTaskTimeParams: SuggestIndividualTaskTimeParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuggestIndividualTaskTimeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestIndividualTaskTime(suggestIndividualTaskTimeParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.suggestIndividualTaskTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suggest meal times
         * @param {SuggestMealTimeParams} suggestMealTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestMealTime(suggestMealTimeParams: SuggestMealTimeParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuggestMealTimeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestMealTime(suggestMealTimeParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.suggestMealTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suggest recommendations now
         * @param {SuggestRecommendationNowParams} suggestRecommendationNowParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestRecommendationNow(suggestRecommendationNowParams: SuggestRecommendationNowParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuggestRecommendationNowRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestRecommendationNow(suggestRecommendationNowParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.suggestRecommendationNow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suggest time for an individual routine activity
         * @param {SuggestRoutineTimeParams} suggestRoutineTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestRoutineTime(suggestRoutineTimeParams: SuggestRoutineTimeParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuggestRoutineTimeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestRoutineTime(suggestRoutineTimeParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.suggestRoutineTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suggest sleep time
         * @param {SuggestSleepTimeParams} suggestSleepTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestSleepTime(suggestSleepTimeParams: SuggestSleepTimeParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuggestSleepTimeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestSleepTime(suggestSleepTimeParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.suggestSleepTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suggest task times
         * @param {SuggestTaskTimeParams} suggestTaskTimeParams 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async suggestTaskTime(suggestTaskTimeParams: SuggestTaskTimeParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuggestTaskTimeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestTaskTime(suggestTaskTimeParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.suggestTaskTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update preferences for scheduler
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;EnergyBoostPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnergyBoostPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnergyBoostPreference(preferenceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.updateEnergyBoostPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update preferences for meal
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;MealPreference&gt;
         * @param {string} [routineId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMealPreference(preferenceId: string, body: object, routineId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMealPreference(preferenceId, body, routineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.updateMealPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing routine activity
         * @param {string} routineId 
         * @param {string} activityId 
         * @param {object} body Partial&lt;RoutineActivity&gt;
         * @param {string} [preferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoutineActivity(routineId: string, activityId: string, body: object, preferenceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoutineActivity(routineId, activityId, body, preferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.updateRoutineActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update preferences for scheduler
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;SchedulerPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSchedulerPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSchedulerPreference(preferenceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.updateSchedulerPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing scheduler rule
         * @param {string} userId 
         * @param {string} ruleId 
         * @param {SchedulerRuleWithoutId} schedulerRuleWithoutId SchedulerRuleWithoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSchedulerRule(userId: string, ruleId: string, schedulerRuleWithoutId: SchedulerRuleWithoutId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSchedulerRule(userId, ruleId, schedulerRuleWithoutId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.updateSchedulerRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update workout preference
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;WorkoutPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkoutPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkoutPreference(preferenceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.updateWorkoutPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchedulerApi - factory interface
 * @export
 */
export const SchedulerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new routine activity
         * @param {string} routineId 
         * @param {object} body RoutineActivity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoutineActivity(routineId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.createRoutineActivity(routineId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new scheduler rule
         * @param {string} userId 
         * @param {SchedulerRuleWithoutId} schedulerRuleWithoutId SchedulerRuleWithoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedulerRule(userId: string, schedulerRuleWithoutId: SchedulerRuleWithoutId, options?: RawAxiosRequestConfig): AxiosPromise<SchedulerRule> {
            return localVarFp.createSchedulerRule(userId, schedulerRuleWithoutId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a scheduler rule
         * @param {string} userId 
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedulerRule(userId: string, ruleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteSchedulerRuleResponse> {
            return localVarFp.deleteSchedulerRule(userId, ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Science-path alias of AI Scheduler V9. Web posts here with `job_id` in the body.
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDailyPlanV5(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generateDailyPlanV5(userId, runAISchedulerV5Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get energy-boost preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEnergyBoostPreference(preferenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getEnergyBoostPreference(preferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get routine by ID
         * @param {string} routineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoutine(routineId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getRoutine(routineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get scheduler preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSchedulerPreference(preferenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getSchedulerPreference(preferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all scheduler rules for a user
         * @param {string} userId 
         * @param {number} [limit] Maximum number of rules to return
         * @param {boolean} [hideHealthSummary] Whether to hide HEALTH_SUMMARY rules. Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulerRules(userId: string, limit?: number, hideHealthSummary?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<SchedulerRule>> {
            return localVarFp.getSchedulerRules(userId, limit, hideHealthSummary, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hide a routine activity
         * @param {string} routineId 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideRoutineActivity(routineId: string, activityId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.hideRoutineActivity(routineId, activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run AI Replan Scheduler V5 (Returns before/after schedule changes)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        runAIReplanSchedulerV5(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): AxiosPromise<SchedulerAIReplanSchedulerV5PutFormattedRes> {
            return localVarFp.runAIReplanSchedulerV5(userId, runAISchedulerV5Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run AI Replan Scheduler V6 (Returns before/after schedule changes)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAIReplanSchedulerV6(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): AxiosPromise<SchedulerAIReplanSchedulerV5PutFormattedRes> {
            return localVarFp.runAIReplanSchedulerV6(userId, runAISchedulerV5Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run AI Scheduler V5 (Enhanced with Redis Memory)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        runAISchedulerV5(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): AxiosPromise<SchedulerAISchedulerV5PutFormattedRes> {
            return localVarFp.runAISchedulerV5(userId, runAISchedulerV5Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run AI Scheduler V5 (Streaming)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        runAISchedulerV5Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.runAISchedulerV5Stream(userId, runAISchedulerV5Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run AI Scheduler V6 (Streaming)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAISchedulerV6Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.runAISchedulerV6Stream(userId, runAISchedulerV5Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run AI Scheduler V7 (Streaming, daily_plan_v3)
         * @param {string} userId 
         * @param {RunAISchedulerV7Params} runAISchedulerV7Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAISchedulerV7Stream(userId: string, runAISchedulerV7Params: RunAISchedulerV7Params, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.runAISchedulerV7Stream(userId, runAISchedulerV7Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run AI Scheduler V8 (Streaming, daily_plan_v4)
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAISchedulerV8Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.runAISchedulerV8Stream(userId, runAISchedulerV5Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run AI Scheduler V9 (Streaming, daily_plan_v5). Unlike v8, generation survives the client disconnecting (science runs it in a background thread and persists progress to Redis as a job); poll GET /api/v1/jobs/{jobId} to recover status/result later.
         * @param {string} userId 
         * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAISchedulerV9Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.runAISchedulerV9Stream(userId, runAISchedulerV5Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run AI Stream V7 Mock (Streaming, onboarding)
         * @param {string} userId 
         * @param {RunAISchedulerV7Params} runAISchedulerV7Params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAIStreamV7Mock(userId: string, runAISchedulerV7Params: RunAISchedulerV7Params, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.runAIStreamV7Mock(userId, runAISchedulerV7Params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate weekly plan (Streaming)
         * @param {RunAIWeekPlanParams} runAIWeekPlanParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAIWeekPlanStream(runAIWeekPlanParams: RunAIWeekPlanParams, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.runAIWeekPlanStream(runAIWeekPlanParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate weekly plan as a background job (Streaming, survives client disconnect)
         * @param {RunAIWeekPlanParams} runAIWeekPlanParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAIWeekPlanStreamV2(runAIWeekPlanParams: RunAIWeekPlanParams, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.runAIWeekPlanStreamV2(runAIWeekPlanParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suggest time for an individual task
         * @param {SuggestIndividualTaskTimeParams} suggestIndividualTaskTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestIndividualTaskTime(suggestIndividualTaskTimeParams: SuggestIndividualTaskTimeParams, options?: RawAxiosRequestConfig): AxiosPromise<SuggestIndividualTaskTimeRes> {
            return localVarFp.suggestIndividualTaskTime(suggestIndividualTaskTimeParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suggest meal times
         * @param {SuggestMealTimeParams} suggestMealTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestMealTime(suggestMealTimeParams: SuggestMealTimeParams, options?: RawAxiosRequestConfig): AxiosPromise<SuggestMealTimeRes> {
            return localVarFp.suggestMealTime(suggestMealTimeParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suggest recommendations now
         * @param {SuggestRecommendationNowParams} suggestRecommendationNowParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestRecommendationNow(suggestRecommendationNowParams: SuggestRecommendationNowParams, options?: RawAxiosRequestConfig): AxiosPromise<SuggestRecommendationNowRes> {
            return localVarFp.suggestRecommendationNow(suggestRecommendationNowParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suggest time for an individual routine activity
         * @param {SuggestRoutineTimeParams} suggestRoutineTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestRoutineTime(suggestRoutineTimeParams: SuggestRoutineTimeParams, options?: RawAxiosRequestConfig): AxiosPromise<SuggestRoutineTimeRes> {
            return localVarFp.suggestRoutineTime(suggestRoutineTimeParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suggest sleep time
         * @param {SuggestSleepTimeParams} suggestSleepTimeParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestSleepTime(suggestSleepTimeParams: SuggestSleepTimeParams, options?: RawAxiosRequestConfig): AxiosPromise<SuggestSleepTimeRes> {
            return localVarFp.suggestSleepTime(suggestSleepTimeParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suggest task times
         * @param {SuggestTaskTimeParams} suggestTaskTimeParams 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        suggestTaskTime(suggestTaskTimeParams: SuggestTaskTimeParams, options?: RawAxiosRequestConfig): AxiosPromise<SuggestTaskTimeRes> {
            return localVarFp.suggestTaskTime(suggestTaskTimeParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update preferences for scheduler
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;EnergyBoostPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnergyBoostPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateEnergyBoostPreference(preferenceId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update preferences for meal
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;MealPreference&gt;
         * @param {string} [routineId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMealPreference(preferenceId: string, body: object, routineId?: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateMealPreference(preferenceId, body, routineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing routine activity
         * @param {string} routineId 
         * @param {string} activityId 
         * @param {object} body Partial&lt;RoutineActivity&gt;
         * @param {string} [preferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoutineActivity(routineId: string, activityId: string, body: object, preferenceId?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateRoutineActivity(routineId, activityId, body, preferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update preferences for scheduler
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;SchedulerPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateSchedulerPreference(preferenceId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing scheduler rule
         * @param {string} userId 
         * @param {string} ruleId 
         * @param {SchedulerRuleWithoutId} schedulerRuleWithoutId SchedulerRuleWithoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedulerRule(userId: string, ruleId: string, schedulerRuleWithoutId: SchedulerRuleWithoutId, options?: RawAxiosRequestConfig): AxiosPromise<SchedulerRule> {
            return localVarFp.updateSchedulerRule(userId, ruleId, schedulerRuleWithoutId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update workout preference
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;WorkoutPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkoutPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateWorkoutPreference(preferenceId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulerApi - object-oriented interface
 * @export
 * @class SchedulerApi
 * @extends {BaseAPI}
 */
export class SchedulerApi extends BaseAPI {
    /**
     * 
     * @summary Create a new routine activity
     * @param {string} routineId 
     * @param {object} body RoutineActivity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public createRoutineActivity(routineId: string, body: object, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).createRoutineActivity(routineId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new scheduler rule
     * @param {string} userId 
     * @param {SchedulerRuleWithoutId} schedulerRuleWithoutId SchedulerRuleWithoutId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public createSchedulerRule(userId: string, schedulerRuleWithoutId: SchedulerRuleWithoutId, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).createSchedulerRule(userId, schedulerRuleWithoutId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a scheduler rule
     * @param {string} userId 
     * @param {string} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public deleteSchedulerRule(userId: string, ruleId: string, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).deleteSchedulerRule(userId, ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Science-path alias of AI Scheduler V9. Web posts here with `job_id` in the body.
     * @param {string} userId 
     * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateDailyPlanV5(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateDailyPlanV5(userId, runAISchedulerV5Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get energy-boost preference
     * @param {string} preferenceId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public getEnergyBoostPreference(preferenceId: string, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).getEnergyBoostPreference(preferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get routine by ID
     * @param {string} routineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public getRoutine(routineId: string, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).getRoutine(routineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get scheduler preference
     * @param {string} preferenceId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public getSchedulerPreference(preferenceId: string, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).getSchedulerPreference(preferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all scheduler rules for a user
     * @param {string} userId 
     * @param {number} [limit] Maximum number of rules to return
     * @param {boolean} [hideHealthSummary] Whether to hide HEALTH_SUMMARY rules. Defaults to false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public getSchedulerRules(userId: string, limit?: number, hideHealthSummary?: boolean, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).getSchedulerRules(userId, limit, hideHealthSummary, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hide a routine activity
     * @param {string} routineId 
     * @param {string} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public hideRoutineActivity(routineId: string, activityId: string, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).hideRoutineActivity(routineId, activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run AI Replan Scheduler V5 (Returns before/after schedule changes)
     * @param {string} userId 
     * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAIReplanSchedulerV5(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAIReplanSchedulerV5(userId, runAISchedulerV5Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run AI Replan Scheduler V6 (Returns before/after schedule changes)
     * @param {string} userId 
     * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAIReplanSchedulerV6(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAIReplanSchedulerV6(userId, runAISchedulerV5Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run AI Scheduler V5 (Enhanced with Redis Memory)
     * @param {string} userId 
     * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAISchedulerV5(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAISchedulerV5(userId, runAISchedulerV5Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run AI Scheduler V5 (Streaming)
     * @param {string} userId 
     * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAISchedulerV5Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAISchedulerV5Stream(userId, runAISchedulerV5Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run AI Scheduler V6 (Streaming)
     * @param {string} userId 
     * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAISchedulerV6Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAISchedulerV6Stream(userId, runAISchedulerV5Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run AI Scheduler V7 (Streaming, daily_plan_v3)
     * @param {string} userId 
     * @param {RunAISchedulerV7Params} runAISchedulerV7Params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAISchedulerV7Stream(userId: string, runAISchedulerV7Params: RunAISchedulerV7Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAISchedulerV7Stream(userId, runAISchedulerV7Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run AI Scheduler V8 (Streaming, daily_plan_v4)
     * @param {string} userId 
     * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAISchedulerV8Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAISchedulerV8Stream(userId, runAISchedulerV5Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run AI Scheduler V9 (Streaming, daily_plan_v5). Unlike v8, generation survives the client disconnecting (science runs it in a background thread and persists progress to Redis as a job); poll GET /api/v1/jobs/{jobId} to recover status/result later.
     * @param {string} userId 
     * @param {RunAISchedulerV5Params} runAISchedulerV5Params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAISchedulerV9Stream(userId: string, runAISchedulerV5Params: RunAISchedulerV5Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAISchedulerV9Stream(userId, runAISchedulerV5Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run AI Stream V7 Mock (Streaming, onboarding)
     * @param {string} userId 
     * @param {RunAISchedulerV7Params} runAISchedulerV7Params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAIStreamV7Mock(userId: string, runAISchedulerV7Params: RunAISchedulerV7Params, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAIStreamV7Mock(userId, runAISchedulerV7Params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate weekly plan (Streaming)
     * @param {RunAIWeekPlanParams} runAIWeekPlanParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAIWeekPlanStream(runAIWeekPlanParams: RunAIWeekPlanParams, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAIWeekPlanStream(runAIWeekPlanParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate weekly plan as a background job (Streaming, survives client disconnect)
     * @param {RunAIWeekPlanParams} runAIWeekPlanParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runAIWeekPlanStreamV2(runAIWeekPlanParams: RunAIWeekPlanParams, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runAIWeekPlanStreamV2(runAIWeekPlanParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suggest time for an individual task
     * @param {SuggestIndividualTaskTimeParams} suggestIndividualTaskTimeParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public suggestIndividualTaskTime(suggestIndividualTaskTimeParams: SuggestIndividualTaskTimeParams, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).suggestIndividualTaskTime(suggestIndividualTaskTimeParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suggest meal times
     * @param {SuggestMealTimeParams} suggestMealTimeParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public suggestMealTime(suggestMealTimeParams: SuggestMealTimeParams, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).suggestMealTime(suggestMealTimeParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suggest recommendations now
     * @param {SuggestRecommendationNowParams} suggestRecommendationNowParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public suggestRecommendationNow(suggestRecommendationNowParams: SuggestRecommendationNowParams, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).suggestRecommendationNow(suggestRecommendationNowParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suggest time for an individual routine activity
     * @param {SuggestRoutineTimeParams} suggestRoutineTimeParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public suggestRoutineTime(suggestRoutineTimeParams: SuggestRoutineTimeParams, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).suggestRoutineTime(suggestRoutineTimeParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suggest sleep time
     * @param {SuggestSleepTimeParams} suggestSleepTimeParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public suggestSleepTime(suggestSleepTimeParams: SuggestSleepTimeParams, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).suggestSleepTime(suggestSleepTimeParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suggest task times
     * @param {SuggestTaskTimeParams} suggestTaskTimeParams 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public suggestTaskTime(suggestTaskTimeParams: SuggestTaskTimeParams, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).suggestTaskTime(suggestTaskTimeParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update preferences for scheduler
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;EnergyBoostPreference&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public updateEnergyBoostPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).updateEnergyBoostPreference(preferenceId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update preferences for meal
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;MealPreference&gt;
     * @param {string} [routineId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public updateMealPreference(preferenceId: string, body: object, routineId?: string, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).updateMealPreference(preferenceId, body, routineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing routine activity
     * @param {string} routineId 
     * @param {string} activityId 
     * @param {object} body Partial&lt;RoutineActivity&gt;
     * @param {string} [preferenceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public updateRoutineActivity(routineId: string, activityId: string, body: object, preferenceId?: string, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).updateRoutineActivity(routineId, activityId, body, preferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update preferences for scheduler
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;SchedulerPreference&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public updateSchedulerPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).updateSchedulerPreference(preferenceId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing scheduler rule
     * @param {string} userId 
     * @param {string} ruleId 
     * @param {SchedulerRuleWithoutId} schedulerRuleWithoutId SchedulerRuleWithoutId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public updateSchedulerRule(userId: string, ruleId: string, schedulerRuleWithoutId: SchedulerRuleWithoutId, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).updateSchedulerRule(userId, ruleId, schedulerRuleWithoutId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update workout preference
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;WorkoutPreference&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public updateWorkoutPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).updateWorkoutPreference(preferenceId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SharedAccessApi - axios parameter creator
 * @export
 */
export const SharedAccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept a referral code and set up shared access relationship
         * @param {string} userId The invitee user ID
         * @param {SharedAccessAcceptPostReq} [sharedAccessAcceptPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSharedAccess: async (userId: string, sharedAccessAcceptPostReq?: SharedAccessAcceptPostReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('acceptSharedAccess', 'userId', userId)
            const localVarPath = `/api/v1/account/sharedAccess/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sharedAccessAcceptPostReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users with shared access for the authenticated user
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedAccessUsers: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSharedAccessUsers', 'userId', userId)
            const localVarPath = `/api/v1/account/sharedAccess/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update shared access rule status
         * @param {string} sharedAccessId The ID of the shared access rule
         * @param {string} userId The user ID
         * @param {SharedAccessUpdateRulePutReq} [sharedAccessUpdateRulePutReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSharedAccessRuleStatus: async (sharedAccessId: string, userId: string, sharedAccessUpdateRulePutReq?: SharedAccessUpdateRulePutReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sharedAccessId' is not null or undefined
            assertParamExists('updateSharedAccessRuleStatus', 'sharedAccessId', sharedAccessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateSharedAccessRuleStatus', 'userId', userId)
            const localVarPath = `/api/v1/account/sharedAccess/{sharedAccessId}`
                .replace(`{${"sharedAccessId"}}`, encodeURIComponent(String(sharedAccessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sharedAccessUpdateRulePutReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SharedAccessApi - functional programming interface
 * @export
 */
export const SharedAccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SharedAccessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept a referral code and set up shared access relationship
         * @param {string} userId The invitee user ID
         * @param {SharedAccessAcceptPostReq} [sharedAccessAcceptPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptSharedAccess(userId: string, sharedAccessAcceptPostReq?: SharedAccessAcceptPostReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptSharedAccess(userId, sharedAccessAcceptPostReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SharedAccessApi.acceptSharedAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get users with shared access for the authenticated user
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSharedAccessUsers(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedAccessGetUsersGetRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSharedAccessUsers(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SharedAccessApi.getSharedAccessUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update shared access rule status
         * @param {string} sharedAccessId The ID of the shared access rule
         * @param {string} userId The user ID
         * @param {SharedAccessUpdateRulePutReq} [sharedAccessUpdateRulePutReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSharedAccessRuleStatus(sharedAccessId: string, userId: string, sharedAccessUpdateRulePutReq?: SharedAccessUpdateRulePutReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSharedAccessRuleStatus(sharedAccessId, userId, sharedAccessUpdateRulePutReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SharedAccessApi.updateSharedAccessRuleStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SharedAccessApi - factory interface
 * @export
 */
export const SharedAccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SharedAccessApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept a referral code and set up shared access relationship
         * @param {string} userId The invitee user ID
         * @param {SharedAccessAcceptPostReq} [sharedAccessAcceptPostReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSharedAccess(userId: string, sharedAccessAcceptPostReq?: SharedAccessAcceptPostReq, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.acceptSharedAccess(userId, sharedAccessAcceptPostReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users with shared access for the authenticated user
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedAccessUsers(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<SharedAccessGetUsersGetRes> {
            return localVarFp.getSharedAccessUsers(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update shared access rule status
         * @param {string} sharedAccessId The ID of the shared access rule
         * @param {string} userId The user ID
         * @param {SharedAccessUpdateRulePutReq} [sharedAccessUpdateRulePutReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSharedAccessRuleStatus(sharedAccessId: string, userId: string, sharedAccessUpdateRulePutReq?: SharedAccessUpdateRulePutReq, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateSharedAccessRuleStatus(sharedAccessId, userId, sharedAccessUpdateRulePutReq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SharedAccessApi - object-oriented interface
 * @export
 * @class SharedAccessApi
 * @extends {BaseAPI}
 */
export class SharedAccessApi extends BaseAPI {
    /**
     * 
     * @summary Accept a referral code and set up shared access relationship
     * @param {string} userId The invitee user ID
     * @param {SharedAccessAcceptPostReq} [sharedAccessAcceptPostReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedAccessApi
     */
    public acceptSharedAccess(userId: string, sharedAccessAcceptPostReq?: SharedAccessAcceptPostReq, options?: RawAxiosRequestConfig) {
        return SharedAccessApiFp(this.configuration).acceptSharedAccess(userId, sharedAccessAcceptPostReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users with shared access for the authenticated user
     * @param {string} userId The user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedAccessApi
     */
    public getSharedAccessUsers(userId: string, options?: RawAxiosRequestConfig) {
        return SharedAccessApiFp(this.configuration).getSharedAccessUsers(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update shared access rule status
     * @param {string} sharedAccessId The ID of the shared access rule
     * @param {string} userId The user ID
     * @param {SharedAccessUpdateRulePutReq} [sharedAccessUpdateRulePutReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedAccessApi
     */
    public updateSharedAccessRuleStatus(sharedAccessId: string, userId: string, sharedAccessUpdateRulePutReq?: SharedAccessUpdateRulePutReq, options?: RawAxiosRequestConfig) {
        return SharedAccessApiFp(this.configuration).updateSharedAccessRuleStatus(sharedAccessId, userId, sharedAccessUpdateRulePutReq, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SuggestionsApi - axios parameter creator
 * @export
 */
export const SuggestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get quick energy-aware suggestions for the current moment
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} currentTime Current ISO datetime string
         * @param {string} [preferenceId] Preference ID (optional override to resolve user time format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuggestionsQuickGet: async (userId: string, metricId: string, currentTime: string, preferenceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1SuggestionsQuickGet', 'userId', userId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('apiV1SuggestionsQuickGet', 'metricId', metricId)
            // verify required parameter 'currentTime' is not null or undefined
            assertParamExists('apiV1SuggestionsQuickGet', 'currentTime', currentTime)
            const localVarPath = `/api/v1/suggestions/quick`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (metricId !== undefined) {
                localVarQueryParameter['metricId'] = metricId;
            }

            if (currentTime !== undefined) {
                localVarQueryParameter['currentTime'] = currentTime;
            }

            if (preferenceId !== undefined) {
                localVarQueryParameter['preferenceId'] = preferenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuggestionsApi - functional programming interface
 * @export
 */
export const SuggestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuggestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get quick energy-aware suggestions for the current moment
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} currentTime Current ISO datetime string
         * @param {string} [preferenceId] Preference ID (optional override to resolve user time format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SuggestionsQuickGet(userId: string, metricId: string, currentTime: string, preferenceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickSuggestionRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SuggestionsQuickGet(userId, metricId, currentTime, preferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuggestionsApi.apiV1SuggestionsQuickGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuggestionsApi - factory interface
 * @export
 */
export const SuggestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuggestionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get quick energy-aware suggestions for the current moment
         * @param {string} userId User ID
         * @param {string} metricId Metric ID
         * @param {string} currentTime Current ISO datetime string
         * @param {string} [preferenceId] Preference ID (optional override to resolve user time format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuggestionsQuickGet(userId: string, metricId: string, currentTime: string, preferenceId?: string, options?: RawAxiosRequestConfig): AxiosPromise<QuickSuggestionRes> {
            return localVarFp.apiV1SuggestionsQuickGet(userId, metricId, currentTime, preferenceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuggestionsApi - object-oriented interface
 * @export
 * @class SuggestionsApi
 * @extends {BaseAPI}
 */
export class SuggestionsApi extends BaseAPI {
    /**
     * 
     * @summary Get quick energy-aware suggestions for the current moment
     * @param {string} userId User ID
     * @param {string} metricId Metric ID
     * @param {string} currentTime Current ISO datetime string
     * @param {string} [preferenceId] Preference ID (optional override to resolve user time format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuggestionsApi
     */
    public apiV1SuggestionsQuickGet(userId: string, metricId: string, currentTime: string, preferenceId?: string, options?: RawAxiosRequestConfig) {
        return SuggestionsApiFp(this.configuration).apiV1SuggestionsQuickGet(userId, metricId, currentTime, preferenceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new project
         * @param {string} userId 
         * @param {object} body AddTodotaskBoardProps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTodoProject: async (userId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addTodoProject', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addTodoProject', 'body', body)
            const localVarPath = `/api/v1/tasks/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a todo task
         * @param {string} boardId 
         * @param {string} userId 
         * @param {object} body AddTaskItemProps
         * @param {string} [taskId] Optional taskId to use for the task
         * @param {string} [originalTaskId] Optional originalTaskId to use for the task (required for apple-reminders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTodoTask: async (boardId: string, userId: string, body: object, taskId?: string, originalTaskId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('addTodoTask', 'boardId', boardId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addTodoTask', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addTodoTask', 'body', body)
            const localVarPath = `/api/v1/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (boardId !== undefined) {
                localVarQueryParameter['boardId'] = boardId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (taskId !== undefined) {
                localVarQueryParameter['taskId'] = taskId;
            }

            if (originalTaskId !== undefined) {
                localVarQueryParameter['originalTaskId'] = originalTaskId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a label
         * @param {string} taskLabelGroupId 
         * @param {object} body Partial&lt;TaskLabel&gt; (name required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskLabel: async (taskLabelGroupId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskLabelGroupId' is not null or undefined
            assertParamExists('createTaskLabel', 'taskLabelGroupId', taskLabelGroupId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createTaskLabel', 'body', body)
            const localVarPath = `/api/v1/tasks/labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (taskLabelGroupId !== undefined) {
                localVarQueryParameter['taskLabelGroupId'] = taskLabelGroupId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks the task label as deleted by setting the `delete` flag to true.
         * @summary Delete a custom label
         * @param {string} taskLabelGroupId 
         * @param {string} taskLabelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskLabel: async (taskLabelGroupId: string, taskLabelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskLabelGroupId' is not null or undefined
            assertParamExists('deleteTaskLabel', 'taskLabelGroupId', taskLabelGroupId)
            // verify required parameter 'taskLabelId' is not null or undefined
            assertParamExists('deleteTaskLabel', 'taskLabelId', taskLabelId)
            const localVarPath = `/api/v1/tasks/labels/{taskLabelId}`
                .replace(`{${"taskLabelId"}}`, encodeURIComponent(String(taskLabelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (taskLabelGroupId !== undefined) {
                localVarQueryParameter['taskLabelGroupId'] = taskLabelGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a project from both Lifestack and the external provider (Todoist, TickTick, Trello, Notion).
         * @summary Delete a project
         * @param {string} userId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTodoProject: async (userId: string, boardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteTodoProject', 'userId', userId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('deleteTodoProject', 'boardId', boardId)
            const localVarPath = `/api/v1/tasks/projects/{boardId}`
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a todo task
         * @param {string} taskId 
         * @param {string} boardId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTodoTask: async (taskId: string, boardId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('deleteTodoTask', 'taskId', taskId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('deleteTodoTask', 'boardId', boardId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteTodoTask', 'userId', userId)
            const localVarPath = `/api/v1/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (boardId !== undefined) {
                localVarQueryParameter['boardId'] = boardId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all labels
         * @param {string} taskLabelsGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTaskLabels: async (taskLabelsGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskLabelsGroupId' is not null or undefined
            assertParamExists('getAllTaskLabels', 'taskLabelsGroupId', taskLabelsGroupId)
            const localVarPath = `/api/v1/tasks/labels/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (taskLabelsGroupId !== undefined) {
                localVarQueryParameter['taskLabelsGroupId'] = taskLabelsGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get daily tasks trend
         * @param {string} dataTrendId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyTasksTrend: async (dataTrendId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getDailyTasksTrend', 'dataTrendId', dataTrendId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getDailyTasksTrend', 'date', date)
            const localVarPath = `/api/v1/tasks/trend/{dataTrendId}/daily`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch overdue tasks by the selected date. So, if you pass 2024-09-30, it will return overdue(not completed) tasks until 2024-09-30.
         * @summary Get all overdue todo tasks
         * @param {Array<string>} todoTasksBoardIds 
         * @param {string} dueDateTill YYYY-MM-DD
         * @param {string} [orderBy] dueDate
         * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
         * @param {boolean} [completed] 
         * @param {boolean} [onlyMyTask] 
         * @param {boolean} [hideNoDueDate] 
         * @param {number} [limit] Maximum number of tasks to return. default is 100
         * @param {boolean} [includeSubtasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverdueTodoTasks: async (todoTasksBoardIds: Array<string>, dueDateTill: string, orderBy?: string, labelNames?: string, completed?: boolean, onlyMyTask?: boolean, hideNoDueDate?: boolean, limit?: number, includeSubtasks?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoTasksBoardIds' is not null or undefined
            assertParamExists('getOverdueTodoTasks', 'todoTasksBoardIds', todoTasksBoardIds)
            // verify required parameter 'dueDateTill' is not null or undefined
            assertParamExists('getOverdueTodoTasks', 'dueDateTill', dueDateTill)
            const localVarPath = `/api/v1/tasks/overdue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (todoTasksBoardIds) {
                localVarQueryParameter['todoTasksBoardIds[]'] = todoTasksBoardIds;
            }

            if (dueDateTill !== undefined) {
                localVarQueryParameter['dueDateTill'] = dueDateTill;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (labelNames !== undefined) {
                localVarQueryParameter['labelNames'] = labelNames;
            }

            if (completed !== undefined) {
                localVarQueryParameter['completed'] = completed;
            }

            if (onlyMyTask !== undefined) {
                localVarQueryParameter['onlyMyTask'] = onlyMyTask;
            }

            if (hideNoDueDate !== undefined) {
                localVarQueryParameter['hideNoDueDate'] = hideNoDueDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (includeSubtasks !== undefined) {
                localVarQueryParameter['includeSubtasks'] = includeSubtasks;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get task preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getTaskPreference: async (preferenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('getTaskPreference', 'preferenceId', preferenceId)
            const localVarPath = `/api/v1/tasks/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all projects
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoProjects: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTodoProjects', 'userId', userId)
            const localVarPath = `/api/v1/tasks/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all todo tasks
         * @param {Array<string>} todoTasksBoardIds 
         * @param {string} [dueDate] date - YYYY-MM-DD
         * @param {boolean} [onlyMyTask] 
         * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
         * @param {boolean} [completed] 
         * @param {boolean} [includeSubtasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoTasks: async (todoTasksBoardIds: Array<string>, dueDate?: string, onlyMyTask?: boolean, labelNames?: string, completed?: boolean, includeSubtasks?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoTasksBoardIds' is not null or undefined
            assertParamExists('getTodoTasks', 'todoTasksBoardIds', todoTasksBoardIds)
            const localVarPath = `/api/v1/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (todoTasksBoardIds) {
                localVarQueryParameter['todoTasksBoardIds[]'] = todoTasksBoardIds;
            }

            if (dueDate !== undefined) {
                localVarQueryParameter['dueDate'] = dueDate;
            }

            if (onlyMyTask !== undefined) {
                localVarQueryParameter['onlyMyTask'] = onlyMyTask;
            }

            if (labelNames !== undefined) {
                localVarQueryParameter['labelNames'] = labelNames;
            }

            if (completed !== undefined) {
                localVarQueryParameter['completed'] = completed;
            }

            if (includeSubtasks !== undefined) {
                localVarQueryParameter['includeSubtasks'] = includeSubtasks;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get overdue tasks from visible projects
         * @param {string} userId 
         * @param {string} dueDateTill YYYY-MM-DD
         * @param {string} [orderBy] dueDate
         * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
         * @param {boolean} [completed] 
         * @param {boolean} [onlyMyTask] 
         * @param {boolean} [hideNoDueDate] 
         * @param {number} [limit] Maximum number of tasks to return. default is 100
         * @param {boolean} [includeSubtasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisibleOverdueTasks: async (userId: string, dueDateTill: string, orderBy?: string, labelNames?: string, completed?: boolean, onlyMyTask?: boolean, hideNoDueDate?: boolean, limit?: number, includeSubtasks?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getVisibleOverdueTasks', 'userId', userId)
            // verify required parameter 'dueDateTill' is not null or undefined
            assertParamExists('getVisibleOverdueTasks', 'dueDateTill', dueDateTill)
            const localVarPath = `/api/v1/tasks/overdue/visible`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (dueDateTill !== undefined) {
                localVarQueryParameter['dueDateTill'] = dueDateTill;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (labelNames !== undefined) {
                localVarQueryParameter['labelNames'] = labelNames;
            }

            if (completed !== undefined) {
                localVarQueryParameter['completed'] = completed;
            }

            if (onlyMyTask !== undefined) {
                localVarQueryParameter['onlyMyTask'] = onlyMyTask;
            }

            if (hideNoDueDate !== undefined) {
                localVarQueryParameter['hideNoDueDate'] = hideNoDueDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (includeSubtasks !== undefined) {
                localVarQueryParameter['includeSubtasks'] = includeSubtasks;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get tasks from visible projects
         * @param {string} userId 
         * @param {string} dueDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisibleProjectTasks: async (userId: string, dueDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getVisibleProjectTasks', 'userId', userId)
            // verify required parameter 'dueDate' is not null or undefined
            assertParamExists('getVisibleProjectTasks', 'dueDate', dueDate)
            const localVarPath = `/api/v1/tasks/visible`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (dueDate !== undefined) {
                localVarQueryParameter['dueDate'] = dueDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get weekly tasks trend
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getWeeklyTasksTrend: async (dataTrendId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getWeeklyTasksTrend', 'dataTrendId', dataTrendId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getWeeklyTasksTrend', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getWeeklyTasksTrend', 'endDate', endDate)
            const localVarPath = `/api/v1/tasks/trend/{dataTrendId}/weekly`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get weekly tasks trend V2
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyTasksTrendV2: async (dataTrendId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataTrendId' is not null or undefined
            assertParamExists('getWeeklyTasksTrendV2', 'dataTrendId', dataTrendId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getWeeklyTasksTrendV2', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getWeeklyTasksTrendV2', 'endDate', endDate)
            const localVarPath = `/api/v1/tasks/trend/{dataTrendId}/weekly/v2`
                .replace(`{${"dataTrendId"}}`, encodeURIComponent(String(dataTrendId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle ClickUp webhook events
         * @param {object} body ClickUpWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleClickUpWebhook: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('handleClickUpWebhook', 'body', body)
            const localVarPath = `/api/v1/tasks/webhook/clickup/receive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle GitHub webhook events
         * @param {object} body GithubWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleGithubTasksWebhook: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('handleGithubTasksWebhook', 'body', body)
            const localVarPath = `/api/v1/tasks/webhook/github/receive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle Notion webhook events
         * @param {object} body NotionWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleNotionTasksWebhook: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('handleNotionTasksWebhook', 'body', body)
            const localVarPath = `/api/v1/tasks/webhook/notion/receive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle Todoist webhook events
         * @param {object} body TodoistWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleTodoistTasksWebhook: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('handleTodoistTasksWebhook', 'body', body)
            const localVarPath = `/api/v1/tasks/webhook/todoist/receive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle Trello webhook events
         * @param {object} body TrelloWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleTrelloTasksWebhook: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('handleTrelloTasksWebhook', 'body', body)
            const localVarPath = `/api/v1/tasks/webhook/trello/receive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move a todo task between projects
         * @param {string} userId 
         * @param {MoveTodoTaskBetweenProjectsReq} moveTodoTaskBetweenProjectsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTodoTaskBetweenProjects: async (userId: string, moveTodoTaskBetweenProjectsReq: MoveTodoTaskBetweenProjectsReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('moveTodoTaskBetweenProjects', 'userId', userId)
            // verify required parameter 'moveTodoTaskBetweenProjectsReq' is not null or undefined
            assertParamExists('moveTodoTaskBetweenProjects', 'moveTodoTaskBetweenProjectsReq', moveTodoTaskBetweenProjectsReq)
            const localVarPath = `/api/v1/tasks/move-between-projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveTodoTaskBetweenProjectsReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search tasks by query string
         * @param {string} query Search query string to match against task name (title)
         * @param {number} [limit] Maximum number of tasks to return. default is 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTasks: async (query: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchTasks', 'query', query)
            const localVarPath = `/api/v1/tasks/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set a project visibility
         * @param {string} boardId 
         * @param {boolean} closed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTodoProjectVisibility: async (boardId: string, closed: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('setTodoProjectVisibility', 'boardId', boardId)
            // verify required parameter 'closed' is not null or undefined
            assertParamExists('setTodoProjectVisibility', 'closed', closed)
            const localVarPath = `/api/v1/tasks/projects/visibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (boardId !== undefined) {
                localVarQueryParameter['boardId'] = boardId;
            }

            if (closed !== undefined) {
                localVarQueryParameter['closed'] = closed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Subscribe ClickUp board webhook
         * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeClickUpBoardWebhook: async (todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoTasksWebhookSubscribeReq' is not null or undefined
            assertParamExists('subscribeClickUpBoardWebhook', 'todoTasksWebhookSubscribeReq', todoTasksWebhookSubscribeReq)
            const localVarPath = `/api/v1/tasks/webhook/clickup/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(todoTasksWebhookSubscribeReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Subscribe GitHub board webhook
         * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeGithubBoardWebhook: async (todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoTasksWebhookSubscribeReq' is not null or undefined
            assertParamExists('subscribeGithubBoardWebhook', 'todoTasksWebhookSubscribeReq', todoTasksWebhookSubscribeReq)
            const localVarPath = `/api/v1/tasks/webhook/github/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(todoTasksWebhookSubscribeReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Subscribe Trello board webhook
         * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeTrelloBoardWebhook: async (todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoTasksWebhookSubscribeReq' is not null or undefined
            assertParamExists('subscribeTrelloBoardWebhook', 'todoTasksWebhookSubscribeReq', todoTasksWebhookSubscribeReq)
            const localVarPath = `/api/v1/tasks/webhook/trello/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(todoTasksWebhookSubscribeReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Apple Reminders as tasks
         * @param {AppleRemindersSyncReq} appleRemindersSyncReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAppleReminders: async (appleRemindersSyncReq: AppleRemindersSyncReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appleRemindersSyncReq' is not null or undefined
            assertParamExists('syncAppleReminders', 'appleRemindersSyncReq', appleRemindersSyncReq)
            const localVarPath = `/api/v1/tasks/sync/appleReminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appleRemindersSyncReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync ClickUp tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncClickUpTasks: async (taskSyncProviderReq: TaskSyncProviderReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskSyncProviderReq' is not null or undefined
            assertParamExists('syncClickUpTasks', 'taskSyncProviderReq', taskSyncProviderReq)
            const localVarPath = `/api/v1/tasks/sync/clickup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskSyncProviderReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync GitHub tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGitHubTasks: async (taskSyncProviderReq: TaskSyncProviderReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskSyncProviderReq' is not null or undefined
            assertParamExists('syncGitHubTasks', 'taskSyncProviderReq', taskSyncProviderReq)
            const localVarPath = `/api/v1/tasks/sync/github`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskSyncProviderReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Google Tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGoogleTasks: async (taskSyncProviderReq: TaskSyncProviderReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskSyncProviderReq' is not null or undefined
            assertParamExists('syncGoogleTasks', 'taskSyncProviderReq', taskSyncProviderReq)
            const localVarPath = `/api/v1/tasks/sync/googleTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskSyncProviderReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Notion tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncNotionTasks: async (taskSyncProviderReq: TaskSyncProviderReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskSyncProviderReq' is not null or undefined
            assertParamExists('syncNotionTasks', 'taskSyncProviderReq', taskSyncProviderReq)
            const localVarPath = `/api/v1/tasks/sync/notion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskSyncProviderReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync TickTick tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTickTickTasks: async (taskSyncProviderReq: TaskSyncProviderReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskSyncProviderReq' is not null or undefined
            assertParamExists('syncTickTickTasks', 'taskSyncProviderReq', taskSyncProviderReq)
            const localVarPath = `/api/v1/tasks/sync/ticktick`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskSyncProviderReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync all projects
         * @param {string} userId 
         * @param {SyncTodoProjectsReq} [syncTodoProjectsReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTodoProjects: async (userId: string, syncTodoProjectsReq?: SyncTodoProjectsReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('syncTodoProjects', 'userId', userId)
            const localVarPath = `/api/v1/tasks/projects/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncTodoProjectsReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Todoist tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTodoistTasksV3: async (taskSyncProviderReq: TaskSyncProviderReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskSyncProviderReq' is not null or undefined
            assertParamExists('syncTodoistTasksV3', 'taskSyncProviderReq', taskSyncProviderReq)
            const localVarPath = `/api/v1/tasks/sync/todoist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskSyncProviderReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Trello tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTrelloTasks: async (taskSyncProviderReq: TaskSyncProviderReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskSyncProviderReq' is not null or undefined
            assertParamExists('syncTrelloTasks', 'taskSyncProviderReq', taskSyncProviderReq)
            const localVarPath = `/api/v1/tasks/sync/trello`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskSyncProviderReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For recurring tasks, returns the calculated next occurrence date (without time).
         * @summary Update a complete status of a task
         * @param {string} taskId 
         * @param {string} boardId 
         * @param {string} userId 
         * @param {boolean} completed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompleteStatusOfTask: async (taskId: string, boardId: string, userId: string, completed: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateCompleteStatusOfTask', 'taskId', taskId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateCompleteStatusOfTask', 'boardId', boardId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateCompleteStatusOfTask', 'userId', userId)
            // verify required parameter 'completed' is not null or undefined
            assertParamExists('updateCompleteStatusOfTask', 'completed', completed)
            const localVarPath = `/api/v1/tasks/{taskId}/complete`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (boardId !== undefined) {
                localVarQueryParameter['boardId'] = boardId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (completed !== undefined) {
                localVarQueryParameter['completed'] = completed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a label
         * @param {string} taskLabelGroupId 
         * @param {string} taskLabelId 
         * @param {object} body Partial&lt;TaskLabel&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskLabel: async (taskLabelGroupId: string, taskLabelId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskLabelGroupId' is not null or undefined
            assertParamExists('updateTaskLabel', 'taskLabelGroupId', taskLabelGroupId)
            // verify required parameter 'taskLabelId' is not null or undefined
            assertParamExists('updateTaskLabel', 'taskLabelId', taskLabelId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateTaskLabel', 'body', body)
            const localVarPath = `/api/v1/tasks/labels/{taskLabelId}`
                .replace(`{${"taskLabelId"}}`, encodeURIComponent(String(taskLabelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (taskLabelGroupId !== undefined) {
                localVarQueryParameter['taskLabelGroupId'] = taskLabelGroupId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update task preferences
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;TaskPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskPreference: async (preferenceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceId' is not null or undefined
            assertParamExists('updateTaskPreference', 'preferenceId', preferenceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateTaskPreference', 'body', body)
            const localVarPath = `/api/v1/tasks/preference/{preferenceId}`
                .replace(`{${"preferenceId"}}`, encodeURIComponent(String(preferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a todo task
         * @param {string} taskId 
         * @param {string} boardId 
         * @param {string} userId 
         * @param {object} body Partial&lt;FirestoreTaskItem&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodoTask: async (taskId: string, boardId: string, userId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateTodoTask', 'taskId', taskId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateTodoTask', 'boardId', boardId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateTodoTask', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateTodoTask', 'body', body)
            const localVarPath = `/api/v1/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (boardId !== undefined) {
                localVarQueryParameter['boardId'] = boardId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a new project
         * @param {string} userId 
         * @param {object} body AddTodotaskBoardProps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTodoProject(userId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskProjectIdRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTodoProject(userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.addTodoProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a todo task
         * @param {string} boardId 
         * @param {string} userId 
         * @param {object} body AddTaskItemProps
         * @param {string} [taskId] Optional taskId to use for the task
         * @param {string} [originalTaskId] Optional originalTaskId to use for the task (required for apple-reminders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTodoTask(boardId: string, userId: string, body: object, taskId?: string, originalTaskId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskIdRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTodoTask(boardId, userId, body, taskId, originalTaskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.addTodoTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a label
         * @param {string} taskLabelGroupId 
         * @param {object} body Partial&lt;TaskLabel&gt; (name required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTaskLabel(taskLabelGroupId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskLabelCreateRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTaskLabel(taskLabelGroupId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.createTaskLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks the task label as deleted by setting the `delete` flag to true.
         * @summary Delete a custom label
         * @param {string} taskLabelGroupId 
         * @param {string} taskLabelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTaskLabel(taskLabelGroupId: string, taskLabelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTaskLabel(taskLabelGroupId, taskLabelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.deleteTaskLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a project from both Lifestack and the external provider (Todoist, TickTick, Trello, Notion).
         * @summary Delete a project
         * @param {string} userId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTodoProject(userId: string, boardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTodoProject(userId, boardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.deleteTodoProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a todo task
         * @param {string} taskId 
         * @param {string} boardId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTodoTask(taskId: string, boardId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTodoTask(taskId, boardId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.deleteTodoTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all labels
         * @param {string} taskLabelsGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTaskLabels(taskLabelsGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTaskLabels(taskLabelsGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getAllTaskLabels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get daily tasks trend
         * @param {string} dataTrendId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyTasksTrend(dataTrendId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyTasksTrend(dataTrendId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getDailyTasksTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch overdue tasks by the selected date. So, if you pass 2024-09-30, it will return overdue(not completed) tasks until 2024-09-30.
         * @summary Get all overdue todo tasks
         * @param {Array<string>} todoTasksBoardIds 
         * @param {string} dueDateTill YYYY-MM-DD
         * @param {string} [orderBy] dueDate
         * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
         * @param {boolean} [completed] 
         * @param {boolean} [onlyMyTask] 
         * @param {boolean} [hideNoDueDate] 
         * @param {number} [limit] Maximum number of tasks to return. default is 100
         * @param {boolean} [includeSubtasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOverdueTodoTasks(todoTasksBoardIds: Array<string>, dueDateTill: string, orderBy?: string, labelNames?: string, completed?: boolean, onlyMyTask?: boolean, hideNoDueDate?: boolean, limit?: number, includeSubtasks?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOverdueTodoTasks(todoTasksBoardIds, dueDateTill, orderBy, labelNames, completed, onlyMyTask, hideNoDueDate, limit, includeSubtasks, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getOverdueTodoTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get task preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getTaskPreference(preferenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskPreference(preferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getTaskPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all projects
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodoProjects(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodoProjects(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getTodoProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all todo tasks
         * @param {Array<string>} todoTasksBoardIds 
         * @param {string} [dueDate] date - YYYY-MM-DD
         * @param {boolean} [onlyMyTask] 
         * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
         * @param {boolean} [completed] 
         * @param {boolean} [includeSubtasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodoTasks(todoTasksBoardIds: Array<string>, dueDate?: string, onlyMyTask?: boolean, labelNames?: string, completed?: boolean, includeSubtasks?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodoTasks(todoTasksBoardIds, dueDate, onlyMyTask, labelNames, completed, includeSubtasks, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getTodoTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get overdue tasks from visible projects
         * @param {string} userId 
         * @param {string} dueDateTill YYYY-MM-DD
         * @param {string} [orderBy] dueDate
         * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
         * @param {boolean} [completed] 
         * @param {boolean} [onlyMyTask] 
         * @param {boolean} [hideNoDueDate] 
         * @param {number} [limit] Maximum number of tasks to return. default is 100
         * @param {boolean} [includeSubtasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisibleOverdueTasks(userId: string, dueDateTill: string, orderBy?: string, labelNames?: string, completed?: boolean, onlyMyTask?: boolean, hideNoDueDate?: boolean, limit?: number, includeSubtasks?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisibleOverdueTasks(userId, dueDateTill, orderBy, labelNames, completed, onlyMyTask, hideNoDueDate, limit, includeSubtasks, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getVisibleOverdueTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get tasks from visible projects
         * @param {string} userId 
         * @param {string} dueDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisibleProjectTasks(userId: string, dueDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisibleProjectTasks(userId, dueDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getVisibleProjectTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get weekly tasks trend
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getWeeklyTasksTrend(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDataTrendWeeklyRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyTasksTrend(dataTrendId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getWeeklyTasksTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get weekly tasks trend V2
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyTasksTrendV2(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyTasksTrendV2(dataTrendId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getWeeklyTasksTrendV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle ClickUp webhook events
         * @param {object} body ClickUpWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleClickUpWebhook(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleClickUpWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.handleClickUpWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle GitHub webhook events
         * @param {object} body GithubWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleGithubTasksWebhook(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleGithubTasksWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.handleGithubTasksWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle Notion webhook events
         * @param {object} body NotionWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleNotionTasksWebhook(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleNotionTasksWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.handleNotionTasksWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle Todoist webhook events
         * @param {object} body TodoistWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleTodoistTasksWebhook(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleTodoistTasksWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.handleTodoistTasksWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle Trello webhook events
         * @param {object} body TrelloWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleTrelloTasksWebhook(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleTrelloTasksWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.handleTrelloTasksWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Move a todo task between projects
         * @param {string} userId 
         * @param {MoveTodoTaskBetweenProjectsReq} moveTodoTaskBetweenProjectsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveTodoTaskBetweenProjects(userId: string, moveTodoTaskBetweenProjectsReq: MoveTodoTaskBetweenProjectsReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoveTodoTaskBetweenProjectsRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveTodoTaskBetweenProjects(userId, moveTodoTaskBetweenProjectsReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.moveTodoTaskBetweenProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search tasks by query string
         * @param {string} query Search query string to match against task name (title)
         * @param {number} [limit] Maximum number of tasks to return. default is 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTasks(query: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTasks(query, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.searchTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set a project visibility
         * @param {string} boardId 
         * @param {boolean} closed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTodoProjectVisibility(boardId: string, closed: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTodoProjectVisibility(boardId, closed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.setTodoProjectVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Subscribe ClickUp board webhook
         * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeClickUpBoardWebhook(todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TodoTasksWebhookSubscribeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeClickUpBoardWebhook(todoTasksWebhookSubscribeReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.subscribeClickUpBoardWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Subscribe GitHub board webhook
         * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeGithubBoardWebhook(todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TodoTasksWebhookSubscribeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeGithubBoardWebhook(todoTasksWebhookSubscribeReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.subscribeGithubBoardWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Subscribe Trello board webhook
         * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeTrelloBoardWebhook(todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TodoTasksWebhookSubscribeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeTrelloBoardWebhook(todoTasksWebhookSubscribeReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.subscribeTrelloBoardWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Apple Reminders as tasks
         * @param {AppleRemindersSyncReq} appleRemindersSyncReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAppleReminders(appleRemindersSyncReq: AppleRemindersSyncReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncAppleReminderRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAppleReminders(appleRemindersSyncReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.syncAppleReminders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync ClickUp tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncClickUpTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskSyncProviderRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncClickUpTasks(taskSyncProviderReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.syncClickUpTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync GitHub tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncGitHubTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskSyncProviderRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncGitHubTasks(taskSyncProviderReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.syncGitHubTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Google Tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncGoogleTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskSyncProviderRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncGoogleTasks(taskSyncProviderReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.syncGoogleTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Notion tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncNotionTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskSyncProviderRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncNotionTasks(taskSyncProviderReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.syncNotionTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync TickTick tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncTickTickTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskSyncProviderRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncTickTickTasks(taskSyncProviderReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.syncTickTickTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync all projects
         * @param {string} userId 
         * @param {SyncTodoProjectsReq} [syncTodoProjectsReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncTodoProjects(userId: string, syncTodoProjectsReq?: SyncTodoProjectsReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncTodoProjects(userId, syncTodoProjectsReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.syncTodoProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Todoist tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncTodoistTasksV3(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskSyncProviderRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncTodoistTasksV3(taskSyncProviderReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.syncTodoistTasksV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Trello tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncTrelloTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskSyncProviderRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncTrelloTasks(taskSyncProviderReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.syncTrelloTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For recurring tasks, returns the calculated next occurrence date (without time).
         * @summary Update a complete status of a task
         * @param {string} taskId 
         * @param {string} boardId 
         * @param {string} userId 
         * @param {boolean} completed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompleteStatusOfTask(taskId: string, boardId: string, userId: string, completed: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCompleteStatusRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompleteStatusOfTask(taskId, boardId, userId, completed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.updateCompleteStatusOfTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a label
         * @param {string} taskLabelGroupId 
         * @param {string} taskLabelId 
         * @param {object} body Partial&lt;TaskLabel&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskLabel(taskLabelGroupId: string, taskLabelId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskIdRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskLabel(taskLabelGroupId, taskLabelId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.updateTaskLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update task preferences
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;TaskPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskPreference(preferenceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.updateTaskPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a todo task
         * @param {string} taskId 
         * @param {string} boardId 
         * @param {string} userId 
         * @param {object} body Partial&lt;FirestoreTaskItem&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTodoTask(taskId: string, boardId: string, userId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskIdRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTodoTask(taskId, boardId, userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.updateTodoTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TasksApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a new project
         * @param {string} userId 
         * @param {object} body AddTodotaskBoardProps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTodoProject(userId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<TaskProjectIdRes> {
            return localVarFp.addTodoProject(userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a todo task
         * @param {string} boardId 
         * @param {string} userId 
         * @param {object} body AddTaskItemProps
         * @param {string} [taskId] Optional taskId to use for the task
         * @param {string} [originalTaskId] Optional originalTaskId to use for the task (required for apple-reminders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTodoTask(boardId: string, userId: string, body: object, taskId?: string, originalTaskId?: string, options?: RawAxiosRequestConfig): AxiosPromise<TaskIdRes> {
            return localVarFp.addTodoTask(boardId, userId, body, taskId, originalTaskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a label
         * @param {string} taskLabelGroupId 
         * @param {object} body Partial&lt;TaskLabel&gt; (name required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskLabel(taskLabelGroupId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<TaskLabelCreateRes> {
            return localVarFp.createTaskLabel(taskLabelGroupId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks the task label as deleted by setting the `delete` flag to true.
         * @summary Delete a custom label
         * @param {string} taskLabelGroupId 
         * @param {string} taskLabelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskLabel(taskLabelGroupId: string, taskLabelId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.deleteTaskLabel(taskLabelGroupId, taskLabelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a project from both Lifestack and the external provider (Todoist, TickTick, Trello, Notion).
         * @summary Delete a project
         * @param {string} userId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTodoProject(userId: string, boardId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.deleteTodoProject(userId, boardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a todo task
         * @param {string} taskId 
         * @param {string} boardId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTodoTask(taskId: string, boardId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.deleteTodoTask(taskId, boardId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all labels
         * @param {string} taskLabelsGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTaskLabels(taskLabelsGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getAllTaskLabels(taskLabelsGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get daily tasks trend
         * @param {string} dataTrendId 
         * @param {string} date YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyTasksTrend(dataTrendId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getDailyTasksTrend(dataTrendId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch overdue tasks by the selected date. So, if you pass 2024-09-30, it will return overdue(not completed) tasks until 2024-09-30.
         * @summary Get all overdue todo tasks
         * @param {Array<string>} todoTasksBoardIds 
         * @param {string} dueDateTill YYYY-MM-DD
         * @param {string} [orderBy] dueDate
         * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
         * @param {boolean} [completed] 
         * @param {boolean} [onlyMyTask] 
         * @param {boolean} [hideNoDueDate] 
         * @param {number} [limit] Maximum number of tasks to return. default is 100
         * @param {boolean} [includeSubtasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverdueTodoTasks(todoTasksBoardIds: Array<string>, dueDateTill: string, orderBy?: string, labelNames?: string, completed?: boolean, onlyMyTask?: boolean, hideNoDueDate?: boolean, limit?: number, includeSubtasks?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getOverdueTodoTasks(todoTasksBoardIds, dueDateTill, orderBy, labelNames, completed, onlyMyTask, hideNoDueDate, limit, includeSubtasks, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get task preference
         * @param {string} preferenceId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getTaskPreference(preferenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getTaskPreference(preferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all projects
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoProjects(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getTodoProjects(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all todo tasks
         * @param {Array<string>} todoTasksBoardIds 
         * @param {string} [dueDate] date - YYYY-MM-DD
         * @param {boolean} [onlyMyTask] 
         * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
         * @param {boolean} [completed] 
         * @param {boolean} [includeSubtasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoTasks(todoTasksBoardIds: Array<string>, dueDate?: string, onlyMyTask?: boolean, labelNames?: string, completed?: boolean, includeSubtasks?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getTodoTasks(todoTasksBoardIds, dueDate, onlyMyTask, labelNames, completed, includeSubtasks, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get overdue tasks from visible projects
         * @param {string} userId 
         * @param {string} dueDateTill YYYY-MM-DD
         * @param {string} [orderBy] dueDate
         * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
         * @param {boolean} [completed] 
         * @param {boolean} [onlyMyTask] 
         * @param {boolean} [hideNoDueDate] 
         * @param {number} [limit] Maximum number of tasks to return. default is 100
         * @param {boolean} [includeSubtasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisibleOverdueTasks(userId: string, dueDateTill: string, orderBy?: string, labelNames?: string, completed?: boolean, onlyMyTask?: boolean, hideNoDueDate?: boolean, limit?: number, includeSubtasks?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getVisibleOverdueTasks(userId, dueDateTill, orderBy, labelNames, completed, onlyMyTask, hideNoDueDate, limit, includeSubtasks, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get tasks from visible projects
         * @param {string} userId 
         * @param {string} dueDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisibleProjectTasks(userId: string, dueDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getVisibleProjectTasks(userId, dueDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get weekly tasks trend
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getWeeklyTasksTrend(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<TaskDataTrendWeeklyRes> {
            return localVarFp.getWeeklyTasksTrend(dataTrendId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get weekly tasks trend V2
         * @param {string} dataTrendId 
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyTasksTrendV2(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getWeeklyTasksTrendV2(dataTrendId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle ClickUp webhook events
         * @param {object} body ClickUpWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleClickUpWebhook(body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.handleClickUpWebhook(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle GitHub webhook events
         * @param {object} body GithubWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleGithubTasksWebhook(body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.handleGithubTasksWebhook(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle Notion webhook events
         * @param {object} body NotionWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleNotionTasksWebhook(body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.handleNotionTasksWebhook(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle Todoist webhook events
         * @param {object} body TodoistWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleTodoistTasksWebhook(body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.handleTodoistTasksWebhook(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle Trello webhook events
         * @param {object} body TrelloWebhookEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleTrelloTasksWebhook(body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.handleTrelloTasksWebhook(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move a todo task between projects
         * @param {string} userId 
         * @param {MoveTodoTaskBetweenProjectsReq} moveTodoTaskBetweenProjectsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTodoTaskBetweenProjects(userId: string, moveTodoTaskBetweenProjectsReq: MoveTodoTaskBetweenProjectsReq, options?: RawAxiosRequestConfig): AxiosPromise<MoveTodoTaskBetweenProjectsRes> {
            return localVarFp.moveTodoTaskBetweenProjects(userId, moveTodoTaskBetweenProjectsReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search tasks by query string
         * @param {string} query Search query string to match against task name (title)
         * @param {number} [limit] Maximum number of tasks to return. default is 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTasks(query: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.searchTasks(query, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set a project visibility
         * @param {string} boardId 
         * @param {boolean} closed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTodoProjectVisibility(boardId: string, closed: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.setTodoProjectVisibility(boardId, closed, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Subscribe ClickUp board webhook
         * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeClickUpBoardWebhook(todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options?: RawAxiosRequestConfig): AxiosPromise<TodoTasksWebhookSubscribeRes> {
            return localVarFp.subscribeClickUpBoardWebhook(todoTasksWebhookSubscribeReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Subscribe GitHub board webhook
         * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeGithubBoardWebhook(todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options?: RawAxiosRequestConfig): AxiosPromise<TodoTasksWebhookSubscribeRes> {
            return localVarFp.subscribeGithubBoardWebhook(todoTasksWebhookSubscribeReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Subscribe Trello board webhook
         * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeTrelloBoardWebhook(todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options?: RawAxiosRequestConfig): AxiosPromise<TodoTasksWebhookSubscribeRes> {
            return localVarFp.subscribeTrelloBoardWebhook(todoTasksWebhookSubscribeReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Apple Reminders as tasks
         * @param {AppleRemindersSyncReq} appleRemindersSyncReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAppleReminders(appleRemindersSyncReq: AppleRemindersSyncReq, options?: RawAxiosRequestConfig): AxiosPromise<SyncAppleReminderRes> {
            return localVarFp.syncAppleReminders(appleRemindersSyncReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync ClickUp tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncClickUpTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): AxiosPromise<TaskSyncProviderRes> {
            return localVarFp.syncClickUpTasks(taskSyncProviderReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync GitHub tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGitHubTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): AxiosPromise<TaskSyncProviderRes> {
            return localVarFp.syncGitHubTasks(taskSyncProviderReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Google Tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGoogleTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): AxiosPromise<TaskSyncProviderRes> {
            return localVarFp.syncGoogleTasks(taskSyncProviderReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Notion tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncNotionTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): AxiosPromise<TaskSyncProviderRes> {
            return localVarFp.syncNotionTasks(taskSyncProviderReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync TickTick tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTickTickTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): AxiosPromise<TaskSyncProviderRes> {
            return localVarFp.syncTickTickTasks(taskSyncProviderReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync all projects
         * @param {string} userId 
         * @param {SyncTodoProjectsReq} [syncTodoProjectsReq] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTodoProjects(userId: string, syncTodoProjectsReq?: SyncTodoProjectsReq, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.syncTodoProjects(userId, syncTodoProjectsReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Todoist tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTodoistTasksV3(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): AxiosPromise<TaskSyncProviderRes> {
            return localVarFp.syncTodoistTasksV3(taskSyncProviderReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Trello tasks for a user
         * @param {TaskSyncProviderReq} taskSyncProviderReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTrelloTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig): AxiosPromise<TaskSyncProviderRes> {
            return localVarFp.syncTrelloTasks(taskSyncProviderReq, options).then((request) => request(axios, basePath));
        },
        /**
         * For recurring tasks, returns the calculated next occurrence date (without time).
         * @summary Update a complete status of a task
         * @param {string} taskId 
         * @param {string} boardId 
         * @param {string} userId 
         * @param {boolean} completed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompleteStatusOfTask(taskId: string, boardId: string, userId: string, completed: boolean, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCompleteStatusRes> {
            return localVarFp.updateCompleteStatusOfTask(taskId, boardId, userId, completed, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a label
         * @param {string} taskLabelGroupId 
         * @param {string} taskLabelId 
         * @param {object} body Partial&lt;TaskLabel&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskLabel(taskLabelGroupId: string, taskLabelId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<TaskIdRes> {
            return localVarFp.updateTaskLabel(taskLabelGroupId, taskLabelId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update task preferences
         * @param {string} preferenceId 
         * @param {object} body Partial&lt;TaskPreference&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<SuccessRes> {
            return localVarFp.updateTaskPreference(preferenceId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a todo task
         * @param {string} taskId 
         * @param {string} boardId 
         * @param {string} userId 
         * @param {object} body Partial&lt;FirestoreTaskItem&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodoTask(taskId: string, boardId: string, userId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<TaskIdRes> {
            return localVarFp.updateTodoTask(taskId, boardId, userId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI {
    /**
     * 
     * @summary Add a new project
     * @param {string} userId 
     * @param {object} body AddTodotaskBoardProps
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public addTodoProject(userId: string, body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).addTodoProject(userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a todo task
     * @param {string} boardId 
     * @param {string} userId 
     * @param {object} body AddTaskItemProps
     * @param {string} [taskId] Optional taskId to use for the task
     * @param {string} [originalTaskId] Optional originalTaskId to use for the task (required for apple-reminders)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public addTodoTask(boardId: string, userId: string, body: object, taskId?: string, originalTaskId?: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).addTodoTask(boardId, userId, body, taskId, originalTaskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a label
     * @param {string} taskLabelGroupId 
     * @param {object} body Partial&lt;TaskLabel&gt; (name required)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public createTaskLabel(taskLabelGroupId: string, body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).createTaskLabel(taskLabelGroupId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks the task label as deleted by setting the `delete` flag to true.
     * @summary Delete a custom label
     * @param {string} taskLabelGroupId 
     * @param {string} taskLabelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public deleteTaskLabel(taskLabelGroupId: string, taskLabelId: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).deleteTaskLabel(taskLabelGroupId, taskLabelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a project from both Lifestack and the external provider (Todoist, TickTick, Trello, Notion).
     * @summary Delete a project
     * @param {string} userId 
     * @param {string} boardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public deleteTodoProject(userId: string, boardId: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).deleteTodoProject(userId, boardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a todo task
     * @param {string} taskId 
     * @param {string} boardId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public deleteTodoTask(taskId: string, boardId: string, userId: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).deleteTodoTask(taskId, boardId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all labels
     * @param {string} taskLabelsGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getAllTaskLabels(taskLabelsGroupId: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getAllTaskLabels(taskLabelsGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get daily tasks trend
     * @param {string} dataTrendId 
     * @param {string} date YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getDailyTasksTrend(dataTrendId: string, date: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getDailyTasksTrend(dataTrendId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch overdue tasks by the selected date. So, if you pass 2024-09-30, it will return overdue(not completed) tasks until 2024-09-30.
     * @summary Get all overdue todo tasks
     * @param {Array<string>} todoTasksBoardIds 
     * @param {string} dueDateTill YYYY-MM-DD
     * @param {string} [orderBy] dueDate
     * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
     * @param {boolean} [completed] 
     * @param {boolean} [onlyMyTask] 
     * @param {boolean} [hideNoDueDate] 
     * @param {number} [limit] Maximum number of tasks to return. default is 100
     * @param {boolean} [includeSubtasks] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getOverdueTodoTasks(todoTasksBoardIds: Array<string>, dueDateTill: string, orderBy?: string, labelNames?: string, completed?: boolean, onlyMyTask?: boolean, hideNoDueDate?: boolean, limit?: number, includeSubtasks?: boolean, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getOverdueTodoTasks(todoTasksBoardIds, dueDateTill, orderBy, labelNames, completed, onlyMyTask, hideNoDueDate, limit, includeSubtasks, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get task preference
     * @param {string} preferenceId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getTaskPreference(preferenceId: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getTaskPreference(preferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all projects
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getTodoProjects(userId: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getTodoProjects(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all todo tasks
     * @param {Array<string>} todoTasksBoardIds 
     * @param {string} [dueDate] date - YYYY-MM-DD
     * @param {boolean} [onlyMyTask] 
     * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
     * @param {boolean} [completed] 
     * @param {boolean} [includeSubtasks] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getTodoTasks(todoTasksBoardIds: Array<string>, dueDate?: string, onlyMyTask?: boolean, labelNames?: string, completed?: boolean, includeSubtasks?: boolean, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getTodoTasks(todoTasksBoardIds, dueDate, onlyMyTask, labelNames, completed, includeSubtasks, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get overdue tasks from visible projects
     * @param {string} userId 
     * @param {string} dueDateTill YYYY-MM-DD
     * @param {string} [orderBy] dueDate
     * @param {string} [labelNames] Either \&#39;lifestack_all\&#39; or comma-separated label names (e.g., \&quot;label1,label2\&quot;)
     * @param {boolean} [completed] 
     * @param {boolean} [onlyMyTask] 
     * @param {boolean} [hideNoDueDate] 
     * @param {number} [limit] Maximum number of tasks to return. default is 100
     * @param {boolean} [includeSubtasks] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getVisibleOverdueTasks(userId: string, dueDateTill: string, orderBy?: string, labelNames?: string, completed?: boolean, onlyMyTask?: boolean, hideNoDueDate?: boolean, limit?: number, includeSubtasks?: boolean, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getVisibleOverdueTasks(userId, dueDateTill, orderBy, labelNames, completed, onlyMyTask, hideNoDueDate, limit, includeSubtasks, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get tasks from visible projects
     * @param {string} userId 
     * @param {string} dueDate YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getVisibleProjectTasks(userId: string, dueDate: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getVisibleProjectTasks(userId, dueDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get weekly tasks trend
     * @param {string} dataTrendId 
     * @param {string} startDate YYYY-MM-DD
     * @param {string} endDate YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getWeeklyTasksTrend(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getWeeklyTasksTrend(dataTrendId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get weekly tasks trend V2
     * @param {string} dataTrendId 
     * @param {string} startDate YYYY-MM-DD
     * @param {string} endDate YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getWeeklyTasksTrendV2(dataTrendId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getWeeklyTasksTrendV2(dataTrendId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle ClickUp webhook events
     * @param {object} body ClickUpWebhookEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public handleClickUpWebhook(body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).handleClickUpWebhook(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle GitHub webhook events
     * @param {object} body GithubWebhookEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public handleGithubTasksWebhook(body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).handleGithubTasksWebhook(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle Notion webhook events
     * @param {object} body NotionWebhookEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public handleNotionTasksWebhook(body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).handleNotionTasksWebhook(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle Todoist webhook events
     * @param {object} body TodoistWebhookEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public handleTodoistTasksWebhook(body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).handleTodoistTasksWebhook(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle Trello webhook events
     * @param {object} body TrelloWebhookEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public handleTrelloTasksWebhook(body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).handleTrelloTasksWebhook(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move a todo task between projects
     * @param {string} userId 
     * @param {MoveTodoTaskBetweenProjectsReq} moveTodoTaskBetweenProjectsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public moveTodoTaskBetweenProjects(userId: string, moveTodoTaskBetweenProjectsReq: MoveTodoTaskBetweenProjectsReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).moveTodoTaskBetweenProjects(userId, moveTodoTaskBetweenProjectsReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search tasks by query string
     * @param {string} query Search query string to match against task name (title)
     * @param {number} [limit] Maximum number of tasks to return. default is 100
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public searchTasks(query: string, limit?: number, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).searchTasks(query, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set a project visibility
     * @param {string} boardId 
     * @param {boolean} closed 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public setTodoProjectVisibility(boardId: string, closed: boolean, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).setTodoProjectVisibility(boardId, closed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Subscribe ClickUp board webhook
     * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public subscribeClickUpBoardWebhook(todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).subscribeClickUpBoardWebhook(todoTasksWebhookSubscribeReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Subscribe GitHub board webhook
     * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public subscribeGithubBoardWebhook(todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).subscribeGithubBoardWebhook(todoTasksWebhookSubscribeReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Subscribe Trello board webhook
     * @param {TodoTasksWebhookSubscribeReq} todoTasksWebhookSubscribeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public subscribeTrelloBoardWebhook(todoTasksWebhookSubscribeReq: TodoTasksWebhookSubscribeReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).subscribeTrelloBoardWebhook(todoTasksWebhookSubscribeReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Apple Reminders as tasks
     * @param {AppleRemindersSyncReq} appleRemindersSyncReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public syncAppleReminders(appleRemindersSyncReq: AppleRemindersSyncReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).syncAppleReminders(appleRemindersSyncReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync ClickUp tasks for a user
     * @param {TaskSyncProviderReq} taskSyncProviderReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public syncClickUpTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).syncClickUpTasks(taskSyncProviderReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync GitHub tasks for a user
     * @param {TaskSyncProviderReq} taskSyncProviderReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public syncGitHubTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).syncGitHubTasks(taskSyncProviderReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Google Tasks for a user
     * @param {TaskSyncProviderReq} taskSyncProviderReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public syncGoogleTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).syncGoogleTasks(taskSyncProviderReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Notion tasks for a user
     * @param {TaskSyncProviderReq} taskSyncProviderReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public syncNotionTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).syncNotionTasks(taskSyncProviderReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync TickTick tasks for a user
     * @param {TaskSyncProviderReq} taskSyncProviderReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public syncTickTickTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).syncTickTickTasks(taskSyncProviderReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync all projects
     * @param {string} userId 
     * @param {SyncTodoProjectsReq} [syncTodoProjectsReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public syncTodoProjects(userId: string, syncTodoProjectsReq?: SyncTodoProjectsReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).syncTodoProjects(userId, syncTodoProjectsReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Todoist tasks for a user
     * @param {TaskSyncProviderReq} taskSyncProviderReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public syncTodoistTasksV3(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).syncTodoistTasksV3(taskSyncProviderReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Trello tasks for a user
     * @param {TaskSyncProviderReq} taskSyncProviderReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public syncTrelloTasks(taskSyncProviderReq: TaskSyncProviderReq, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).syncTrelloTasks(taskSyncProviderReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For recurring tasks, returns the calculated next occurrence date (without time).
     * @summary Update a complete status of a task
     * @param {string} taskId 
     * @param {string} boardId 
     * @param {string} userId 
     * @param {boolean} completed 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public updateCompleteStatusOfTask(taskId: string, boardId: string, userId: string, completed: boolean, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).updateCompleteStatusOfTask(taskId, boardId, userId, completed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a label
     * @param {string} taskLabelGroupId 
     * @param {string} taskLabelId 
     * @param {object} body Partial&lt;TaskLabel&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public updateTaskLabel(taskLabelGroupId: string, taskLabelId: string, body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).updateTaskLabel(taskLabelGroupId, taskLabelId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update task preferences
     * @param {string} preferenceId 
     * @param {object} body Partial&lt;TaskPreference&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public updateTaskPreference(preferenceId: string, body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).updateTaskPreference(preferenceId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a todo task
     * @param {string} taskId 
     * @param {string} boardId 
     * @param {string} userId 
     * @param {object} body Partial&lt;FirestoreTaskItem&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public updateTodoTask(taskId: string, boardId: string, userId: string, body: object, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).updateTodoTask(taskId, boardId, userId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamApi - axios parameter creator
 * @export
 */
export const TeamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept a team invite
         * @param {TeamInviteAcceptReq} teamInviteAcceptReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTeamInvite: async (teamInviteAcceptReq: TeamInviteAcceptReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamInviteAcceptReq' is not null or undefined
            assertParamExists('acceptTeamInvite', 'teamInviteAcceptReq', teamInviteAcceptReq)
            const localVarPath = `/api/v1/teams/invites/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamInviteAcceptReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a Team board
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTeamBoard: async (teamId: string, boardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('archiveTeamBoard', 'teamId', teamId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('archiveTeamBoard', 'boardId', boardId)
            const localVarPath = `/api/v1/teams/{teamId}/boards/{boardId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a team
         * @param {TeamCreateReq} teamCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: async (teamCreateReq: TeamCreateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamCreateReq' is not null or undefined
            assertParamExists('createTeam', 'teamCreateReq', teamCreateReq)
            const localVarPath = `/api/v1/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamCreateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Team board
         * @param {string} teamId 
         * @param {TeamBoardCreateReq} teamBoardCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamBoard: async (teamId: string, teamBoardCreateReq: TeamBoardCreateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createTeamBoard', 'teamId', teamId)
            // verify required parameter 'teamBoardCreateReq' is not null or undefined
            assertParamExists('createTeamBoard', 'teamBoardCreateReq', teamBoardCreateReq)
            const localVarPath = `/api/v1/teams/{teamId}/boards`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamBoardCreateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or resend a team invite
         * @param {string} teamId 
         * @param {TeamInviteCreateReq} teamInviteCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamInvite: async (teamId: string, teamInviteCreateReq: TeamInviteCreateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createTeamInvite', 'teamId', teamId)
            // verify required parameter 'teamInviteCreateReq' is not null or undefined
            assertParamExists('createTeamInvite', 'teamInviteCreateReq', teamInviteCreateReq)
            const localVarPath = `/api/v1/teams/{teamId}/invites`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamInviteCreateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {TeamTaskCreateReq} teamTaskCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamTask: async (teamId: string, boardId: string, teamTaskCreateReq: TeamTaskCreateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createTeamTask', 'teamId', teamId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('createTeamTask', 'boardId', boardId)
            // verify required parameter 'teamTaskCreateReq' is not null or undefined
            assertParamExists('createTeamTask', 'teamTaskCreateReq', teamTaskCreateReq)
            const localVarPath = `/api/v1/teams/{teamId}/boards/{boardId}/tasks`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamTaskCreateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeam', 'teamId', teamId)
            const localVarPath = `/api/v1/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft delete a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamTask: async (teamId: string, boardId: string, taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeamTask', 'teamId', teamId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('deleteTeamTask', 'boardId', boardId)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('deleteTeamTask', 'taskId', taskId)
            const localVarPath = `/api/v1/teams/{teamId}/boards/{boardId}/tasks/{taskId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Team-board tasks assigned to the authenticated user across teams for a date range
         * @param {string} startDate Range start in YYYY-MM-DD format
         * @param {string} endDate Range end in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedTeamTasksRange: async (startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getAssignedTeamTasksRange', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getAssignedTeamTasksRange', 'endDate', endDate)
            const localVarPath = `/api/v1/teams/tasks/assigned-to-me/range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one team for the authenticated user
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeam', 'teamId', teamId)
            const localVarPath = `/api/v1/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Team-board task view data
         * @param {string} teamId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamBoardTasks: async (teamId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamBoardTasks', 'teamId', teamId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getTeamBoardTasks', 'date', date)
            const localVarPath = `/api/v1/teams/{teamId}/board-tasks`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get team day view data
         * @param {string} teamId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {boolean} [includeEnergy] Whether to include energy phases. Defaults to false.
         * @param {string} [xTimeZone] Viewer timezone used to resolve the selected day window
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDay: async (teamId: string, date: string, includeEnergy?: boolean, xTimeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamDay', 'teamId', teamId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getTeamDay', 'date', date)
            const localVarPath = `/api/v1/teams/{teamId}/day`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (includeEnergy !== undefined) {
                localVarQueryParameter['includeEnergy'] = includeEnergy;
            }

            if (xTimeZone != null) {
                localVarHeaderParameter['x-time-zone'] = String(xTimeZone);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve a team invite by code
         * @param {string} inviteCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInvite: async (inviteCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteCode' is not null or undefined
            assertParamExists('getTeamInvite', 'inviteCode', inviteCode)
            const localVarPath = `/api/v1/teams/invites/{inviteCode}`
                .replace(`{${"inviteCode"}}`, encodeURIComponent(String(inviteCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get invites for a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInvites: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamInvites', 'teamId', teamId)
            const localVarPath = `/api/v1/teams/{teamId}/invites`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get shared teammate task view data
         * @param {string} teamId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamTasks: async (teamId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamTasks', 'teamId', teamId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getTeamTasks', 'date', date)
            const localVarPath = `/api/v1/teams/{teamId}/tasks`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get teams for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leave a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveTeam: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('leaveTeam', 'teamId', teamId)
            const localVarPath = `/api/v1/teams/{teamId}/leave`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a team member
         * @param {string} teamId 
         * @param {string} memberUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTeamMember: async (teamId: string, memberUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('removeTeamMember', 'teamId', teamId)
            // verify required parameter 'memberUserId' is not null or undefined
            assertParamExists('removeTeamMember', 'memberUserId', memberUserId)
            const localVarPath = `/api/v1/teams/{teamId}/members/{memberUserId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"memberUserId"}}`, encodeURIComponent(String(memberUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke a pending team invite
         * @param {string} teamId 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTeamInvite: async (teamId: string, inviteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('revokeTeamInvite', 'teamId', teamId)
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('revokeTeamInvite', 'inviteId', inviteId)
            const localVarPath = `/api/v1/teams/{teamId}/invites/{inviteId}/revoke`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Transfer team ownership
         * @param {string} teamId 
         * @param {TeamOwnershipTransferReq} teamOwnershipTransferReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferTeamOwnership: async (teamId: string, teamOwnershipTransferReq: TeamOwnershipTransferReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('transferTeamOwnership', 'teamId', teamId)
            // verify required parameter 'teamOwnershipTransferReq' is not null or undefined
            assertParamExists('transferTeamOwnership', 'teamOwnershipTransferReq', teamOwnershipTransferReq)
            const localVarPath = `/api/v1/teams/{teamId}/transfer-ownership`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamOwnershipTransferReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle complete status for a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {boolean} completed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompleteStatusOfTeamTask: async (teamId: string, boardId: string, taskId: string, completed: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateCompleteStatusOfTeamTask', 'teamId', teamId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateCompleteStatusOfTeamTask', 'boardId', boardId)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateCompleteStatusOfTeamTask', 'taskId', taskId)
            // verify required parameter 'completed' is not null or undefined
            assertParamExists('updateCompleteStatusOfTeamTask', 'completed', completed)
            const localVarPath = `/api/v1/teams/{teamId}/boards/{boardId}/tasks/{taskId}/complete`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (completed !== undefined) {
                localVarQueryParameter['completed'] = completed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename a team
         * @param {string} teamId 
         * @param {TeamUpdateReq} teamUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: async (teamId: string, teamUpdateReq: TeamUpdateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeam', 'teamId', teamId)
            // verify required parameter 'teamUpdateReq' is not null or undefined
            assertParamExists('updateTeam', 'teamUpdateReq', teamUpdateReq)
            const localVarPath = `/api/v1/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamUpdateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Team board
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {TeamBoardUpdateReq} teamBoardUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamBoard: async (teamId: string, boardId: string, teamBoardUpdateReq: TeamBoardUpdateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamBoard', 'teamId', teamId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateTeamBoard', 'boardId', boardId)
            // verify required parameter 'teamBoardUpdateReq' is not null or undefined
            assertParamExists('updateTeamBoard', 'teamBoardUpdateReq', teamBoardUpdateReq)
            const localVarPath = `/api/v1/teams/{teamId}/boards/{boardId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamBoardUpdateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change a team member role
         * @param {string} teamId 
         * @param {string} memberUserId 
         * @param {TeamMemberRoleUpdateReq} teamMemberRoleUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberRole: async (teamId: string, memberUserId: string, teamMemberRoleUpdateReq: TeamMemberRoleUpdateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamMemberRole', 'teamId', teamId)
            // verify required parameter 'memberUserId' is not null or undefined
            assertParamExists('updateTeamMemberRole', 'memberUserId', memberUserId)
            // verify required parameter 'teamMemberRoleUpdateReq' is not null or undefined
            assertParamExists('updateTeamMemberRole', 'teamMemberRoleUpdateReq', teamMemberRoleUpdateReq)
            const localVarPath = `/api/v1/teams/{teamId}/members/{memberUserId}/role`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"memberUserId"}}`, encodeURIComponent(String(memberUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberRoleUpdateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update share settings for the authenticated user
         * @param {string} teamId 
         * @param {TeamShareSettingsUpdateReq} teamShareSettingsUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamShareSettings: async (teamId: string, teamShareSettingsUpdateReq: TeamShareSettingsUpdateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamShareSettings', 'teamId', teamId)
            // verify required parameter 'teamShareSettingsUpdateReq' is not null or undefined
            assertParamExists('updateTeamShareSettings', 'teamShareSettingsUpdateReq', teamShareSettingsUpdateReq)
            const localVarPath = `/api/v1/teams/{teamId}/share-settings`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamShareSettingsUpdateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {TeamTaskUpdateReq} teamTaskUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamTask: async (teamId: string, boardId: string, taskId: string, teamTaskUpdateReq: TeamTaskUpdateReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamTask', 'teamId', teamId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateTeamTask', 'boardId', boardId)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateTeamTask', 'taskId', taskId)
            // verify required parameter 'teamTaskUpdateReq' is not null or undefined
            assertParamExists('updateTeamTask', 'teamTaskUpdateReq', teamTaskUpdateReq)
            const localVarPath = `/api/v1/teams/{teamId}/boards/{boardId}/tasks/{taskId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamTaskUpdateReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign, reassign, or unassign a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {TeamTaskAssignmentReq} teamTaskAssignmentReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamTaskAssignment: async (teamId: string, boardId: string, taskId: string, teamTaskAssignmentReq: TeamTaskAssignmentReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamTaskAssignment', 'teamId', teamId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateTeamTaskAssignment', 'boardId', boardId)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateTeamTaskAssignment', 'taskId', taskId)
            // verify required parameter 'teamTaskAssignmentReq' is not null or undefined
            assertParamExists('updateTeamTaskAssignment', 'teamTaskAssignmentReq', teamTaskAssignmentReq)
            const localVarPath = `/api/v1/teams/{teamId}/boards/{boardId}/tasks/{taskId}/assignment`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamTaskAssignmentReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamApi - functional programming interface
 * @export
 */
export const TeamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept a team invite
         * @param {TeamInviteAcceptReq} teamInviteAcceptReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTeamInvite(teamInviteAcceptReq: TeamInviteAcceptReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamInviteAcceptRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTeamInvite(teamInviteAcceptReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.acceptTeamInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a Team board
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveTeamBoard(teamId: string, boardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamBoardArchiveRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveTeamBoard(teamId, boardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.archiveTeamBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a team
         * @param {TeamCreateReq} teamCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeam(teamCreateReq: TeamCreateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamCreateRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeam(teamCreateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Team board
         * @param {string} teamId 
         * @param {TeamBoardCreateReq} teamBoardCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamBoard(teamId: string, teamBoardCreateReq: TeamBoardCreateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamBoardCreateRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamBoard(teamId, teamBoardCreateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createTeamBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create or resend a team invite
         * @param {string} teamId 
         * @param {TeamInviteCreateReq} teamInviteCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamInvite(teamId: string, teamInviteCreateReq: TeamInviteCreateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamInviteCreateRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamInvite(teamId, teamInviteCreateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createTeamInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {TeamTaskCreateReq} teamTaskCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamTask(teamId: string, boardId: string, teamTaskCreateReq: TeamTaskCreateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamTaskMutationRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamTask(teamId, boardId, teamTaskCreateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createTeamTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeam(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamDeleteRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeam(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.deleteTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Soft delete a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamTask(teamId: string, boardId: string, taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamTaskDeleteRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamTask(teamId, boardId, taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.deleteTeamTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Team-board tasks assigned to the authenticated user across teams for a date range
         * @param {string} startDate Range start in YYYY-MM-DD format
         * @param {string} endDate Range end in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssignedTeamTasksRange(startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamAssignedTasksRangeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignedTeamTasksRange(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getAssignedTeamTasksRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get one team for the authenticated user
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeam(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamGetRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeam(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Team-board task view data
         * @param {string} teamId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamBoardTasks(teamId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamTasksRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamBoardTasks(teamId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamBoardTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get team day view data
         * @param {string} teamId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {boolean} [includeEnergy] Whether to include energy phases. Defaults to false.
         * @param {string} [xTimeZone] Viewer timezone used to resolve the selected day window
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamDay(teamId: string, date: string, includeEnergy?: boolean, xTimeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamDayRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamDay(teamId, date, includeEnergy, xTimeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamDay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resolve a team invite by code
         * @param {string} inviteCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamInvite(inviteCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamInviteResolveRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamInvite(inviteCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get invites for a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamInvites(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamInvitesListRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamInvites(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get shared teammate task view data
         * @param {string} teamId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamTasks(teamId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamTasksRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamTasks(teamId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get teams for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeams(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamListRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeams(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Leave a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveTeam(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamLeaveRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveTeam(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.leaveTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a team member
         * @param {string} teamId 
         * @param {string} memberUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTeamMember(teamId: string, memberUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberRemoveRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTeamMember(teamId, memberUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.removeTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke a pending team invite
         * @param {string} teamId 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeTeamInvite(teamId: string, inviteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamInviteRevokeRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeTeamInvite(teamId, inviteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.revokeTeamInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Transfer team ownership
         * @param {string} teamId 
         * @param {TeamOwnershipTransferReq} teamOwnershipTransferReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferTeamOwnership(teamId: string, teamOwnershipTransferReq: TeamOwnershipTransferReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamOwnershipTransferRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferTeamOwnership(teamId, teamOwnershipTransferReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.transferTeamOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle complete status for a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {boolean} completed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompleteStatusOfTeamTask(teamId: string, boardId: string, taskId: string, completed: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamTaskMutationRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompleteStatusOfTeamTask(teamId, boardId, taskId, completed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateCompleteStatusOfTeamTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rename a team
         * @param {string} teamId 
         * @param {TeamUpdateReq} teamUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeam(teamId: string, teamUpdateReq: TeamUpdateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamUpdateRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeam(teamId, teamUpdateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a Team board
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {TeamBoardUpdateReq} teamBoardUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamBoard(teamId: string, boardId: string, teamBoardUpdateReq: TeamBoardUpdateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamBoardUpdateRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamBoard(teamId, boardId, teamBoardUpdateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change a team member role
         * @param {string} teamId 
         * @param {string} memberUserId 
         * @param {TeamMemberRoleUpdateReq} teamMemberRoleUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamMemberRole(teamId: string, memberUserId: string, teamMemberRoleUpdateReq: TeamMemberRoleUpdateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberRoleUpdateRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamMemberRole(teamId, memberUserId, teamMemberRoleUpdateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamMemberRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update share settings for the authenticated user
         * @param {string} teamId 
         * @param {TeamShareSettingsUpdateReq} teamShareSettingsUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamShareSettings(teamId: string, teamShareSettingsUpdateReq: TeamShareSettingsUpdateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamShareSettingsUpdateRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamShareSettings(teamId, teamShareSettingsUpdateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamShareSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {TeamTaskUpdateReq} teamTaskUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamTask(teamId: string, boardId: string, taskId: string, teamTaskUpdateReq: TeamTaskUpdateReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamTaskMutationRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamTask(teamId, boardId, taskId, teamTaskUpdateReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assign, reassign, or unassign a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {TeamTaskAssignmentReq} teamTaskAssignmentReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamTaskAssignment(teamId: string, boardId: string, taskId: string, teamTaskAssignmentReq: TeamTaskAssignmentReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamTaskMutationRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamTaskAssignment(teamId, boardId, taskId, teamTaskAssignmentReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamTaskAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamApi - factory interface
 * @export
 */
export const TeamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept a team invite
         * @param {TeamInviteAcceptReq} teamInviteAcceptReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTeamInvite(teamInviteAcceptReq: TeamInviteAcceptReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamInviteAcceptRes> {
            return localVarFp.acceptTeamInvite(teamInviteAcceptReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a Team board
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTeamBoard(teamId: string, boardId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamBoardArchiveRes> {
            return localVarFp.archiveTeamBoard(teamId, boardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a team
         * @param {TeamCreateReq} teamCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam(teamCreateReq: TeamCreateReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamCreateRes> {
            return localVarFp.createTeam(teamCreateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Team board
         * @param {string} teamId 
         * @param {TeamBoardCreateReq} teamBoardCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamBoard(teamId: string, teamBoardCreateReq: TeamBoardCreateReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamBoardCreateRes> {
            return localVarFp.createTeamBoard(teamId, teamBoardCreateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or resend a team invite
         * @param {string} teamId 
         * @param {TeamInviteCreateReq} teamInviteCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamInvite(teamId: string, teamInviteCreateReq: TeamInviteCreateReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamInviteCreateRes> {
            return localVarFp.createTeamInvite(teamId, teamInviteCreateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {TeamTaskCreateReq} teamTaskCreateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamTask(teamId: string, boardId: string, teamTaskCreateReq: TeamTaskCreateReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamTaskMutationRes> {
            return localVarFp.createTeamTask(teamId, boardId, teamTaskCreateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam(teamId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamDeleteRes> {
            return localVarFp.deleteTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft delete a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamTask(teamId: string, boardId: string, taskId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamTaskDeleteRes> {
            return localVarFp.deleteTeamTask(teamId, boardId, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Team-board tasks assigned to the authenticated user across teams for a date range
         * @param {string} startDate Range start in YYYY-MM-DD format
         * @param {string} endDate Range end in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedTeamTasksRange(startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamAssignedTasksRangeRes> {
            return localVarFp.getAssignedTeamTasksRange(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one team for the authenticated user
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam(teamId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamGetRes> {
            return localVarFp.getTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Team-board task view data
         * @param {string} teamId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamBoardTasks(teamId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamTasksRes> {
            return localVarFp.getTeamBoardTasks(teamId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get team day view data
         * @param {string} teamId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {boolean} [includeEnergy] Whether to include energy phases. Defaults to false.
         * @param {string} [xTimeZone] Viewer timezone used to resolve the selected day window
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDay(teamId: string, date: string, includeEnergy?: boolean, xTimeZone?: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamDayRes> {
            return localVarFp.getTeamDay(teamId, date, includeEnergy, xTimeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve a team invite by code
         * @param {string} inviteCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInvite(inviteCode: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamInviteResolveRes> {
            return localVarFp.getTeamInvite(inviteCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get invites for a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInvites(teamId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamInvitesListRes> {
            return localVarFp.getTeamInvites(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get shared teammate task view data
         * @param {string} teamId 
         * @param {string} date Day in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamTasks(teamId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamTasksRes> {
            return localVarFp.getTeamTasks(teamId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get teams for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams(options?: RawAxiosRequestConfig): AxiosPromise<TeamListRes> {
            return localVarFp.getTeams(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leave a team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveTeam(teamId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamLeaveRes> {
            return localVarFp.leaveTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a team member
         * @param {string} teamId 
         * @param {string} memberUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTeamMember(teamId: string, memberUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberRemoveRes> {
            return localVarFp.removeTeamMember(teamId, memberUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke a pending team invite
         * @param {string} teamId 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTeamInvite(teamId: string, inviteId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamInviteRevokeRes> {
            return localVarFp.revokeTeamInvite(teamId, inviteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Transfer team ownership
         * @param {string} teamId 
         * @param {TeamOwnershipTransferReq} teamOwnershipTransferReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferTeamOwnership(teamId: string, teamOwnershipTransferReq: TeamOwnershipTransferReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamOwnershipTransferRes> {
            return localVarFp.transferTeamOwnership(teamId, teamOwnershipTransferReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle complete status for a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {boolean} completed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompleteStatusOfTeamTask(teamId: string, boardId: string, taskId: string, completed: boolean, options?: RawAxiosRequestConfig): AxiosPromise<TeamTaskMutationRes> {
            return localVarFp.updateCompleteStatusOfTeamTask(teamId, boardId, taskId, completed, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename a team
         * @param {string} teamId 
         * @param {TeamUpdateReq} teamUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(teamId: string, teamUpdateReq: TeamUpdateReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamUpdateRes> {
            return localVarFp.updateTeam(teamId, teamUpdateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Team board
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {TeamBoardUpdateReq} teamBoardUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamBoard(teamId: string, boardId: string, teamBoardUpdateReq: TeamBoardUpdateReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamBoardUpdateRes> {
            return localVarFp.updateTeamBoard(teamId, boardId, teamBoardUpdateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change a team member role
         * @param {string} teamId 
         * @param {string} memberUserId 
         * @param {TeamMemberRoleUpdateReq} teamMemberRoleUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberRole(teamId: string, memberUserId: string, teamMemberRoleUpdateReq: TeamMemberRoleUpdateReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberRoleUpdateRes> {
            return localVarFp.updateTeamMemberRole(teamId, memberUserId, teamMemberRoleUpdateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update share settings for the authenticated user
         * @param {string} teamId 
         * @param {TeamShareSettingsUpdateReq} teamShareSettingsUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamShareSettings(teamId: string, teamShareSettingsUpdateReq: TeamShareSettingsUpdateReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamShareSettingsUpdateRes> {
            return localVarFp.updateTeamShareSettings(teamId, teamShareSettingsUpdateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {TeamTaskUpdateReq} teamTaskUpdateReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamTask(teamId: string, boardId: string, taskId: string, teamTaskUpdateReq: TeamTaskUpdateReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamTaskMutationRes> {
            return localVarFp.updateTeamTask(teamId, boardId, taskId, teamTaskUpdateReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign, reassign, or unassign a Team-board task
         * @param {string} teamId 
         * @param {string} boardId 
         * @param {string} taskId 
         * @param {TeamTaskAssignmentReq} teamTaskAssignmentReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamTaskAssignment(teamId: string, boardId: string, taskId: string, teamTaskAssignmentReq: TeamTaskAssignmentReq, options?: RawAxiosRequestConfig): AxiosPromise<TeamTaskMutationRes> {
            return localVarFp.updateTeamTaskAssignment(teamId, boardId, taskId, teamTaskAssignmentReq, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamApi - object-oriented interface
 * @export
 * @class TeamApi
 * @extends {BaseAPI}
 */
export class TeamApi extends BaseAPI {
    /**
     * 
     * @summary Accept a team invite
     * @param {TeamInviteAcceptReq} teamInviteAcceptReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public acceptTeamInvite(teamInviteAcceptReq: TeamInviteAcceptReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).acceptTeamInvite(teamInviteAcceptReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a Team board
     * @param {string} teamId 
     * @param {string} boardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public archiveTeamBoard(teamId: string, boardId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).archiveTeamBoard(teamId, boardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a team
     * @param {TeamCreateReq} teamCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createTeam(teamCreateReq: TeamCreateReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createTeam(teamCreateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Team board
     * @param {string} teamId 
     * @param {TeamBoardCreateReq} teamBoardCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createTeamBoard(teamId: string, teamBoardCreateReq: TeamBoardCreateReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createTeamBoard(teamId, teamBoardCreateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or resend a team invite
     * @param {string} teamId 
     * @param {TeamInviteCreateReq} teamInviteCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createTeamInvite(teamId: string, teamInviteCreateReq: TeamInviteCreateReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createTeamInvite(teamId, teamInviteCreateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Team-board task
     * @param {string} teamId 
     * @param {string} boardId 
     * @param {TeamTaskCreateReq} teamTaskCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createTeamTask(teamId: string, boardId: string, teamTaskCreateReq: TeamTaskCreateReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createTeamTask(teamId, boardId, teamTaskCreateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a team
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public deleteTeam(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).deleteTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft delete a Team-board task
     * @param {string} teamId 
     * @param {string} boardId 
     * @param {string} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public deleteTeamTask(teamId: string, boardId: string, taskId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).deleteTeamTask(teamId, boardId, taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Team-board tasks assigned to the authenticated user across teams for a date range
     * @param {string} startDate Range start in YYYY-MM-DD format
     * @param {string} endDate Range end in YYYY-MM-DD format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getAssignedTeamTasksRange(startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getAssignedTeamTasksRange(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one team for the authenticated user
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeam(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Team-board task view data
     * @param {string} teamId 
     * @param {string} date Day in YYYY-MM-DD format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamBoardTasks(teamId: string, date: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamBoardTasks(teamId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get team day view data
     * @param {string} teamId 
     * @param {string} date Day in YYYY-MM-DD format
     * @param {boolean} [includeEnergy] Whether to include energy phases. Defaults to false.
     * @param {string} [xTimeZone] Viewer timezone used to resolve the selected day window
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamDay(teamId: string, date: string, includeEnergy?: boolean, xTimeZone?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamDay(teamId, date, includeEnergy, xTimeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve a team invite by code
     * @param {string} inviteCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamInvite(inviteCode: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamInvite(inviteCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get invites for a team
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamInvites(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamInvites(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get shared teammate task view data
     * @param {string} teamId 
     * @param {string} date Day in YYYY-MM-DD format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamTasks(teamId: string, date: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamTasks(teamId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get teams for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeams(options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeams(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leave a team
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public leaveTeam(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).leaveTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a team member
     * @param {string} teamId 
     * @param {string} memberUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public removeTeamMember(teamId: string, memberUserId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).removeTeamMember(teamId, memberUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke a pending team invite
     * @param {string} teamId 
     * @param {string} inviteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public revokeTeamInvite(teamId: string, inviteId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).revokeTeamInvite(teamId, inviteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Transfer team ownership
     * @param {string} teamId 
     * @param {TeamOwnershipTransferReq} teamOwnershipTransferReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public transferTeamOwnership(teamId: string, teamOwnershipTransferReq: TeamOwnershipTransferReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).transferTeamOwnership(teamId, teamOwnershipTransferReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle complete status for a Team-board task
     * @param {string} teamId 
     * @param {string} boardId 
     * @param {string} taskId 
     * @param {boolean} completed 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateCompleteStatusOfTeamTask(teamId: string, boardId: string, taskId: string, completed: boolean, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateCompleteStatusOfTeamTask(teamId, boardId, taskId, completed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename a team
     * @param {string} teamId 
     * @param {TeamUpdateReq} teamUpdateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeam(teamId: string, teamUpdateReq: TeamUpdateReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeam(teamId, teamUpdateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Team board
     * @param {string} teamId 
     * @param {string} boardId 
     * @param {TeamBoardUpdateReq} teamBoardUpdateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamBoard(teamId: string, boardId: string, teamBoardUpdateReq: TeamBoardUpdateReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamBoard(teamId, boardId, teamBoardUpdateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change a team member role
     * @param {string} teamId 
     * @param {string} memberUserId 
     * @param {TeamMemberRoleUpdateReq} teamMemberRoleUpdateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamMemberRole(teamId: string, memberUserId: string, teamMemberRoleUpdateReq: TeamMemberRoleUpdateReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamMemberRole(teamId, memberUserId, teamMemberRoleUpdateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update share settings for the authenticated user
     * @param {string} teamId 
     * @param {TeamShareSettingsUpdateReq} teamShareSettingsUpdateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamShareSettings(teamId: string, teamShareSettingsUpdateReq: TeamShareSettingsUpdateReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamShareSettings(teamId, teamShareSettingsUpdateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Team-board task
     * @param {string} teamId 
     * @param {string} boardId 
     * @param {string} taskId 
     * @param {TeamTaskUpdateReq} teamTaskUpdateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamTask(teamId: string, boardId: string, taskId: string, teamTaskUpdateReq: TeamTaskUpdateReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamTask(teamId, boardId, taskId, teamTaskUpdateReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign, reassign, or unassign a Team-board task
     * @param {string} teamId 
     * @param {string} boardId 
     * @param {string} taskId 
     * @param {TeamTaskAssignmentReq} teamTaskAssignmentReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamTaskAssignment(teamId: string, boardId: string, taskId: string, teamTaskAssignmentReq: TeamTaskAssignmentReq, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamTaskAssignment(teamId, boardId, taskId, teamTaskAssignmentReq, options).then((request) => request(this.axios, this.basePath));
    }
}



